
jQuery(document).ready(function () {
	/* Disena tu cama Landing Page */
	var listado_productos = [

		{
			id: 1,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: '80-90 cm',
			sku: null,
			precio: null,
			premium: null,
			cat: 'cama',
			modo: 'square',
			clase: 'square',
			capa: 'bajera',
			imagen: 'Bco_Individual_Base.png'
		},
		{
			id: 2,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: '135-140 cm',
			sku: null,
			precio: null,
			premium: null,
			cat: 'cama',
			modo: 'square',
			clase: 'square',
			capa: 'bajera',
			imagen: 'Bco_Doble_Base.png'
		},
		{
			id: 3,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: '150-160 cm',
			sku: null,
			precio: null,
			premium: null,
			cat: 'cama',
			modo: 'square',
			clase: 'square',
			capa: 'bajera',
			imagen: 'Bco_Doble_Base.png'
		},
		{
			id: 4,
			parentid: 4,
			subparentid: null,
			defecto: true,
			nombre: '180-200 cm',
			sku: null,
			precio: null,
			premium: null,
			cat: 'cama',
			modo: 'square',
			clase: 'square',
			capa: 'bajera',
			imagen: 'Bco_Doble_Base.png'
		},

		{
			id: 5,
			parentid: 1,
			subparentid: null,
			defecto: true,
			nombre: 'Bajera ajustable algodón orgánico Blanco',
			sku: 'besto/90x200/bco',
			precio: 27,
			premium: 19.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'bco',
			capa: 'bajera',
			imagen: 'Bco_Individual_Base.png'
		},

		{
			id: 1008,
			parentid: 1,
			subparentid: null,
			defecto: true,
			nombre: 'Bajera ajustable algodón orgánico Verde Oscuro',
			sku: 'BESTO/90X200/VOS',
			precio: 23,
			premium: 20.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'gre',
			capa: 'bajera',
			imagen: 'Dark_Green_Individual_Base.png'
		},


		{
			id: 1500,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Bajera ajustable algodón orgánico Lila Claro',
			sku: 'BESTO/90X200/LIC',
			precio: 28,
			premium: 24.99,
			cat: 'bajera',
			modo: 'color',
			clase: 'lic',
			capa: 'bajera',
			imagen: 'Lic_Individual_Base.png'
		},

		{
			id: 6,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Bajera ajustable algodón orgánico Aqua',
			sku: 'besto/90x200/aqu',
			precio: 27,
			premium: 19.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'aqu',
			capa: 'bajera',
			imagen: 'Agu_Individual_Base.png'
		},
		{
			id: 7,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Bajera ajustable algodón orgánico Amarillo',
			// sku: 'besto/90x200/ama',
			sku: 'besto/90x200/amc',
			precio: 27,
			premium: 19.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'ama',
			capa: 'bajera',
			imagen: 'Ama_Individual_Base.png'
		},
		{
			id: 8,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Bajera ajustable algodón orgánico Rosa',
			sku: 'besto/90x200/ros',
			precio: 27,
			premium: 19.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'ros',
			capa: 'bajera',
			imagen: 'Ros_Individual_Base.png'
		},
		{
			id: 9,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Bajera ajustable algodón orgánico Azul Oscuro',
			sku: 'besto/90x200/azd',
			precio: 27,
			premium: 19.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'azd',
			capa: 'bajera',
			imagen: 'Azd_Individual_Base.png'
		},
		{
			id: 10,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Bajera ajustable algodón orgánico Gris Ceniza',
			sku: 'besto/90x200/grz',
			precio: 27,
			premium: 19.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'grz',
			capa: 'bajera',
			imagen: 'Grz_Individual_Base.png'
		},
		{
			id: 11,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Bajera ajustable algodón orgánico Gris Piedra',
			sku: 'besto/90x200/pie',
			precio: 27,
			premium: 19.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'pie',
			capa: 'bajera',
			imagen: 'Pie_Individual_Base.png'
		},
		{
			id: 12,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Bajera ajustable algodón orgánico Azul',
			sku: 'besto/90x200/azc',
			precio: 27,
			premium: 19.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'azc',
			capa: 'bajera',
			imagen: 'Azu_Individual_Base.png'
		},
		{
			id: 13,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Bajera ajustable algodón orgánico Gris Ceniza Oscuro',
			sku: 'besto/90x200/cen',
			precio: 27,
			premium: 19.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'cen',
			capa: 'bajera',
			imagen: 'Grc_Individual_Base.png'
		},
		{
			id: 14,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Bajera ajustable algodón orgánico Gris Claro',
			sku: 'besto/90x200/grc',
			precio: 27,
			premium: 19.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'grc',
			capa: 'bajera',
			imagen: 'Grc_2_Individual_Base.png'
		},


		{
			id: 15,
			parentid: 1,
			subparentid: null,
			defecto: true,
			nombre: 'Sábana encimera algodón orgánico Blanco',
			sku: 'besto/160x275/bco',
			precio: 30,
			premium: 21.90,
			cat: 'encimera',
			modo: 'color',
			clase: 'bco',
			capa: 'encimera',
			imagen: 'Bco_Individual_Sabana.png'
		},

		{
			id: 1004,
			parentid: 1,
			subparentid: null,
			defecto: true,
			nombre: 'Sábana encimera algodón orgánico Verde Oscuro',
			sku: 'BESTO/160X275/VOS',
			precio: 25,
			premium: 22.90,
			cat: 'encimera',
			modo: 'color',
			clase: 'gre',
			capa: 'encimera',
			imagen: 'Dark_Green_Individual_Sabana.png'
		},


		{
			id: 1508,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Sábana encimera algodón orgánico Lila Claro',
			sku: 'BESTO/160X275/LIC',
			precio: 30,
			premium: 26.99,
			cat: 'encimera',
			modo: 'color',
			clase: 'lic',
			capa: 'encimera',
			imagen: 'Lic_Individual_Sabana.png'
		},

		{
			id: 16,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Sábana encimera algodón orgánico Aqua',
			sku: 'besto/160x275/aqu',
			precio: 30,
			premium: 21.90,
			cat: 'encimera',
			modo: 'color',
			clase: 'aqu',
			capa: 'encimera',
			imagen: 'Agu_Individual_Sabana.png'
		},
		{
			id: 17,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Sábana encimera algodón orgánico Amarillo',
			sku: 'besto/160x275/ama',
			precio: 30,
			premium: 21.90,
			cat: 'encimera',
			modo: 'color',
			clase: 'ama',
			capa: 'encimera',
			imagen: 'Ama_Individual_Sabana.png'
		},
		{
			id: 18,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Sábana encimera algodón orgánico Rosa',
			sku: 'besto/160x275/ros',
			precio: 30,
			premium: 21.90,
			cat: 'encimera',
			modo: 'color',
			clase: 'ros',
			capa: 'encimera',
			imagen: 'Ros_Individual_Sabana.png'
		},
		{
			id: 19,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Sábana encimera algodón orgánico Azul Oscuro',
			sku: 'besto/160x275/azd',
			precio: 30,
			premium: 21.90,
			cat: 'encimera',
			modo: 'color',
			clase: 'azd',
			capa: 'encimera',
			imagen: 'Azd_Individual_Sabana.png'
		},
		{
			id: 20,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Sábana encimera algodón orgánico Gris Ceniza Oscuro',
			sku: 'besto/160x275/cen',
			precio: 30,
			premium: 21.90,
			cat: 'encimera',
			modo: 'color',
			clase: 'grz',
			capa: 'encimera',
			imagen: 'Grz_Individual_Sabana.png'
		},
		{
			id: 21,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Sábana encimera algodón orgánico Gris Piedra',
			sku: 'besto/160x275/pie',
			precio: 30,
			premium: 21.90,
			cat: 'encimera',
			modo: 'color',
			clase: 'pie',
			capa: 'encimera',
			imagen: 'Pie_Individual_Sabana.png'
		},
		{
			id: 22,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Sábana encimera algodón orgánico Azul',
			sku: 'besto/160x275/azu',
			precio: 30,
			premium: 21.90,
			cat: 'encimera',
			modo: 'color',
			clase: 'azu',
			capa: 'encimera',
			imagen: 'Azu_Individual_Sabana.png'
		},
		{
			id: 23,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Sábana encimera algodón orgánico Gris Claro',
			sku: 'besto/160x275/grz',
			precio: 30,
			premium: 21.90,
			cat: 'encimera',
			modo: 'color',
			clase: 'cen',
			capa: 'encimera',
			imagen: 'Grc_Individual_Sabana.png'
		},

		{
			id: 25,
			parentid: 1,
			subparentid: null,
			defecto: true,
			nombre: 'Funda nórdica algodón orgánico Blanco',
			sku: 'besto/150x260/bco',
			precio: 47,
			premium: 34.90,
			cat: 'funda',
			modo: 'color',
			clase: 'bco',
			capa: 'funda',
			imagen: 'Bco_Individual_Nordico.png'
		},

		{
			id: 1000,
			parentid: 1,
			subparentid: null,
			defecto: true,
			nombre: 'Funda nórdica algodón orgánico Verde Oscuro',
			sku: 'BESTO-FNORD-A',
			precio: 40,
			premium: 35.90,
			cat: 'funda',
			modo: 'color',
			clase: 'gre',
			capa: 'funda',
			imagen: 'Dark_Green_Individual_Nordico.png'
		},

		{
			id: 1504,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Funda nórdica algodón orgánico Lila Claro',
			sku: 'BESTO/150X260/LIC',
			precio: 44,
			premium: 39.99,
			cat: 'funda',
			modo: 'color',
			clase: 'lic',
			capa: 'funda',
			imagen: 'Lic_Individual_Nordico.png'
		},

		{
			id: 26,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Funda nórdica algodón orgánico Aqua',
			sku: 'besto/150x260/aqu',
			precio: 47,
			premium: 34.90,
			cat: 'funda',
			modo: 'color',
			clase: 'aqu',
			capa: 'funda',
			imagen: 'Agu_Individual_Nordico.png'
		},
		{
			id: 27,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Funda nórdica algodón orgánico Amarillo',
			sku: 'besto/150x260/ama',
			precio: 47,
			premium: 34.90,
			cat: 'funda',
			modo: 'color',
			clase: 'ama',
			capa: 'funda',
			imagen: 'Ama_Individual_Nordico.png'
		},
		{
			id: 28,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Funda nórdica algodón orgánico Rosa',
			sku: 'besto/150x260/ros',
			precio: 47,
			premium: 34.90,
			cat: 'funda',
			modo: 'color',
			clase: 'ros',
			capa: 'funda',
			imagen: 'Ros_Individual_Nordico.png'
		},
		{
			id: 29,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Funda nórdica algodón orgánico Azul Oscuro',
			sku: 'besto/150x260/azd',
			precio: 47,
			premium: 34.90,
			cat: 'funda',
			modo: 'color',
			clase: 'azd',
			capa: 'funda',
			imagen: 'Azd_Individual_Nordico.png'
		},
		{
			id: 30,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Funda nórdica algodón orgánico Gris Ceniza',
			sku: 'besto/150x260/cen',
			precio: 47,
			premium: 34.90,
			cat: 'funda',
			modo: 'color',
			clase: 'grz',
			capa: 'funda',
			imagen: 'Grz_Individual_Nordico.png'
		},
		{
			id: 31,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Funda nórdica algodón orgánico Gris Piedra',
			sku: 'bestobic/150x260/pie',
			precio: 47,
			premium: 34.90,
			cat: 'funda',
			modo: 'color',
			clase: 'piedoble',
			capa: 'funda',
			imagen: 'Pie_Individual_Nordico.png'
		},
		{
			id: 32,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Funda nórdica algodón orgánico Azul',
			sku: 'bestobic/150x260/azc',
			precio: 47,
			premium: 34.90,
			cat: 'funda',
			modo: 'color',
			clase: 'azudoble',
			capa: 'funda',
			imagen: 'Azu_Individual_Nordico.png'
		},
		{
			id: 33,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Funda nórdica algodón orgánico Gris Claro',
			sku: 'bestobic/150x260/grc',
			precio: 47,
			premium: 34.90,
			cat: 'funda',
			modo: 'color',
			clase: 'grcdoble',
			capa: 'funda',
			imagen: 'Grc_Individual_Nordico.png'
		},


		{
			id: 34,
			parentid: 2,
			subparentid: null,
			defecto: true,
			nombre: 'Bajera ajustable algodón orgánico Blanco',
			sku: 'besto/135x200/bco',
			precio: 33,
			premium: 23.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'bco',
			capa: 'bajera',
			imagen: 'Bco_Doble_Base.png'
		},

		{
			id: 1009,
			parentid: 2,
			subparentid: null,
			defecto: true,
			nombre: 'Bajera ajustable algodón orgánico Verde Oscuro',
			sku: 'BESTO/135X200/VOS',
			precio: 27,
			premium: 23.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'gre',
			capa: 'bajera',
			imagen: 'Dark_Green_Doble_Base.png'
		},


		{
			id: 1501,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Bajera ajustable algodón orgánico Lila Claro',
			sku: 'BESTO/135X200/LIC',
			precio: 31,
			premium: 27.99,
			cat: 'bajera',
			modo: 'color',
			clase: 'lic',
			capa: 'bajera',
			imagen: 'Lic_Doble_Base.png'
		},

		{
			id: 35,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Bajera ajustable algodón orgánico Aqua',
			sku: 'besto/135x200/aqu',
			precio: 33,
			premium: 23.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'aqu',
			capa: 'bajera',
			imagen: 'Agu_Doble_Base.png'
		},
		{
			id: 36,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Bajera ajustable algodón orgánico Amarillo',
			sku: 'besto/135x200/ama',
			precio: 33,
			premium: 23.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'ama',
			capa: 'bajera',
			imagen: 'Ama_Doble_Base.png'
		},
		{
			id: 37,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Bajera ajustable algodón orgánico Rosa',
			sku: 'besto/135x200/ros',
			precio: 33,
			premium: 23.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'ros',
			capa: 'bajera',
			imagen: 'Ros_Doble_Base.png'
		},
		{
			id: 38,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Bajera ajustable algodón orgánico Azul Oscuro',
			sku: 'besto/135x200/azd',
			precio: 33,
			premium: 23.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'azd',
			capa: 'bajera',
			imagen: 'Azd_Doble_Base.png'
		},
		{
			id: 39,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Bajera ajustable algodón orgánico Gris Ceniza Oscuro',
			sku: 'besto/135x200/cen',
			precio: 33,
			premium: 23.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'grz',
			capa: 'bajera',
			imagen: 'Grz_Doble_Base.png'
		},
		{
			id: 40,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Bajera ajustable algodón orgánico Gris Piedra',
			sku: 'besto/135x200/pie',
			precio: 33,
			premium: 23.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'pie',
			capa: 'bajera',
			imagen: 'Pie_Doble_Base.png'
		},
		{
			id: 41,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Bajera ajustable algodón orgánico Azul',
			sku: 'besto/135x200/azc',
			precio: 33,
			premium: 23.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'azc',
			capa: 'bajera',
			imagen: 'Azu_Doble_Base.png'
		},
		{
			id: 42,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Bajera ajustable algodón orgánico Gris Ceniza',
			sku: 'besto/135x200/grz',
			precio: 33,
			premium: 23.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'cen',
			capa: 'bajera',
			imagen: 'Grc_Doble_Base.png'
		},
		{
			id: 43,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Bajera ajustable algodón orgánico Gris Claro',
			sku: 'besto/135x200/grc',
			precio: 33,
			premium: 23.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'grc',
			capa: 'bajera',
			imagen: 'Grc_2_Doble_Base.png'
		},


		{
			id: 44,
			parentid: 2,
			subparentid: null,
			defecto: true,
			nombre: 'Sábana encimera algodón orgánico Blanco',
			sku: 'besto/210x275/bco',
			precio: 38,
			premium: 27.90,
			cat: 'encimera',
			modo: 'color',
			clase: 'bco',
			capa: 'encimera',
			imagen: 'Bco_Doble_Sabana.png'
		},

		{
			id: 1005,
			parentid: 2,
			subparentid: null,
			defecto: true,
			nombre: 'Sábana encimera algodón orgánico Verde Oscuro',
			sku: 'BESTO/210X275/VOS',
			precio: 31,
			premium: 27.90,
			cat: 'encimera',
			modo: 'color',
			clase: 'gre',
			capa: 'encimera',
			imagen: 'Dark_Green_Doble_Sabana.png'
		},


		{
			id: 1509,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Sábana encimera algodón orgánico Gris Ceniza Oscuro',
			sku: 'besto/210x275/grz',
			precio: 36,
			premium: 32.99,
			cat: 'encimera',
			modo: 'color',
			clase: 'lic',
			capa: 'encimera',
			imagen: 'Lic_Doble_Sabana.png'
		},

		{
			id: 45,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Sábana encimera algodón orgánico Aqua',
			sku: 'besto/210x275/aqu',
			precio: 38,
			premium: 27.90,
			cat: 'encimera',
			modo: 'color',
			clase: 'aqu',
			capa: 'encimera',
			imagen: 'Agu_Doble_Sabana.png'
		},
		{
			id: 46,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Sábana encimera algodón orgánico Gris Ceniza Amarillo',
			sku: 'besto/210x275/ama',
			precio: 38,
			premium: 27.90,
			cat: 'encimera',
			modo: 'color',
			clase: 'ama',
			capa: 'encimera',
			imagen: 'Ama_Doble_Sabana.png'
		},
		{
			id: 47,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Sábana encimera algodón orgánico Rosa',
			sku: 'besto/210x275/ros',
			precio: 38,
			premium: 27.90,
			cat: 'encimera',
			modo: 'color',
			clase: 'ros',
			capa: 'encimera',
			imagen: 'Ros_Doble_Sabana.png'
		},
		{
			id: 48,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Sábana encimera algodón orgánico Azul Oscuro',
			sku: 'besto/210x275/azd',
			precio: 38,
			premium: 27.90,
			cat: 'encimera',
			modo: 'color',
			clase: 'azd',
			capa: 'encimera',
			imagen: 'Azd_Doble_Sabana.png'
		},

		{
			id: 49,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Sábana encimera algodón orgánico Gris Claro',
			sku: 'besto/210x275/cen',
			precio: 38,
			premium: 27.90,
			cat: 'encimera',
			modo: 'color',
			clase: 'grz',
			capa: 'encimera',
			imagen: 'Grz_Doble_Sabana.png'
		},
		{
			id: 50,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Sábana encimera algodón orgánico Gris Piedra',
			sku: 'besto/210x275/pie',
			precio: 38,
			premium: 27.90,
			cat: 'encimera',
			modo: 'color',
			clase: 'pie',
			capa: 'encimera',
			imagen: 'Pie_Doble_Sabana.png'
		},

		{
			id: 51,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Sábana encimera algodón orgánico Azul',
			sku: 'besto/210x275/azu',
			precio: 38,
			premium: 27.90,
			cat: 'encimera',
			modo: 'color',
			clase: 'azu',
			capa: 'encimera',
			imagen: 'Azu_Doble_Sabana.png'
		},
		{
			id: 52,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Sábana encimera algodón orgánico Gris Ceniza Oscuro',
			sku: 'besto/210x275/grz',
			precio: 38,
			premium: 27.90,
			cat: 'encimera',
			modo: 'color',
			clase: 'cen',
			capa: 'encimera',
			imagen: 'Grc_Doble_Sabana.png'
		},
		{
			id: 53,
			parentid: 2,
			subparentid: null,
			defecto: true,
			nombre: 'Funda nórdica algodón orgánico Blanco',
			sku: 'besto/220x260/bco',
			precio: 64,
			premium: 46.90,
			cat: 'funda',
			modo: 'color',
			clase: 'bco',
			capa: 'funda',
			imagen: 'Bco_Doble_Nordico.png'
		},

		{
			id: 1001,
			parentid: 2,
			subparentid: null,
			defecto: true,
			nombre: 'Funda nórdica algodón orgánico Verde Oscuro',
			sku: 'BESTO/220X260/VOS',
			precio: 52,
			premium: 46.90,
			cat: 'funda',
			modo: 'color',
			clase: 'gre',
			capa: 'funda',
			imagen: 'Dark_Green_Doble_Nordico.png'
		},


		{
			id: 1505,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Funda nórdica algodón orgánico lila Claro',
			sku: 'BESTO/220X260/LIC',
			precio: 58,
			premium: 52.99,
			cat: 'funda',
			modo: 'color',
			clase: 'lic',
			capa: 'funda',
			imagen: 'Lic_Doble_Nordico.png'
		},


		{
			id: 54,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Funda nórdica algodón orgánico Aqua',
			sku: 'besto/220x260/aqu',
			precio: 64,
			premium: 46.90,
			cat: 'funda',
			modo: 'color',
			clase: 'aqu',
			capa: 'funda',
			imagen: 'Agu_Doble_Nordico.png'
		},
		{
			id: 55,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Funda nórdica algodón orgánico Amarillo',
			sku: 'besto/220x260/ama',
			precio: 64,
			premium: 46.90,
			cat: 'funda',
			modo: 'color',
			clase: 'ama',
			capa: 'funda',
			imagen: 'Ama_Doble_Nordico.png'
		},
		{
			id: 56,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Funda nórdica algodón orgánico Rosa',
			sku: 'besto/220x260/ros',
			precio: 64,
			premium: 46.90,
			cat: 'funda',
			modo: 'color',
			clase: 'ros',
			capa: 'funda',
			imagen: 'Ros_Doble_Nordico.png'
		},
		{
			id: 57,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Funda nórdica algodón orgánico Azul Oscuro',
			sku: 'besto/220x260/azd',
			precio: 64,
			premium: 46.90,
			cat: 'funda',
			modo: 'color',
			clase: 'azd',
			capa: 'funda',
			imagen: 'Azd_Doble_Nordico.png'
		},
		{
			id: 58,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Funda nórdica algodón orgánico Gris Ceniza',
			sku: 'besto/220x260/cen',
			precio: 64,
			premium: 46.90,
			cat: 'funda',
			modo: 'color',
			clase: 'grz',
			capa: 'funda',
			imagen: 'Grz_Doble_Nordico.png'
		},
		{
			id: 59,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Funda nórdica algodón orgánico Gris Piedra',
			sku: 'bestobic/220x260/pie',
			precio: 64,
			premium: 46.90,
			cat: 'funda',
			modo: 'color',
			clase: 'piedoble',
			capa: 'funda',
			imagen: 'Pie_Doble_Nordico.png'
		},
		{
			id: 60,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Funda nórdica algodón orgánico Azul',
			sku: 'besto/220x260/azc',
			precio: 64,
			premium: 46.90,
			cat: 'funda',
			modo: 'color',
			clase: 'azudoble',
			capa: 'funda',
			imagen: 'Azu_Doble_Nordico.png'
		},
		{
			id: 61,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Funda nórdica algodón orgánico Gris Claro',
			sku: 'bestobic/220x260/grc',
			precio: 64,
			premium: 46.90,
			cat: 'funda',
			modo: 'color',
			clase: 'grcdoble',
			capa: 'funda',
			imagen: 'Grc_Doble_Nordico.png'
		},

		{
			id: 62,
			parentid: 3,
			subparentid: null,
			defecto: true,
			nombre: 'Bajera ajustable algodón orgánico Blanco',
			sku: 'besto/150x200/bco',
			precio: 34,
			premium: 24.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'bco',
			capa: 'bajera',
			imagen: 'Bco_Doble_Base.png'
		},

		{
			id: 1010,
			parentid: 3,
			subparentid: null,
			defecto: true,
			nombre: 'Bajera ajustable algodón orgánico Verde Oscuro',
			sku: 'BESTO/150X200/VOS',
			precio: 29,
			premium: 25.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'gre',
			capa: 'bajera',
			imagen: 'Dark_Green_Doble_Base.png'
		},


		{
			id: 1502,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Bajera ajustable algodón orgánico Lila Claro',
			sku: 'BESTO/150X200/LIC',
			precio: 33,
			premium: 29.99,
			cat: 'bajera',
			modo: 'color',
			clase: 'lic',
			capa: 'bajera',
			imagen: 'Lic_Doble_Base.png'
		},


		{
			id: 63,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Bajera ajustable algodón orgánico Aqua',
			sku: 'besto/150x200/aqu',
			precio: 34,
			premium: 24.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'aqu',
			capa: 'bajera',
			imagen: 'Agu_Doble_Base.png'
		},
		{
			id: 64,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Bajera ajustable algodón orgánico Amarillo',
			sku: 'besto/150x200/ama',
			precio: 34,
			premium: 24.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'ama',
			capa: 'bajera',
			imagen: 'Ama_Doble_Base.png'
		},
		{
			id: 65,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Bajera ajustable algodón orgánico Rosa',
			sku: 'besto/150x200/ros',
			precio: 34,
			premium: 24.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'ros',
			capa: 'bajera',
			imagen: 'Ros_Doble_Base.png'
		},
		{
			id: 66,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Bajera ajustable algodón orgánico Azul Oscuro',
			sku: 'besto/150x200/azd',
			precio: 34,
			premium: 24.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'azd',
			capa: 'bajera',
			imagen: 'Azd_Doble_Base.png'
		},
		{
			id: 67,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Bajera ajustable algodón orgánico Gris Ceniza Oscuro',
			sku: 'besto/150x200/cen',
			precio: 34,
			premium: 24.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'grz',
			capa: 'bajera',
			imagen: 'Grz_Doble_Base.png'
		},
		{
			id: 68,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Bajera ajustable algodón orgánico Gris Piedra',
			sku: 'besto/150x200/pie',
			precio: 34,
			premium: 24.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'pie',
			capa: 'bajera',
			imagen: 'Pie_Doble_Base.png'
		},
		{
			id: 69,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Bajera ajustable algodón orgánico Azul',
			sku: 'besto/150x200/azc',
			precio: 34,
			premium: 24.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'azc',
			capa: 'bajera',
			imagen: 'Azu_Doble_Base.png'
		},
		{
			id: 70,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Bajera ajustable algodón orgánico Gris Ceniza',
			sku: 'besto/150x200/grz',
			precio: 34,
			premium: 24.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'cen',
			capa: 'bajera',
			imagen: 'Grc_Doble_Base.png'
		},
		{
			id: 71,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Bajera ajustable algodón orgánico Gris Claro',
			sku: 'besto/150x200/grc',
			precio: 34,
			premium: 24.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'grc',
			capa: 'bajera',
			imagen: 'Grc_2_Doble_Base.png'
		},


		{
			id: 72,
			parentid: 3,
			subparentid: null,
			defecto: true,
			nombre: 'Sábana encimera algodón orgánico Blanco',
			sku: 'besto/240x275/bco',
			precio: 41,
			premium: 29.90,
			cat: 'encimera',
			modo: 'color',
			clase: 'bco',
			capa: 'encimera',
			imagen: 'Bco_Doble_Sabana.png'
		},

		{
			id: 1006,
			parentid: 3,
			subparentid: null,
			defecto: true,
			nombre: 'Sábana encimera algodón orgánico Verde Oscuro',
			sku: 'BESTO/240X275/VOS',
			precio: 34,
			premium: 30.90,
			cat: 'encimera',
			modo: 'color',
			clase: 'gre',
			capa: 'encimera',
			imagen: 'Dark_Green_Doble_Sabana.png'
		},

		{
			id: 1510,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Sábana encimera algodón orgánico Lila Claro',
			sku: 'BESTO/240X275/LIC',
			precio: 40,
			premium: 35.99,
			cat: 'encimera',
			modo: 'color',
			clase: 'lic',
			capa: 'encimera',
			imagen: 'Lic_Doble_Sabana.png'
		},

		{
			id: 73,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Sábana encimera algodón orgánico Aqua',
			sku: 'besto/240x275/aqu',
			precio: 41,
			premium: 29.90,
			cat: 'encimera',
			modo: 'color',
			clase: 'aqu',
			capa: 'encimera',
			imagen: 'Agu_Doble_Sabana.png'
		},
		{
			id: 74,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Sábana encimera algodón orgánico Amarillo',
			sku: 'besto/240x275/ama',
			precio: 41,
			premium: 29.90,
			cat: 'encimera',
			modo: 'color',
			clase: 'ama',
			capa: 'encimera',
			imagen: 'Ama_Doble_Sabana.png'
		},
		{
			id: 75,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Sábana encimera algodón orgánico Rosa',
			sku: 'besto/240x275/ros',
			precio: 41,
			premium: 29.90,
			cat: 'encimera',
			modo: 'color',
			clase: 'ros',
			capa: 'encimera',
			imagen: 'Ros_Doble_Sabana.png'
		},
		{
			id: 76,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Sábana encimera algodón orgánico Azul Oscuro',
			sku: 'besto/240x275/azd',
			precio: 41,
			premium: 29.90,
			cat: 'encimera',
			modo: 'color',
			clase: 'azd',
			capa: 'encimera',
			imagen: 'Azd_Doble_Sabana.png'
		},
		{
			id: 77,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Sábana encimera algodón orgánico Gris Ceniza Oscuro',
			sku: 'besto/240x275/cen',
			precio: 41,
			premium: 29.90,
			cat: 'encimera',
			modo: 'color',
			clase: 'grz',
			capa: 'encimera',
			imagen: 'Grz_Doble_Sabana.png'
		},
		{
			id: 78,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Sábana encimera algodón orgánico Gris Piedra',
			sku: 'besto/240x275/pie',
			precio: 41,
			premium: 29.90,
			cat: 'encimera',
			modo: 'color',
			clase: 'pie',
			capa: 'encimera',
			imagen: 'Pie_Doble_Sabana.png'
		},
		{
			id: 79,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Sábana encimera algodón orgánico Azul',
			sku: 'besto/240x275/azu',
			precio: 41,
			premium: 29.90,
			cat: 'encimera',
			modo: 'color',
			clase: 'azc',
			capa: 'encimera',
			imagen: 'Azu_Doble_Sabana.png'
		},

		{
			id: 80,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Sábana encimera algodón orgánico Gris Claro',
			sku: 'besto/240x275/grz',
			precio: 41,
			premium: 29.90,
			cat: 'encimera',
			modo: 'color',
			clase: 'cen',
			capa: 'encimera',
			imagen: 'Grc_Doble_Sabana.png'
		},

		{
			id: 81,
			parentid: 3,
			subparentid: null,
			defecto: true,
			nombre: 'Funda nórdica algodón orgánico Blanco',
			sku: 'besto/240x260/bco',
			precio: 68,
			premium: 49.90,
			cat: 'funda',
			modo: 'color',
			clase: 'bco',
			capa: 'funda',
			imagen: 'Bco_Doble_Nordico.png'
		},

		{
			id: 1002,
			parentid: 3,
			subparentid: null,
			defecto: true,
			nombre: 'Funda nórdica algodón orgánico Verde Oscuro',
			sku: 'BESTO/240X260/VOS',
			precio: 56,
			premium: 50.90,
			cat: 'funda',
			modo: 'color',
			clase: 'gre',
			capa: 'funda',
			imagen: 'Dark_Green_Doble_Nordico.png'
		},

		{
			id: 1506,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Funda nórdica algodón orgánico Lila Claro',
			sku: 'BESTO/240X260/LIC',
			precio: 63,
			premium: 56.99,
			cat: 'funda',
			modo: 'color',
			clase: 'lic',
			capa: 'funda',
			imagen: 'Lic_Doble_Nordico.png'
		},

		{
			id: 82,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Funda nórdica algodón orgánico Aqua',
			sku: 'besto/240x260/aqu',
			precio: 68,
			premium: 49.90,
			cat: 'funda',
			modo: 'color',
			clase: 'aqu',
			capa: 'funda',
			imagen: 'Agu_Doble_Nordico.png'
		},
		{
			id: 83,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Funda nórdica algodón orgánico Amarillo',
			sku: 'besto/240x260/ama',
			precio: 68,
			premium: 49.90,
			cat: 'funda',
			modo: 'color',
			clase: 'ama',
			capa: 'funda',
			imagen: 'Ama_Doble_Nordico.png'
		},
		{
			id: 84,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Funda nórdica algodón orgánico Rosa',
			sku: 'besto/240x260/ros',
			precio: 68,
			premium: 49.90,
			cat: 'funda',
			modo: 'color',
			clase: 'ros',
			capa: 'funda',
			imagen: 'Ros_Doble_Nordico.png'
		},
		{
			id: 85,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Funda nórdica algodón orgánico Azul Oscuro',
			sku: 'besto/240x260/azd',
			precio: 68,
			premium: 49.90,
			cat: 'funda',
			modo: 'color',
			clase: 'azd',
			capa: 'funda',
			imagen: 'Azd_Doble_Nordico.png'
		},
		{
			id: 86,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Funda nórdica algodón orgánico Gris Ceniza',
			sku: 'besto/240x260/cen',
			precio: 68,
			premium: 49.90,
			cat: 'funda',
			modo: 'color',
			clase: 'grz',
			capa: 'funda',
			imagen: 'Grz_Doble_Nordico.png'
		},
		{
			id: 87,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Funda nórdica algodón orgánico Gris Piedra',
			sku: 'bestobic/240x260/pie',
			precio: 68,
			premium: 49.90,
			cat: 'funda',
			modo: 'color',
			clase: 'piedoble',
			capa: 'funda',
			imagen: 'Pie_Doble_Nordico.png'
		},
		{
			id: 88,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Funda nórdica algodón orgánico Azul',
			sku: 'bestobic/240x260/azc',
			precio: 68,
			premium: 49.90,
			cat: 'funda',
			modo: 'color',
			clase: 'azudoble',
			capa: 'funda',
			imagen: 'Azu_Doble_Nordico.png'
		},

		{
			id: 89,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Funda nórdica algodón orgánico Gris Claro',
			sku: 'bestobic/240x260/grc',
			precio: 68,
			premium: 49.90,
			cat: 'funda',
			modo: 'color',
			clase: 'grcdoble',
			capa: 'funda',
			imagen: 'Grc_2_Doble_Nordico.png'
		},
		{
			id: 90,
			parentid: 4,
			subparentid: null,
			defecto: true,
			nombre: 'Bajera ajustable algodón orgánico Blanco',
			sku: 'besto/180x200/bco',
			precio: 38,
			premium: 27.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'bco',
			capa: 'bajera',
			imagen: 'Bco_Doble_Base.png'
		},

		{
			id: 1011,
			parentid: 4,
			subparentid: null,
			defecto: true,
			nombre: 'Bajera ajustable algodón orgánico Verde Oscuro',
			sku: 'BESTO/180X200/VOS',
			precio: 31,
			premium: 27.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'gre',
			capa: 'bajera',
			imagen: 'Dark_Green_Doble_Base.png'
		},

		{
			id: 1503,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Bajera ajustable algodón orgánico Lic Claro',
			sku: 'BESTO/180X200/LIC',
			precio: 36,
			premium: 32.99,
			cat: 'bajera',
			modo: 'color',
			clase: 'lic',
			capa: 'bajera',
			imagen: 'Lic_Doble_Base.png'
		},

		{
			id: 91,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Bajera ajustable algodón orgánico Aqua',
			sku: 'besto/180x200/aqu',
			precio: 38,
			premium: 27.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'aqu',
			capa: 'bajera',
			imagen: 'Agu_Doble_Base.png'
		},
		{
			id: 92,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Bajera ajustable algodón orgánico Amarillo',
			sku: 'besto/180x200/ama',
			precio: 38,
			premium: 27.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'ama',
			capa: 'bajera',
			imagen: 'Ama_Doble_Base.png'
		},
		{
			id: 93,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Bajera ajustable algodón orgánico Rosa',
			sku: 'besto/180x200/ros',
			precio: 38,
			premium: 27.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'ros',
			capa: 'bajera',
			imagen: 'Ros_Doble_Base.png'
		},
		{
			id: 94,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Bajera ajustable algodón orgánico Azul Oscuro',
			sku: 'besto/180x200/azd',
			precio: 38,
			premium: 27.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'azd',
			capa: 'bajera',
			imagen: 'Azd_Doble_Base.png'
		},
		{
			id: 95,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Bajera ajustable algodón orgánico Gris Ceniza Oscuro',
			sku: 'besto/180x200/cen',
			precio: 38,
			premium: 27.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'grz',
			capa: 'bajera',
			imagen: 'Grz_Doble_Base.png'
		},
		{
			id: 96,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Bajera ajustable algodón orgánico Gris Piedra',
			sku: 'besto/180x200/pie',
			precio: 38,
			premium: 27.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'pie',
			capa: 'bajera',
			imagen: 'Pie_Doble_Base.png'
		},
		{
			id: 97,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Bajera ajustable algodón orgánico Azul',
			sku: 'besto/180x200/azc',
			precio: 38,
			premium: 27.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'azc',
			capa: 'bajera',
			imagen: 'Azu_Doble_Base.png'
		},
		{
			id: 98,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Bajera ajustable algodón orgánico Gris Ceniza',
			sku: 'besto/180x200/grz',
			precio: 38,
			premium: 27.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'cen',
			capa: 'bajera',
			imagen: 'Grc_Doble_Base.png'
		},
		{
			id: 99,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Bajera ajustable algodón orgánico Gris Claro',
			sku: 'besto/180x200/grc',
			precio: 38,
			premium: 27.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'grc',
			capa: 'bajera',
			imagen: 'Grc_2_Doble_Base.png'
		},

		{
			id: 100,
			parentid: 4,
			subparentid: null,
			defecto: true,
			nombre: 'Sábana encimera algodón orgánico Blanco',
			sku: 'besto/270x275/bco',
			precio: 47,
			premium: 34.90,
			cat: 'encimera',
			modo: 'color',
			clase: 'bco',
			capa: 'encimera',
			imagen: 'Bco_Doble_Sabana.png'
		},

		{
			id: 1007,
			parentid: 4,
			subparentid: null,
			defecto: true,
			nombre: 'Sábana encimera algodón orgánico Verde Oscuro',
			sku: 'BESTO/270X275/VOS',
			precio: 39,
			premium: 34.90,
			cat: 'encimera',
			modo: 'color',
			clase: 'gre',
			capa: 'encimera',
			imagen: 'Dark_Green_Doble_Sabana.png'
		},

		{
			id: 1511,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Sábana encimera algodón orgánico Lila Claro',
			sku: 'besto/270x275/grz',
			precio: 44,
			premium: 39.99,
			cat: 'encimera',
			modo: 'color',
			clase: 'lic',
			capa: 'encimera',
			imagen: 'Lic_Doble_Sabana.png'
		},

		{
			id: 101,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Sábana encimera algodón orgánico Aqua',
			sku: 'besto/270x275/aqu',
			precio: 47,
			premium: 34.90,
			cat: 'encimera',
			modo: 'color',
			clase: 'aqu',
			capa: 'encimera',
			imagen: 'Agu_Doble_Sabana.png'
		},
		{
			id: 102,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Sábana encimera algodón orgánico Amarillo',
			sku: 'besto/270x275/ama',
			precio: 47,
			premium: 34.90,
			cat: 'encimera',
			modo: 'color',
			clase: 'ama',
			capa: 'encimera',
			imagen: 'Ama_Doble_Sabana.png'
		},
		{
			id: 103,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Sábana encimera algodón orgánico Rosa',
			sku: 'besto/270x275/ros',
			precio: 47,
			premium: 34.90,
			cat: 'encimera',
			modo: 'color',
			clase: 'ros',
			capa: 'encimera',
			imagen: 'Ros_Doble_Sabana.png'
		},
		{
			id: 104,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Sábana encimera algodón orgánico Azul Oscuro',
			sku: 'besto/270x275/azd',
			precio: 47,
			premium: 34.90,
			cat: 'encimera',
			modo: 'color',
			clase: 'azd',
			capa: 'encimera',
			imagen: 'Azd_Doble_Sabana.png'
		},
		{
			id: 105,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Sábana encimera algodón orgánico Gris Ceniza Oscuro',
			sku: 'besto/270x275/cen',
			precio: 47,
			premium: 34.90,
			cat: 'encimera',
			modo: 'color',
			clase: 'grz',
			capa: 'encimera',
			imagen: 'Grz_Doble_Sabana.png'
		},
		{
			id: 106,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Sábana encimera algodón orgánico Gris Piedra',
			sku: 'besto/270x275/pie',
			precio: 47,
			premium: 34.90,
			cat: 'encimera',
			modo: 'color',
			clase: 'pie',
			capa: 'encimera',
			imagen: 'Pie_Doble_Sabana.png'
		},
		{
			id: 107,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Sábana encimera algodón orgánico Azul',
			sku: 'besto/270x275/azu',
			precio: 47,
			premium: 34.90,
			cat: 'encimera',
			modo: 'color',
			clase: 'azu',
			capa: 'encimera',
			imagen: 'Azu_Doble_Sabana.png'
		},
		{
			id: 108,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Sábana encimera algodón orgánico Gris Claro',
			sku: 'besto/270x275/grz',
			precio: 47,
			premium: 34.90,
			cat: 'encimera',
			modo: 'color',
			clase: 'cen',
			capa: 'encimera',
			imagen: 'Grc_Doble_Sabana.png'
		},
		{
			id: 109,
			parentid: 4,
			subparentid: null,
			defecto: true,
			nombre: 'Funda nórdica algodón orgánico Blanco',
			sku: 'besto/260x260/bco',
			precio: 75,
			premium: 54.90,
			cat: 'funda',
			modo: 'color',
			clase: 'bco',
			capa: 'funda',
			imagen: 'Bco_Doble_Nordico.png'
		},
		{
			id: 1003,
			parentid: 4,
			subparentid: null,
			defecto: true,
			nombre: 'Funda nórdica algodón orgánico Verde Oscuro',
			sku: 'BESTO/260X260/VOS',
			precio: 60,
			premium: 54.90,
			cat: 'funda',
			modo: 'color',
			clase: 'gre',
			capa: 'funda',
			imagen: 'Dark_Green_Doble_Nordico.png'
		},
		{
			id: 1507,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Funda nórdica algodón orgánico Lila Claro',
			sku: 'BESTO/260X260/LIC',
			precio: 67,
			premium: 60.99,
			cat: 'funda',
			modo: 'color',
			clase: 'lic',
			capa: 'funda',
			imagen: 'Lic_Doble_Nordico.png'
		},
		{
			id: 110,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Funda nórdica algodón orgánico Aqua',
			sku: 'besto/260x260/aqu',
			precio: 75,
			premium: 54.90,
			cat: 'funda',
			modo: 'color',
			clase: 'aqu',
			capa: 'funda',
			imagen: 'Agu_Doble_Nordico.png'
		},
		{
			id: 111,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Funda nórdica algodón orgánico Amarillo',
			sku: 'besto/260x260/ama',
			precio: 75,
			premium: 54.90,
			cat: 'funda',
			modo: 'color',
			clase: 'ama',
			capa: 'funda',
			imagen: 'Ama_Doble_Nordico.png'
		},
		{
			id: 112,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Funda nórdica algodón orgánico Rosa',
			sku: 'besto/260x260/ros',
			precio: 75,
			premium: 54.90,
			cat: 'funda',
			modo: 'color',
			clase: 'ros',
			capa: 'funda',
			imagen: 'Ros_Doble_Nordico.png'
		},
		{
			id: 113,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Funda nórdica algodón orgánico Azul Oscuro',
			sku: 'besto/260x260/azd',
			precio: 75,
			premium: 54.90,
			cat: 'funda',
			modo: 'color',
			clase: 'azd',
			capa: 'funda',
			imagen: 'Azd_Doble_Nordico.png'
		},
		{
			id: 114,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Funda nórdica algodón orgánico Gris Ceniza',
			sku: 'besto/260x260/cen',
			precio: 75,
			premium: 54.90,
			cat: 'funda',
			modo: 'color',
			clase: 'grz',
			capa: 'funda',
			imagen: 'Grz_Doble_Nordico.png'
		},
		{
			id: 115,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Funda nórdica algodón orgánico Gris Piedra',
			sku: 'bestobic/260x260/pie',
			precio: 75,
			premium: 54.90,
			cat: 'funda',
			modo: 'color',
			clase: 'piedoble',
			capa: 'funda',
			imagen: 'Pie_Doble_Nordico.png'
		},
		{
			id: 116,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Funda nórdica algodón orgánico Azul',
			sku: 'bestobic/260x260/azc',
			precio: 75,
			premium: 54.90,
			cat: 'funda',
			modo: 'color',
			clase: 'azudoble',
			capa: 'funda',
			imagen: 'Azu_Doble_Nordico.png'
		},
		{
			id: 117,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Funda nórdica algodón orgánico Gris Claro',
			sku: 'bestobic/260x260/grc',
			precio: 75,
			premium: 54.90,
			cat: 'funda',
			modo: 'color',
			clase: 'grcdoble',
			capa: 'funda',
			imagen: 'Grc_Doble_Nordico.png'
		},
		{
			id: 118,
			parentid: 1,
			subparentid: null,
			defecto: true,
			nombre: 'Funda almohada algodón orgánico Blanco',
			sku: 'besto1/45x110/bco',
			precio: 18,
			premium: 12.90,
			cat: 'almohada-45x110',
			modo: 'color',
			clase: 'bco',
			capa: 'almohada',
			imagen: 'Bco_Individual_Cojin.png'
		},
		{
			id: 1012,
			parentid: 1,
			subparentid: null,
			defecto: true,
			nombre: 'Funda almohada algodón orgánico Verde Oscuro',
			sku: 'BESTO/45X110/VOS',
			precio: 16,
			premium: 13.90,
			cat: 'almohada-45x110',
			modo: 'color',
			clase: 'gre',
			capa: 'almohada',
			imagen: 'Dark_Green_Individual_Cojin.png'
		},
		{
			id: 1512,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Funda almohada algodón orgánico Lila Claro',
			sku: 'BESTO/45X110/LIC',
			precio: 18,
			premium: 15.99,
			cat: 'almohada-45x110',
			modo: 'color',
			clase: 'lic',
			capa: 'almohada',
			imagen: 'Lic_Individual_Cojin.png'
		},
		{
			id: 119,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Funda almohada algodón orgánico Aqua',
			sku: 'besto/45x110/aqu',
			precio: 18,
			premium: 12.90,
			cat: 'almohada-45x110',
			modo: 'color',
			clase: 'aqu',
			capa: 'almohada',
			imagen: 'Agu_Individual_Cojin.png'
		},
		{
			id: 120,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Funda almohada algodón orgánico Amarillo',
			sku: 'besto/45x110/ama',
			precio: 18,
			premium: 12.90,
			cat: 'almohada-45x110',
			modo: 'color',
			clase: 'ama',
			capa: 'almohada',
			imagen: 'Ama_Individual_Cojin.png'
		},
		{
			id: 121,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Funda almohada algodón orgánico Rosa',
			sku: 'besto/45x110/ros',
			precio: 18,
			premium: 12.90,
			cat: 'almohada-45x110',
			modo: 'color',
			clase: 'ros',
			capa: 'almohada',
			imagen: 'Ros_Individual_Cojin.png'
		},
		{
			id: 122,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Funda almohada algodón orgánico Azul Oscuro',
			sku: 'besto/45x110/azd',
			precio: 18,
			premium: 12.90,
			cat: 'almohada-45x110',
			modo: 'color',
			clase: 'azd',
			capa: 'almohada',
			imagen: 'Azd_Individual_Cojin.png'
		},
		{
			id: 123,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Funda almohada algodón orgánico Gris Ceniza Oscuro',
			sku: 'besto/45x110/cen',
			precio: 18,
			premium: 12.90,
			cat: 'almohada-45x110',
			modo: 'color',
			clase: 'grz',
			capa: 'almohada',
			imagen: 'Grz_Individual_Cojin.png'
		},
		{
			id: 124,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Funda almohada algodón orgánico Gris Piedra',
			sku: 'besto/45x110/pie',
			precio: 18,
			premium: 12.90,
			cat: 'almohada-45x110',
			modo: 'color',
			clase: 'pie',
			capa: 'almohada',
			imagen: 'Pie_Individual_Cojin.png'
		},
		{
			id: 125,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Funda almohada algodón orgánico Azul',
			sku: 'besto/45x110/azu',
			precio: 18,
			premium: 12.90,
			cat: 'almohada-45x110',
			modo: 'color',
			clase: 'azu',
			capa: 'almohada',
			imagen: 'Azu_Individual_Cojin.png'
		},
		{
			id: 126,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Funda almohada algodón orgánico Gris Ceniza',
			sku: 'besto/45x110/grz',
			precio: 18,
			premium: 12.90,
			cat: 'almohada-45x110',
			modo: 'color',
			clase: 'cen',
			capa: 'almohada',
			imagen: 'Grc_Individual_Cojin.png'
		},
		{
			id: 127,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Funda almohada algodón orgánico Gris Claro',
			sku: 'besto/45x110/grc',
			precio: 18,
			premium: 12.90,
			cat: 'almohada-45x110',
			modo: 'color',
			clase: 'grc',
			capa: 'almohada',
			imagen: 'Grc_2_Individual_Cojin.png'
		},
		{
			id: 128,
			parentid: 2,
			subparentid: null,
			defecto: true,
			nombre: 'Funda almohada algodón orgánico Blanco',
			sku: 'besto1/45X160/bco',
			precio: 19,
			premium: 13.90,
			cat: 'almohada-45x160',
			modo: 'color',
			clase: 'bco',
			capa: 'almohada',
			imagen: 'Bco_Doble_Largo.png'
		},

		{
			id: 1013,
			parentid: 2,
			subparentid: null,
			defecto: true,
			nombre: 'Funda almohada algodón orgánico Verde Oscuro',
			sku: 'BESTO/45X160/VOS',
			precio: 16,
			premium: 13.90,
			cat: 'almohada-45x160',
			modo: 'color',
			clase: 'gre',
			capa: 'almohada',
			imagen: 'Dark_Green_Doble_Largo.png'
		},
		{
			id: 1513,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Funda almohada algodón orgánico Lila Claro',
			sku: 'BESTO/45X160/LIC',
			precio: 19,
			premium: 16.99,
			cat: 'almohada-45x160',
			modo: 'color',
			clase: 'lic',
			capa: 'almohada',
			imagen: 'Lic_Doble_Largo.png'
		},

		{
			id: 129,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Funda almohada algodón orgánico Aqua',
			sku: 'besto/45X160/aqu',
			precio: 19,
			premium: 13.90,
			cat: 'almohada-45x160',
			modo: 'color',
			clase: 'aqu',
			capa: 'almohada',
			imagen: 'Agu_Doble_Largo.png'
		},
		{
			id: 130,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Funda almohada algodón orgánico Amarillo',
			sku: 'besto/45X160/ama',
			precio: 19,
			premium: 13.90,
			cat: 'almohada-45x160',
			modo: 'color',
			clase: 'ama',
			capa: 'almohada',
			imagen: 'Ama_Doble_Largo.png'
		},
		{
			id: 131,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Funda almohada algodón orgánico Rosa',
			sku: 'besto/45X160/ros',
			precio: 19,
			premium: 13.90,
			cat: 'almohada-45x160',
			modo: 'color',
			clase: 'ros',
			capa: 'almohada',
			imagen: 'Ros_Doble_Largo.png'
		},
		{
			id: 132,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Funda almohada algodón orgánico Azul Oscuro',
			sku: 'besto/45X160/azd',
			precio: 19,
			premium: 13.90,
			cat: 'almohada-45x160',
			modo: 'color',
			clase: 'azd',
			capa: 'almohada',
			imagen: 'Azd_Doble_Largo.png'
		},

		{
			id: 133,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Funda almohada algodón orgánico Gris Ceniza Oscuro',
			sku: 'besto/45X160/cen',
			precio: 19,
			premium: 13.90,
			cat: 'almohada-45x160',
			modo: 'color',
			clase: 'grz',
			capa: 'almohada',
			imagen: 'Grz_Doble_Largo.png'
		},
		{
			id: 134,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Funda almohada algodón orgánico Gris Piedra',
			sku: 'besto/45X160/pie',
			precio: 19,
			premium: 13.90,
			cat: 'almohada-45x160',
			modo: 'color',
			clase: 'pie',
			capa: 'almohada',
			imagen: 'Pie_Doble_Largo.png'
		},
		{
			id: 135,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Funda almohada algodón orgánico Azul',
			sku: 'besto/45X160/azu',
			precio: 19,
			premium: 13.90,
			cat: 'almohada-45x160',
			modo: 'color',
			clase: 'azu',
			capa: 'almohada',
			imagen: 'Azu_Doble_Largo.png'
		},
		{
			id: 136,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Funda almohada algodón orgánico Gris Ceniza',
			sku: 'besto/45X160/grz',
			precio: 19,
			premium: 13.90,
			cat: 'almohada-45x160',
			modo: 'color',
			clase: 'cen',
			capa: 'almohada',
			imagen: 'Grc_Doble_Largo.png'

		},
		{
			id: 137,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Funda almohada algodón orgánico Gris Claro',
			sku: 'besto/45X160/grc',
			precio: 19,
			premium: 13.90,
			cat: 'almohada-45x160',
			modo: 'color',
			clase: 'grc',
			capa: 'almohada',
			imagen: 'Grc_2_Doble_Largo.png'

		},










		//ALMOHADA SET 2-50x85 - CAMA 135x140


		{
			id: 138,
			parentid: 2,
			subparentid: null,
			defecto: true,
			nombre: 'Funda almohada algodón orgánico',
			sku: 'BESTO/50X85/BCO',
			precio: 24,
			premium: 21.9,
			cat: 'almohada-2-50x85',
			modo: 'color',
			clase: 'bco',
			capa: 'almohada',
			imagen: 'Bco_Doble_Cojines.png'
		},
		{
			id: 139,
			parentid: 2,
			subparentid: null,
			defecto: true,
			nombre: 'Funda almohada algodón orgánico',
			sku: 'BESTO/50X85/VOS',
			precio: 24,
			premium: 21.9,
			cat: 'almohada-2-50x85',
			modo: 'color',
			clase: 'gre',
			capa: 'almohada',
			imagen: 'Dark_Green_Doble_Cojines.png'
		},
		{
			id: 1514,
			parentid: 2,
			subparentid: null,
			defecto: true,
			nombre: 'Funda almohada algodón Lila orgánico',
			sku: 'BESTO/50X85/LIC',
			precio: 28,
			premium: 24.99,
			cat: 'almohada-2-50x85',
			modo: 'color',
			clase: 'lic',
			capa: 'almohada',
			imagen: 'Lic_Doble_Cojines.png'
		},
		{
			id: 140,
			parentid: 2,
			subparentid: null,
			defecto: true,
			nombre: 'Funda almohada algodón orgánico',
			sku: 'BESTO/50X85/AQU',
			precio: 24,
			premium: 21.9,
			cat: 'almohada-2-50x85',
			modo: 'color',
			clase: 'aqu',
			capa: 'almohada',
			imagen: 'Agu_Doble_Cojines.png'
		},

		{
			id: 141,
			parentid: 2,
			subparentid: null,
			defecto: true,
			nombre: 'Funda almohada algodón orgánico',
			sku: 'BESTO/50X85/AMA',
			precio: 24,
			premium: 21.9,
			cat: 'almohada-2-50x85',
			modo: 'color',
			clase: 'ama',
			capa: 'almohada',
			imagen: 'Ama_Doble_Cojines.png'
		},


		{
			id: 142,
			parentid: 2,
			subparentid: null,
			defecto: true,
			nombre: 'Funda almohada algodón orgánico',
			sku: 'BESTO/50X85/ROS',
			precio: 24,
			premium: 21.9,
			cat: 'almohada-2-50x85',
			modo: 'color',
			clase: 'ros',
			capa: 'almohada',
			imagen: 'Ros_Doble_Cojines.png'
		},

		{
			id: 143,
			parentid: 2,
			subparentid: null,
			defecto: true,
			nombre: 'Funda almohada algodón orgánico',
			sku: 'BESTO/50X85/AZD',
			precio: 24,
			premium: 21.9,
			cat: 'almohada-2-50x85',
			modo: 'color',
			clase: 'azd',
			capa: 'almohada',
			imagen: 'Azd_Doble_Cojines.png'
		},
		{
			id: 144,
			parentid: 2,
			subparentid: null,
			defecto: true,
			nombre: 'Funda almohada algodón orgánico',
			sku: 'BESTO/50X85/GRZ',
			precio: 24,
			premium: 21.9,
			cat: 'almohada-2-50x85',
			modo: 'color',
			clase: 'grz',
			capa: 'almohada',
			imagen: 'Grz_Doble_Cojines.png'
		},


		{
			id: 145,
			parentid: 2,
			subparentid: null,
			defecto: true,
			nombre: 'Funda almohada algodón orgánico',
			sku: 'BESTO/50X85/PIE',
			precio: 24,
			premium: 21.9,
			cat: 'almohada-2-50x85',
			modo: 'color',
			clase: 'pie',
			capa: 'almohada',
			imagen: 'Pie_Doble_Cojines.png'
		},
		{
			id: 146,
			parentid: 2,
			subparentid: null,
			defecto: true,
			nombre: 'Funda almohada algodón orgánico',
			sku: 'BESTO/50X85/AZU',
			precio: 24,
			premium: 21.9,
			cat: 'almohada-2-50x85',
			modo: 'color',
			clase: 'azu',
			capa: 'almohada',
			imagen: 'Azu_Doble_Cojines.png'
		},
		{
			id: 147,
			parentid: 2,
			subparentid: null,
			defecto: true,
			nombre: 'Funda almohada algodón orgánico',
			sku: 'BESTO/50X85/CEN',
			precio: 24,
			premium: 21.9,
			cat: 'almohada-2-50x85',
			modo: 'color',
			clase: 'cen',
			capa: 'almohada',
			imagen: 'Grc_Doble_Cojines.png'
		},
		{
			id: 148,
			parentid: 2,
			subparentid: null,
			defecto: true,
			nombre: 'Funda almohada algodón orgánico',
			sku: 'BESTO/50X85/GRC',
			precio: 24,
			premium: 21.9,
			cat: 'almohada-2-50x85',
			modo: 'color',
			clase: 'grc',
			capa: 'almohada',
			imagen: 'Grc_2_Doble_Cojines.png'
		},


		//ALMOHADA SET 2-50x85 - CAMA 150x160


		{
			id: 1200,
			parentid: 3,
			subparentid: null,
			defecto: true,
			nombre: 'Funda almohada algodón orgánico',
			sku: 'BESTO/50X85/BCO',
			precio: 24,
			premium: 21.9,
			cat: 'almohada-2-50x85',
			modo: 'color',
			clase: 'bco',
			capa: 'almohada',
			imagen: 'Bco_Doble_Cojines.png'
		},
		{
			id: 1201,
			parentid: 3,
			subparentid: null,
			defecto: true,
			nombre: 'Funda almohada algodón orgánico',
			sku: 'BESTO/50X85/VOS',
			precio: 24,
			premium: 21.9,
			cat: 'almohada-2-50x85',
			modo: 'color',
			clase: 'gre',
			capa: 'almohada',
			imagen: 'Dark_Green_Doble_Cojines.png'
		},
		{
			id: 1515,
			parentid: 3,
			subparentid: null,
			defecto: true,
			nombre: 'Funda almohada algodón Lila orgánico',
			sku: 'BESTO/50X85/LIC',
			precio: 28,
			premium: 24.99,
			cat: 'almohada-2-50x85',
			modo: 'color',
			clase: 'lic',
			capa: 'almohada',
			imagen: 'Lic_Doble_Cojines.png'
		},
		{
			id: 1202,
			parentid: 3,
			subparentid: null,
			defecto: true,
			nombre: 'Funda almohada algodón orgánico',
			sku: 'BESTO/50X85/AQU',
			precio: 24,
			premium: 21.9,
			cat: 'almohada-2-50x85',
			modo: 'color',
			clase: 'aqu',
			capa: 'almohada',
			imagen: 'Agu_Doble_Cojines.png'
		},

		{
			id: 1203,
			parentid: 3,
			subparentid: null,
			defecto: true,
			nombre: 'Funda almohada algodón orgánico',
			sku: 'BESTO/50X85/AMA',
			precio: 24,
			premium: 21.9,
			cat: 'almohada-2-50x85',
			modo: 'color',
			clase: 'ama',
			capa: 'almohada',
			imagen: 'Ama_Doble_Cojines.png'
		},


		{
			id: 1204,
			parentid: 3,
			subparentid: null,
			defecto: true,
			nombre: 'Funda almohada algodón orgánico',
			sku: 'BESTO/50X85/ROS',
			precio: 24,
			premium: 21.9,
			cat: 'almohada-2-50x85',
			modo: 'color',
			clase: 'ros',
			capa: 'almohada',
			imagen: 'Ros_Doble_Cojines.png'
		},

		{
			id: 1205,
			parentid: 3,
			subparentid: null,
			defecto: true,
			nombre: 'Funda almohada algodón orgánico',
			sku: 'BESTO/50X85/AZD',
			precio: 24,
			premium: 21.9,
			cat: 'almohada-2-50x85',
			modo: 'color',
			clase: 'azd',
			capa: 'almohada',
			imagen: 'Azd_Doble_Cojines.png'
		},
		{
			id: 1206,
			parentid: 3,
			subparentid: null,
			defecto: true,
			nombre: 'Funda almohada algodón orgánico',
			sku: 'BESTO/50X85/GRZ',
			precio: 24,
			premium: 21.9,
			cat: 'almohada-2-50x85',
			modo: 'color',
			clase: 'grz',
			capa: 'almohada',
			imagen: 'Grz_Doble_Cojines.png'
		},


		{
			id: 1207,
			parentid: 3,
			subparentid: null,
			defecto: true,
			nombre: 'Funda almohada algodón orgánico',
			sku: 'BESTO/50X85/PIE',
			precio: 24,
			premium: 21.9,
			cat: 'almohada-2-50x85',
			modo: 'color',
			clase: 'pie',
			capa: 'almohada',
			imagen: 'Pie_Doble_Cojines.png'
		},
		{
			id: 1208,
			parentid: 3,
			subparentid: null,
			defecto: true,
			nombre: 'Funda almohada algodón orgánico',
			sku: 'BESTO/50X85/AZU',
			precio: 24,
			premium: 21.9,
			cat: 'almohada-2-50x85',
			modo: 'color',
			clase: 'azu',
			capa: 'almohada',
			imagen: 'Azu_Doble_Cojines.png'
		},
		{
			id: 1209,
			parentid: 3,
			subparentid: null,
			defecto: true,
			nombre: 'Funda almohada algodón orgánico',
			sku: 'BESTO/50X85/CEN',
			precio: 24,
			premium: 21.9,
			cat: 'almohada-2-50x85',
			modo: 'color',
			clase: 'cen',
			capa: 'almohada',
			imagen: 'Grc_Doble_Cojines.png'
		},
		{
			id: 1210,
			parentid: 3,
			subparentid: null,
			defecto: true,
			nombre: 'Funda almohada algodón orgánico',
			sku: 'BESTO/50X85/GRC',
			precio: 24,
			premium: 21.9,
			cat: 'almohada-2-50x85',
			modo: 'color',
			clase: 'grc',
			capa: 'almohada',
			imagen: 'Grc_2_Doble_Cojines.png'
		},




		//ALMOHADA SET 2-50x85 - CAMA 180x200


		{
			id: 1211,
			parentid: 4,
			subparentid: null,
			defecto: true,
			nombre: 'Funda almohada algodón orgánico',
			sku: 'BESTO/50X85/BCO',
			precio: 24,
			premium: 21.9,
			cat: 'almohada-2-50x85',
			modo: 'color',
			clase: 'bco',
			capa: 'almohada',
			imagen: 'Bco_Doble_Cojines.png'
		},
		{
			id: 1212,
			parentid: 4,
			subparentid: null,
			defecto: true,
			nombre: 'Funda almohada algodón orgánico',
			sku: 'BESTO/50X85/VOS',
			precio: 24,
			premium: 21.9,
			cat: 'almohada-2-50x85',
			modo: 'color',
			clase: 'gre',
			capa: 'almohada',
			imagen: 'Dark_Green_Doble_Cojines.png'
		},
		{
			id: 1516,
			parentid: 4,
			subparentid: null,
			defecto: true,
			nombre: 'Funda almohada algodón Lila orgánico',
			sku: 'BESTO/50X85/LIC',
			precio: 28,
			premium: 24.99,
			cat: 'almohada-2-50x85',
			modo: 'color',
			clase: 'lic',
			capa: 'almohada',
			imagen: 'Lic_Doble_Cojines.png'
		},
		{
			id: 1213,
			parentid: 4,
			subparentid: null,
			defecto: true,
			nombre: 'Funda almohada algodón orgánico',
			sku: 'BESTO/50X85/AQU',
			precio: 24,
			premium: 21.9,
			cat: 'almohada-2-50x85',
			modo: 'color',
			clase: 'aqu',
			capa: 'almohada',
			imagen: 'Agu_Doble_Cojines.png'
		},

		{
			id: 1214,
			parentid: 4,
			subparentid: null,
			defecto: true,
			nombre: 'Funda almohada algodón orgánico',
			sku: 'BESTO/50X85/AMA',
			precio: 24,
			premium: 21.9,
			cat: 'almohada-2-50x85',
			modo: 'color',
			clase: 'ama',
			capa: 'almohada',
			imagen: 'Ama_Doble_Cojines.png'
		},


		{
			id: 1215,
			parentid: 4,
			subparentid: null,
			defecto: true,
			nombre: 'Funda almohada algodón orgánico',
			sku: 'BESTO/50X85/ROS',
			precio: 24,
			premium: 21.9,
			cat: 'almohada-2-50x85',
			modo: 'color',
			clase: 'ros',
			capa: 'almohada',
			imagen: 'Ros_Doble_Cojines.png'
		},

		{
			id: 1216,
			parentid: 4,
			subparentid: null,
			defecto: true,
			nombre: 'Funda almohada algodón orgánico',
			sku: 'BESTO/50X85/AZD',
			precio: 24,
			premium: 21.9,
			cat: 'almohada-2-50x85',
			modo: 'color',
			clase: 'azd',
			capa: 'almohada',
			imagen: 'Azd_Doble_Cojines.png'
		},
		{
			id: 1217,
			parentid: 4,
			subparentid: null,
			defecto: true,
			nombre: 'Funda almohada algodón orgánico',
			sku: 'BESTO/50X85/GRZ',
			precio: 24,
			premium: 21.9,
			cat: 'almohada-2-50x85',
			modo: 'color',
			clase: 'grz',
			capa: 'almohada',
			imagen: 'Grz_Doble_Cojines.png'
		},


		{
			id: 1218,
			parentid: 4,
			subparentid: null,
			defecto: true,
			nombre: 'Funda almohada algodón orgánico',
			sku: 'BESTO/50X85/PIE',
			precio: 24,
			premium: 21.9,
			cat: 'almohada-2-50x85',
			modo: 'color',
			clase: 'pie',
			capa: 'almohada',
			imagen: 'Pie_Doble_Cojines.png'
		},
		{
			id: 1219,
			parentid: 4,
			subparentid: null,
			defecto: true,
			nombre: 'Funda almohada algodón orgánico',
			sku: 'BESTO/50X85/AZU',
			precio: 24,
			premium: 21.9,
			cat: 'almohada-2-50x85',
			modo: 'color',
			clase: 'azu',
			capa: 'almohada',
			imagen: 'Azu_Doble_Cojines.png'
		},
		{
			id: 1220,
			parentid: 4,
			subparentid: null,
			defecto: true,
			nombre: 'Funda almohada algodón orgánico',
			sku: 'BESTO/50X85/CEN',
			precio: 24,
			premium: 21.9,
			cat: 'almohada-2-50x85',
			modo: 'color',
			clase: 'cen',
			capa: 'almohada',
			imagen: 'Grc_Doble_Cojines.png'
		},


		{
			id: 1221,
			parentid: 4,
			subparentid: null,
			defecto: true,
			nombre: 'Funda almohada algodón orgánico',
			sku: 'BESTO/50X85/GRC',
			precio: 24,
			premium: 21.9,
			cat: 'almohada-2-50x85',
			modo: 'color',
			clase: 'grc',
			capa: 'almohada',
			imagen: 'Grc_2_Doble_Cojines.png'
		},

		{
			id: 158,
			parentid: 1,
			subparentid: null,
			defecto: true,
			nombre: 'Funda de cuadrante algodón orgánico Blanco',
			sku: 'besto/55x55/bco',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'bco',
			capa: 'cuadrante_1',
			imagen: 'Bco_Individual_Cojin1.png'
		},
		{
			id: 159,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Aqua',
			sku: 'besto/55x55/aqu',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'aqu',
			capa: 'cuadrante_1',
			imagen: 'Agu_Individual_Cojin1.png'
		},
		{
			id: 160,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Amarillo',
			sku: 'besto/55x55/ama',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'ama',
			capa: 'cuadrante_1',
			imagen: 'Ama_Individual_Cojin1.png'
		},
		{
			id: 161,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Rosa',
			sku: 'besto/55x55/ros',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'ros',
			capa: 'cuadrante_1',
			imagen: 'Ros_Individual_Cojin1.png'
		},
		{
			id: 162,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Azul Oscuro',
			sku: 'besto/55x55/azd',
			precio: 27,
			premium: 19.90,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'azd',
			capa: 'cuadrante_1',
			imagen: 'Azd_Individual_Cojin1.png'
		},
		{
			id: 163,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Gris Ceniza Oscuro',
			sku: 'besto/55x55/cen',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'grz',
			capa: 'cuadrante_1',
			imagen: 'Grz_Individual_Cojin1.png'
		},
		{
			id: 164,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Gris Piedra',
			sku: 'bestobic/55x55/pie',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'piedoble',
			capa: 'cuadrante_1',
			imagen: 'Pie_Individual_Cojin1.png'
		},

		{
			id: 165,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Azul',
			sku: 'bestobic/55x55/azu',
			precio: 27,
			premium: 19.90,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'azudoble',
			capa: 'cuadrante_1',
			imagen: 'Azu_Individual_Cojin1.png'
		},

		{
			id: 166,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Gris Claro',
			sku: 'bestobic/55x55/grc',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'grcdoble',
			capa: 'cuadrante_1',
			imagen: 'Grc_2_Individual_Cojin1.png'
		},

		{
			id: 167,
			parentid: 2,
			subparentid: null,
			defecto: true,
			nombre: 'Funda de cuadrante algodón orgánico Blanco',
			sku: 'besto/55x55/bco',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'bco',
			capa: 'cuadrante_1',
			imagen: 'Bco_Doble_Cojin1.png'
		},
		{
			id: 1020,
			parentid: 2,
			subparentid: null,
			defecto: true,
			nombre: 'Funda de cuadrante algodón orgánico Verde Oscuro',
			sku: 'BESTO/55X55/VOS',
			precio: 15,
			premium: 12.90,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'gre',
			capa: 'cuadrante_1',
			imagen: 'Dark_Green_Doble_Cojin2.png'
		},
		{
			id: 1521,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Lila Claro',
			sku: 'BESTO/55X55/LIC',
			precio: 18,
			premium: 15.99,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'lic',
			capa: 'cuadrante_1',
			imagen: 'Lic_Doble_Cojin1.png'
		},
		{
			id: 168,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Aqua',
			sku: 'besto/55x55/aqu',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'aqu',
			capa: 'cuadrante_1',
			imagen: 'Agu_Doble_Cojin1.png'
		},
		{
			id: 169,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Amarillo',
			sku: 'besto/55x55/ama',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'ama',
			capa: 'cuadrante_1',
			imagen: 'Ama_Doble_Cojin1.png'
		},
		{
			id: 170,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Rosa',
			sku: 'besto/55x55/ros',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'ros',
			capa: 'cuadrante_1',
			imagen: 'Ros_Doble_Cojin1.png'
		},
		{
			id: 171,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Azul Oscuro',
			sku: 'besto/55x55/azd',
			precio: 27,
			premium: 19.90,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'azd',
			capa: 'cuadrante_1',
			imagen: 'Azd_Doble_Cojin1.png'
		},
		{
			id: 172,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Gris Ceniza Oscuro',
			sku: 'besto/55x55/cen',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'grz',
			capa: 'cuadrante_1',
			imagen: 'Grz_Doble_Cojin1.png'
		},
		{
			id: 173,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Gris Piedra',
			sku: 'bestobic/55x55/pie',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'piedoble',
			capa: 'cuadrante_1',
			imagen: 'Pie_Doble_Cojin1.png'
		},


		{
			id: 174,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Azul',
			sku: 'bestobic/55x55/azu',
			precio: 27,
			premium: 19.90,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'azudoble',
			capa: 'cuadrante_1',
			imagen: 'Azu_Doble_Cojin1.png'
		},

		{
			id: 175,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Gris Claro',
			sku: 'bestobic/55x55/grc',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'grcdoble',
			capa: 'cuadrante_1',
			imagen: 'Grc_2_Doble_Cojin1.png'
		},
		{
			id: 176,
			parentid: 3,
			subparentid: null,
			defecto: true,
			nombre: 'Funda de cuadrante algodón orgánico Blanco',
			sku: 'besto/55x55/bco',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'bco',
			capa: 'cuadrante_1',
			imagen: 'Bco_Doble_Cojin1.png'
		},
		{
			id: 1021,
			parentid: 3,
			subparentid: null,
			defecto: true,
			nombre: 'Funda de cuadrante algodón orgánico Verde Oscuro',
			sku: 'BESTO/55X55/VOS',
			precio: 15,
			premium: 12.90,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'gre',
			capa: 'cuadrante_1',
			imagen: 'Dark_Green_Doble_Cojin1.png'
		},
		{
			id: 1525,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Lila Claro',
			sku: 'BESTO/55X55/LIC',
			precio: 18,
			premium: 15.99,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'lic',
			capa: 'cuadrante_1',
			imagen: 'Lic_Doble_Cojin1.png'
		},
		{
			id: 177,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Aqua',
			sku: 'besto/55x55/aqu',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'aqu',
			capa: 'cuadrante_1',
			imagen: 'Agu_Doble_Cojin1.png'
		},
		{
			id: 178,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Amarillo',
			sku: 'besto/55x55/ama',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'ama',
			capa: 'cuadrante_1',
			imagen: 'Ama_Doble_Cojin1.png'
		},
		{
			id: 179,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Rosa',
			sku: 'besto/55x55/ros',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'ros',
			capa: 'cuadrante_1',
			imagen: 'Ros_Doble_Cojin1.png'
		},
		{
			id: 180,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Azul Oscuro',
			sku: 'besto/55x55/azd',
			precio: 27,
			premium: 19.90,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'azd',
			capa: 'cuadrante_1',
			imagen: 'Azd_Doble_Cojin1.png'
		},
		{
			id: 181,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Gris Ceniza Oscuro',
			sku: 'besto/55x55/cen',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'grz',
			capa: 'cuadrante_1',
			imagen: 'Grz_Doble_Cojin1.png'
		},
		{
			id: 182,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Gris Piedra',
			sku: 'bestobic/55x55/pie',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'piedoble',
			capa: 'cuadrante_1',
			imagen: 'Pie_Doble_Cojin1.png'
		},
		{
			id: 183,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Azul',
			sku: 'bestobic/55x55/azu',
			precio: 27,
			premium: 19.90,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'azudoble',
			capa: 'cuadrante_1',
			imagen: 'Azu_Doble_Cojin1.png'
		},

		{
			id: 184,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Gris Claro',
			sku: 'bestobic/55x55/grc',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'grcdoble',
			capa: 'cuadrante_1',
			imagen: 'Grc_2_Doble_Cojin1.png'
		},
		{
			id: 185,
			parentid: 4,
			subparentid: null,
			defecto: true,
			nombre: 'Funda de cuadrante algodón orgánico Blanco',
			sku: 'besto/55x55/bco',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'bco',
			capa: 'cuadrante_1',
			imagen: 'Bco_Doble_Cojin1.png'
		},
		{
			id: 1022,
			parentid: 4,
			subparentid: null,
			defecto: true,
			nombre: 'Funda de cuadrante algodón orgánico Verde Oscuro',
			sku: 'BESTO/55X55/VOS',
			precio: 15,
			premium: 12.90,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'gre',
			capa: 'cuadrante_1',
			imagen: 'Dark_Green_Doble_Cojin2.png'
		},
		{
			id: 1518,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Lila Claro',
			sku: 'BESTO/55X55/LIC',
			precio: 18,
			premium: 15.99,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'lic',
			capa: 'cuadrante_1',
			imagen: 'Lic_Doble_Cojin1.png'
		},
		{
			id: 186,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Aqua',
			sku: 'besto/55x55/aqu',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'aqu',
			capa: 'cuadrante_1',
			imagen: 'Agu_Doble_Cojin1.png'
		},
		{
			id: 187,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Amarillo',
			sku: 'besto/55x55/ama',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'ama',
			capa: 'cuadrante_1',
			imagen: 'Ama_Doble_Cojin1.png'
		},
		{
			id: 188,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Rosa',
			sku: 'besto/55x55/ros',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'ros',
			capa: 'cuadrante_1',
			imagen: 'Ros_Doble_Cojin1.png'
		},
		{
			id: 189,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Azul Oscuro',
			sku: 'besto/55x55/azd',
			precio: 27,
			premium: 19.90,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'azd',
			capa: 'cuadrante_1',
			imagen: 'Azd_Doble_Cojin1.png'
		},
		{
			id: 190,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Gris Ceniza Oscuro',
			sku: 'besto/55x55/cen',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'grz',
			capa: 'cuadrante_1',
			imagen: 'Grz_Doble_Cojin1.png'
		},
		{
			id: 191,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Gris Piedra',
			sku: 'bestobic/55x55/pie',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'piedoble',
			capa: 'cuadrante_1',
			imagen: 'Pie_Doble_Cojin1.png'
		},
		{
			id: 192,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Azul',
			sku: 'bestobic/55x55/azu',
			precio: 27,
			premium: 19.90,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'azudoble',
			capa: 'cuadrante_1',
			imagen: 'Azu_Doble_Cojin1.png'
		},
		{
			id: 193,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Gris Claro',
			sku: 'bestobic/55x55/grc',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'grcdoble',
			capa: 'cuadrante_1',
			imagen: 'Grc_2_Doble_Cojin1.png'
		},
		{
			id: 194,
			parentid: 1,
			subparentid: null,
			defecto: true,
			nombre: 'Funda de cuadrante algodón orgánico Blanco',
			sku: 'besto/55x55/bco',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'bco',
			capa: 'cuadrante_2',
			imagen: 'Bco_Individual_Cojin1.png'
		},
		{
			id: 1019,
			parentid: 1,
			subparentid: null,
			defecto: true,
			nombre: 'Funda de cuadrante algodón orgánico Verde Oscuro',
			sku: 'BESTO/55X55/VOS',
			precio: 15,
			premium: 12.90,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'gre',
			capa: 'cuadrante_2',
			imagen: 'Dark_Green_Doble_Cojin2.png'
		},
		{
			id: 1522,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Lila Claro',
			sku: 'BESTO/55X55/LIC',
			precio: 18,
			premium: 15.99,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'lic',
			capa: 'cuadrante_2',
			imagen: 'Lic_Individual_Cojin1.png'
		},
		{
			id: 195,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Aqua',
			sku: 'besto/55x55/aqu',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'aqu',
			capa: 'cuadrante_2',
			imagen: 'Agu_Individual_Cojin1.png'
		},
		{
			id: 196,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Amarillo',
			sku: 'besto/55x55/ama',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'ama',
			capa: 'cuadrante_2',
			imagen: 'Ama_Individual_Cojin1.png'
		},
		{
			id: 197,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Rosa',
			sku: 'besto/55x55/ros',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'ros',
			capa: 'cuadrante_2',
			imagen: 'Ros_Individual_Cojin1.png'
		},
		{
			id: 198,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Azul Oscuro',
			sku: 'besto/55x55/azd',
			precio: 27,
			premium: 19.90,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'azd',
			capa: 'cuadrante_2',
			imagen: 'Azd_Individual_Cojin1.png'
		},
		{
			id: 199,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Gris Ceniza Oscuro',
			sku: 'besto/55x55/cen',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'grz',
			capa: 'cuadrante_2',
			imagen: 'Grz_Individual_Cojin1.png'
		},


		{
			id: 200,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Gris Piedra',
			sku: 'bestobic/55x55/pie',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'piedoble',
			capa: 'cuadrante_2',
			imagen: 'Pie_Individual_Cojin1.png'
		},
		{
			id: 201,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Azul',
			sku: 'bestobic/55x55/azu',
			precio: 27,
			premium: 19.90,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'azudoble',
			capa: 'cuadrante_2',
			imagen: 'Azu_Individual_Cojin1.png'
		},

		{
			id: 202,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Gris Claro',
			sku: 'bestobic/55x55/grc',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'grcdoble',
			capa: 'cuadrante_2',
			imagen: 'Grc_2_Individual_Cojin1.png'
		},
		{
			id: 203,
			parentid: 2,
			subparentid: null,
			defecto: true,
			nombre: 'Funda de cuadrante algodón orgánico Blanco',
			sku: 'besto/55x55/bco',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'bco',
			capa: 'cuadrante_2',
			imagen: 'Bco_Doble_Cojin2.png'
		},
		{
			id: 1018,
			parentid: 2,
			subparentid: null,
			defecto: true,
			nombre: 'Funda de cuadrante algodón orgánico Verde Oscuro',
			sku: 'BESTO/55X55/VOS',
			precio: 15,
			premium: 12.90,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'gre',
			capa: 'cuadrante_2',
			imagen: 'Dark_Green_Doble_Cojin2.png'
		},
		{
			id: 1520,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Lila Claro',
			sku: 'BESTO/55X55/LIC',
			precio: 18,
			premium: 15.99,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'lic',
			capa: 'cuadrante_2',
			imagen: 'Lic_Doble_Cojin2.png'
		},
		{
			id: 204,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Aqua',
			sku: 'besto/55x55/aqu',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'aqu',
			capa: 'cuadrante_2',
			imagen: 'Agu_Doble_Cojin2.png'
		},
		{
			id: 205,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Amarillo',
			sku: 'besto/55x55/ama',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'ama',
			capa: 'cuadrante_2',
			imagen: 'Ama_Doble_Cojin2.png'
		},
		{
			id: 206,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Rosa',
			sku: 'besto/55x55/ros',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'ros',
			capa: 'cuadrante_2',
			imagen: 'Ros_Doble_Cojin2.png'
		},
		{
			id: 207,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Azul Oscuro',
			sku: 'besto/55x55/azd',
			precio: 27,
			premium: 19.90,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'azd',
			capa: 'cuadrante_2',
			imagen: 'Azd_Doble_Cojin2.png'
		},
		{
			id: 208,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Gris Ceniza Oscuro',
			sku: 'besto/55x55/cen',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'grz',
			capa: 'cuadrante_2',
			imagen: 'Grz_Doble_Cojin2.png'
		},
		{
			id: 209,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Gris Piedra',
			sku: 'bestobic/55x55/pie',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'piedoble',
			capa: 'cuadrante_2',
			imagen: 'Pie_Doble_Cojin2.png'
		},
		{
			id: 210,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Azul',
			sku: 'bestobic/55x55/azu',
			precio: 27,
			premium: 19.90,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'azudoble',
			capa: 'cuadrante_2',
			imagen: 'Azu_Doble_Cojin2.png'
		},
		{
			id: 211,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Gris Claro',
			sku: 'bestobic/55x55/grc',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'grcdoble',
			capa: 'cuadrante_2',
			imagen: 'Grc_2_Doble_Cojin2.png'
		},
		{
			id: 212,
			parentid: 3,
			subparentid: null,
			defecto: true,
			nombre: 'Funda de cuadrante algodón orgánico Blanco',
			sku: 'besto/55x55/bco',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'bco',
			capa: 'cuadrante_2',
			imagen: 'Bco_Doble_Cojin2.png'
		},
		{
			id: 1017,
			parentid: 3,
			subparentid: null,
			defecto: true,
			nombre: 'Funda de cuadrante algodón orgánico Verde Oscuro',
			sku: 'BESTO/55X55/VOS',
			precio: 15,
			premium: 12.90,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'gre',
			capa: 'cuadrante_2',
			imagen: 'Dark_Green_Doble_Cojin2.png'
		},
		{
			id: 1519,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Lila Claro',
			sku: 'BESTO/55X55/LIC',
			precio: 18,
			premium: 15.99,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'lic',
			capa: 'cuadrante_2',
			imagen: 'Lic_Doble_Cojin2.png'
		},
		{
			id: 213,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Aqua',
			sku: 'besto/55x55/aqu',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'aqu',
			capa: 'cuadrante_2',
			imagen: 'Agu_Doble_Cojin2.png'
		},
		{
			id: 214,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Amarillo',
			sku: 'besto/55x55/ama',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'ama',
			capa: 'cuadrante_2',
			imagen: 'Ama_Doble_Cojin2.png'
		},
		{
			id: 215,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Rosa',
			sku: 'besto/55x55/ros',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'ros',
			capa: 'cuadrante_2',
			imagen: 'Ros_Doble_Cojin2.png'
		},
		{
			id: 216,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Azul Oscuro',
			sku: 'besto/55x55/azd',
			precio: 27,
			premium: 19.90,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'azd',
			capa: 'cuadrante_2',
			imagen: 'Azd_Doble_Cojin2.png'
		},
		{
			id: 217,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Gris Ceniza Oscuro',
			sku: 'besto/55x55/cen',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'grz',
			capa: 'cuadrante_2',
			imagen: 'Grz_Doble_Cojin2.png'
		},
		{
			id: 218,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Gris Piedra',
			sku: 'bestobic/55x55/pie',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'piedoble',
			capa: 'cuadrante_2',
			imagen: 'Pie_Doble_Cojin2.png'
		},
		{
			id: 219,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Azul',
			sku: 'bestobic/55x55/azu',
			precio: 27,
			premium: 19.90,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'azudoble',
			capa: 'cuadrante_2',
			imagen: 'Azu_Doble_Cojin2.png'
		},
		{
			id: 220,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Gris Claro',
			sku: 'bestobic/55x55/grc',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'grcdoble',
			capa: 'cuadrante_2',
			imagen: 'Grc_2_Doble_Cojin2.png'
		},
		{
			id: 221,
			parentid: 4,
			subparentid: null,
			defecto: true,
			nombre: 'Funda de cuadrante algodón orgánico Blanco',
			sku: 'besto/55x55/bco',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'bco',
			capa: 'cuadrante_2',
			imagen: 'Bco_Doble_Cojin2.png'
		},

		{
			id: 1016,
			parentid: 4,
			subparentid: null,
			defecto: true,
			nombre: 'Funda de cuadrante algodón orgánico Verde Oscuro',
			sku: 'BESTO/55X55/VOS',
			precio: 15,
			premium: 12.90,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'gre',
			capa: 'cuadrante_2',
			imagen: 'Dark_Green_Doble_Cojin2.png'
		},

		{
			id: 1517,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Lila Claro',
			sku: 'BESTO/55X55/LIC',
			precio: 18,
			premium: 15.99,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'lic',
			capa: 'cuadrante_2',
			imagen: 'Lic_Doble_Cojin2.png'
		},
		{
			id: 222,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Aqua',
			sku: 'besto/55x55/aqu',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'aqu',
			capa: 'cuadrante_2',
			imagen: 'Agu_Doble_Cojin2.png'
		},
		{
			id: 223,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Amarillo',
			sku: 'besto/55x55/ama',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'ama',
			capa: 'cuadrante_2',
			imagen: 'Ama_Doble_Cojin2.png'
		},
		{
			id: 224,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Rosa',
			sku: 'besto/55x55/ros',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'ros',
			capa: 'cuadrante_2',
			imagen: 'Ros_Doble_Cojin2.png'
		},
		{
			id: 225,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Azul Oscuro',
			sku: 'besto/55x55/azd',
			precio: 27,
			premium: 19.90,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'azd',
			capa: 'cuadrante_2',
			imagen: 'Azd_Doble_Cojin2.png'
		},
		{
			id: 226,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Gris Ceniza Oscuro',
			sku: 'besto/55x55/cen',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'grz',
			capa: 'cuadrante_2',
			imagen: 'Grz_Doble_Cojin2.png'
		},
		{
			id: 227,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Gris Piedra',
			sku: 'bestobic/55x55/pie',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'piedoble',
			capa: 'cuadrante_2',
			imagen: 'Pie_Doble_Cojin2.png'
		},
		{
			id: 228,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Azul',
			sku: 'bestobic/55x55/azu',
			precio: 27,
			premium: 19.90,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'azudoble',
			capa: 'cuadrante_2',
			imagen: 'Azu_Doble_Cojin2.png'
		},
		{
			id: 229,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Gris Claro',
			sku: 'bestobic/55x55/grc',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'grcdoble',
			capa: 'cuadrante_2',
			imagen: 'Grc_2_Doble_Cojin2.png'
		},


	];

	var shopifyProducts = [

		{
			"productId": 8076086444250,
			"variantId": 44138036232410,
			"sku": "ANREAL1/N50/UNI"
		},
		{
			"productId": 8076086444250,
			"variantId": 44138036265178,
			"sku": "ANREAL1/N70/UNI"
		},
		{
			"productId": 8076086444250,
			"variantId": 44138036297946,
			"sku": "ANREAL1/N80/UNI"
		},
		{
			"productId": 8076086444250,
			"variantId": 44138036330714,
			"sku": "ANREAL1/N90/UNI"
		},
		{
			"productId": 8076086444250,
			"variantId": 44138036363482,
			"sku": "ANREAL1/N135/UNI"
		},
		{
			"productId": 8076086837466,
			"variantId": 44138005692634,
			"sku": "BAMBU/N50/BCO"
		},
		{
			"productId": 8076086837466,
			"variantId": 44138005725402,
			"sku": "BAMBU/N70/BCO"
		},
		{
			"productId": 8076086837466,
			"variantId": 44138005758170,
			"sku": "BAMBU/N90/BCO"
		},
		{
			"productId": 8076086837466,
			"variantId": 44138005790938,
			"sku": "BAMBU/105/BCO"
		},
		{
			"productId": 8076087230682,
			"variantId": 44138033119450,
			"sku": "BASE1/50/BCO"
		},
		{
			"productId": 8076087230682,
			"variantId": 44138033152218,
			"sku": "BASE1/N70/BCO"
		},
		{
			"productId": 8076087230682,
			"variantId": 44138033184986,
			"sku": "BASE1/N80/BCO"
		},
		{
			"productId": 8076087230682,
			"variantId": 44138033217754,
			"sku": "BASE1/N90/BCO"
		},
		{
			"productId": 8076087820506,
			"variantId": 44137998483674,
			"sku": "BEST2/260X275/PIE"
		},
		{
			"productId": 8076088410330,
			"variantId": 44138032562394,
			"sku": "BESTO/90X200/BCO"
		},
		{
			"productId": 8076088410330,
			"variantId": 44138032595162,
			"sku": "BESTO/105X200/BCO"
		},
		{
			"productId": 8076088410330,
			"variantId": 44138032627930,
			"sku": "BESTO/135X200/BCO"
		},
		{
			"productId": 8076088410330,
			"variantId": 44138032660698,
			"sku": "BESTO/150X200/BCO"
		},
		{
			"productId": 8076088410330,
			"variantId": 44138032693466,
			"sku": "BESTO/180X200/BCO"
		},
		{
			"productId": 8076088410330,
			"variantId": 44138032726234,
			"sku": "BESTO/200X200/BCO"
		},
		{
			"productId": 8076088443098,
			"variantId": 44138019750106,
			"sku": "BESTO/90X200/GRC"
		},
		{
			"productId": 8076088443098,
			"variantId": 44138019782874,
			"sku": "BESTO/105X200/GRC"
		},
		{
			"productId": 8076088443098,
			"variantId": 44138019815642,
			"sku": "BESTO/135X200/GRC"
		},
		{
			"productId": 8076088443098,
			"variantId": 44138019848410,
			"sku": "BESTO/150X200/GRC"
		},
		{
			"productId": 8076088443098,
			"variantId": 44138019881178,
			"sku": "BESTO/180X200/GRC"
		},
		{
			"productId": 8076088475866,
			"variantId": 44138058973402,
			"sku": "BESTO/90X200/PIE"
		},
		{
			"productId": 8076088475866,
			"variantId": 44138059006170,
			"sku": "BESTO/105X200/PIE"
		},
		{
			"productId": 8076088475866,
			"variantId": 44138059038938,
			"sku": "BESTO/135X200/PIE"
		},
		{
			"productId": 8076088475866,
			"variantId": 44138059071706,
			"sku": "BESTO/150X200/PIE"
		},
		{
			"productId": 8076088475866,
			"variantId": 44138059104474,
			"sku": "BESTO/180X200/PIE"
		},
		{
			"productId": 8076088508634,
			"variantId": 44138052157658,
			"sku": "BESTO/90X200/AMA"
		},
		{
			"productId": 8076088508634,
			"variantId": 44138052190426,
			"sku": "BESTO/135X200/AMA"
		},
		{
			"productId": 8076088508634,
			"variantId": 44138052223194,
			"sku": "BESTO/150X200/AMA"
		},
		{
			"productId": 8076088508634,
			"variantId": 44138052255962,
			"sku": "BESTO/180X200/AMA"
		}, /**/
		{
			"ID": 14873876463995,
			"variantId": 54900467532155,
			"sku": "BESTO/90X200/AMC"
		},
		{
			"ID": 14873876463995,
			"variantId": 54900467564923,
			"sku": "BESTO/135X200/AMC"
		},
		{
			"ID": 14873876463995,
			"variantId": 54900467597691,
			"sku": "BESTO/150X200/AMC"
		},
		{
			"ID": 14873876463995,
			"variantId": 54900467630459,
			"sku": "BESTO/180X200/AMC"
		}, /**/
		{
			"productId": 8076088541402,
			"variantId": 44138046914778,
			"sku": "BESTO/90X200/AQU"
		},
		{
			"productId": 8076088541402,
			"variantId": 44138046947546,
			"sku": "BESTO/135X200/AQU"
		},
		{
			"productId": 8076088541402,
			"variantId": 44138046980314,
			"sku": "BESTO/150X200/AQU"
		},
		{
			"productId": 8076088541402,
			"variantId": 44138047013082,
			"sku": "BESTO/180X200/AQU"
		},
		{
			"productId": 8076088574170,
			"variantId": 44138029187290,
			"sku": "BESTO/90X200/AZC"
		},
		{
			"productId": 8076088574170,
			"variantId": 44138029220058,
			"sku": "BESTO/135X200/AZC"
		},
		{
			"productId": 8076088574170,
			"variantId": 44138029252826,
			"sku": "BESTO/150X200/AZC"
		},
		{
			"productId": 8076088574170,
			"variantId": 44138029285594,
			"sku": "BESTO/180X200/AZC"
		},
		{
			"productId": 8076088606938,
			"variantId": 44138020700378,
			"sku": "BESTO/90X200/AZD"
		},
		{
			"productId": 8076088606938,
			"variantId": 44138020733146,
			"sku": "BESTO/135X200/AZD"
		},
		{
			"productId": 8076088606938,
			"variantId": 44138020765914,
			"sku": "BESTO/150X200/AZD"
		},
		{
			"productId": 8076088606938,
			"variantId": 44138020798682,
			"sku": "BESTO/180X200/AZD"
		},
		{
			"productId": 8076088672474,
			"variantId": 44138019193050,
			"sku": "BESTO/90X200/CEN"
		},
		{
			"productId": 8076088672474,
			"variantId": 44138019225818,
			"sku": "BESTO/135X200/CEN"
		},
		{
			"productId": 8076088672474,
			"variantId": 44138019258586,
			"sku": "BESTO/150X200/CEN"
		},
		{
			"productId": 8076088672474,
			"variantId": 44138019291354,
			"sku": "BESTO/180X200/CEN"
		},
		{
			"productId": 8076088705242,
			"variantId": 44138023583962,
			"sku": "BESTO/90X200/GRZ"
		},
		{
			"productId": 8076088705242,
			"variantId": 44138023616730,
			"sku": "BESTO/135X200/GRZ"
		},
		{
			"productId": 8076088705242,
			"variantId": 44138023649498,
			"sku": "BESTO/150X200/GRZ"
		},
		{
			"productId": 8076088705242,
			"variantId": 44138023682266,
			"sku": "BESTO/180X200/GRZ"
		},
		{
			"productId": 8076088738010,
			"variantId": 44138056286426,
			"sku": "BESTO/90X200/ROS"
		},
		{
			"productId": 8076088738010,
			"variantId": 44138056319194,
			"sku": "BESTO/135X200/ROS"
		},
		{
			"productId": 8076088738010,
			"variantId": 44138056351962,
			"sku": "BESTO/150X200/ROS"
		},
		{
			"productId": 8076088738010,
			"variantId": 44138056384730,
			"sku": "BESTO/180X200/ROS"
		},
		{
			"productId": 8076088803546,
			"variantId": 44138035282138,
			"sku": "BESTO/90X200/VOS"
		},
		{
			"productId": 8076088803546,
			"variantId": 44138035314906,
			"sku": "BESTO/135X200/VOS"
		},
		{
			"productId": 8076088803546,
			"variantId": 44138035347674,
			"sku": "BESTO/150X200/VOS"
		},
		{
			"productId": 8076088803546,
			"variantId": 44138035380442,
			"sku": "BESTO/180X200/VOS"
		},
		{
			"productId": 8076089262298,
			"variantId": 44138039804122,
			"sku": "BESTO/260X275/BCO"
		},
		{
			"productId": 8076089295066,
			"variantId": 44138009395418,
			"sku": "BESTO/260X275/PIE"
		},
		{
			"productId": 8076087525594,
			"variantId": 44138020471002,
			"sku": "BEST2/90X200/BCO"
		},
		{
			"productId": 8076087525594,
			"variantId": 44138020503770,
			"sku": "BEST2/105X200/BCO"
		},
		{
			"productId": 8076087525594,
			"variantId": 44138020536538,
			"sku": "BEST2/135X200/BCO"
		},
		{
			"productId": 8076087525594,
			"variantId": 44138020569306,
			"sku": "BEST2/150X200/BCO"
		},
		{
			"productId": 8076087525594,
			"variantId": 44138020602074,
			"sku": "BEST2/180X200/BCO"
		},
		{
			"productId": 8076087525594,
			"variantId": 44138020634842,
			"sku": "BEST2/200X200/BCO"
		},
		{
			"productId": 8076087558362,
			"variantId": 44138034004186,
			"sku": "BEST2/90X200/PIE"
		},
		{
			"productId": 8076087558362,
			"variantId": 44138034036954,
			"sku": "BEST2/105X200/PIE"
		},
		{
			"productId": 8076087558362,
			"variantId": 44138034069722,
			"sku": "BEST2/135X200/PIE"
		},
		{
			"productId": 8076087558362,
			"variantId": 44138034102490,
			"sku": "BEST2/150X200/PIE"
		},
		{
			"productId": 8076087558362,
			"variantId": 44138034135258,
			"sku": "BEST2/180X200/PIE"
		},
		{
			"productId": 8076087591130,
			"variantId": 44137997074650,
			"sku": "BEST2/90X200/GRC"
		},
		{
			"productId": 8076087591130,
			"variantId": 44137997107418,
			"sku": "BEST2/135X200/GRC"
		},
		{
			"productId": 8076087591130,
			"variantId": 44137997140186,
			"sku": "BEST2/150X200/GRC"
		},
		{
			"productId": 8076087591130,
			"variantId": 44137997172954,
			"sku": "BEST2/180X200/GRC"
		},
		{
			"productId": 8076087787738,
			"variantId": 44138041311450,
			"sku": "BEST2/260X275/BCO"
		},
		{
			"productId": 8076099682522,
			"variantId": 44138017718490,
			"sku": "RITZI/90X200/BCO"
		},
		{
			"productId": 8076099682522,
			"variantId": 44138017751258,
			"sku": "RITZI/135X200/BCO"
		},
		{
			"productId": 8076099682522,
			"variantId": 44138017784026,
			"sku": "RITZI/150X200/BCO"
		},
		{
			"productId": 8076099682522,
			"variantId": 44138017816794,
			"sku": "RITZI/180X200/BCO"
		},
		{
			"productId": 8076099682522,
			"variantId": 44138017849562,
			"sku": "RITZI/200X200/BCO"
		},
		{
			"productId": 8076099715290,
			"variantId": 44137998811354,
			"sku": "RITZI/90X200/GRI"
		},
		{
			"productId": 8076099715290,
			"variantId": 44137998844122,
			"sku": "RITZI/135X200/GRI"
		},
		{
			"productId": 8076099715290,
			"variantId": 44137998876890,
			"sku": "RITZI/150X200/GRI"
		},
		{
			"productId": 8076099715290,
			"variantId": 44137998909658,
			"sku": "RITZI/180X200/GRI"
		},
		{
			"productId": 8076099715290,
			"variantId": 44137998942426,
			"sku": "RITZI/200X200/GRI"
		},
		{
			"productId": 8076077564122,
			"variantId": 44138076766426,
			"sku": "GAFRA/90X200/GRI"
		},
		{
			"productId": 8076077564122,
			"variantId": 44138076799194,
			"sku": "GAFRA/135X200/GRI"
		},
		{
			"productId": 8076077564122,
			"variantId": 44138076831962,
			"sku": "GAFRA/150X200/GRI"
		},
		{
			"productId": 8076077564122,
			"variantId": 44138076864730,
			"sku": "GAFRA/180X200/GRI"
		},
		{
			"productId": 8076094144730,
			"variantId": 44137993240794,
			"sku": "LINLOV/90X200/AGM"
		},
		{
			"productId": 8076094144730,
			"variantId": 44137993273562,
			"sku": "LINLOV/150X200/AGM"
		},
		{
			"productId": 8076094144730,
			"variantId": 44137993306330,
			"sku": "LINLOV/180X200/AGM"
		},
		{
			"productId": 8076094177498,
			"variantId": 44138022437082,
			"sku": "LINLOV/90X200/BCO"
		},
		{
			"productId": 8076094177498,
			"variantId": 44138022469850,
			"sku": "LINLOV/150X200/BCO"
		},
		{
			"productId": 8076094177498,
			"variantId": 44138022502618,
			"sku": "LINLOV/180X200/BCO"
		},
		{
			"productId": 8076094210266,
			"variantId": 44138046816474,
			"sku": "LINLOV/90X200/BEI"
		},
		{
			"productId": 8076094210266,
			"variantId": 44138046849242,
			"sku": "LINLOV/150X200/BEI"
		},
		{
			"productId": 8076094210266,
			"variantId": 44138046882010,
			"sku": "LINLOV/180X200/BEI"
		},
		{
			"productId": 8076094243034,
			"variantId": 44138030268634,
			"sku": "LINLOV/90X200/ROS"
		},
		{
			"productId": 8076094243034,
			"variantId": 44138030301402,
			"sku": "LINLOV/150X200/ROS"
		},
		{
			"productId": 8076094243034,
			"variantId": 44138030334170,
			"sku": "LINLOV/180X200/ROS"
		},
		{
			"productId": 8076094865626,
			"variantId": 44138038919386,
			"sku": "LINO/90X200/BCO"
		},
		{
			"productId": 8076094865626,
			"variantId": 44138038952154,
			"sku": "LINO/150X200/BCO"
		},
		{
			"productId": 8076094865626,
			"variantId": 44138038984922,
			"sku": "LINO/180X200/BCO"
		},
		{
			"productId": 8076090343642,
			"variantId": 44138028990682,
			"sku": "BESTPUNT/90X190/BCO"
		},
		{
			"productId": 8076090343642,
			"variantId": 44138029023450,
			"sku": "BESTPUNT/105X190/BCO"
		},
		{
			"productId": 8076090343642,
			"variantId": 44138029056218,
			"sku": "BESTPUNT/135X190/BCO"
		},
		{
			"productId": 8076090343642,
			"variantId": 44138029088986,
			"sku": "BESTPUNT/150X190/BCO"
		},
		{
			"productId": 8076090343642,
			"variantId": 44138029121754,
			"sku": "BESTPUNT/180X200/BCO"
		},
		{
			"productId": 8076090343642,
			"variantId": 44138029154522,
			"sku": "BESTPUNT/200X200/BCO"
		},
		{
			"productId": 8076090376410,
			"variantId": 44138059694298,
			"sku": "BESTPUNT/90X190/GRI"
		},
		{
			"productId": 8076090376410,
			"variantId": 44138059727066,
			"sku": "BESTPUNT/105X190/GRI"
		},
		{
			"productId": 8076090376410,
			"variantId": 44138059759834,
			"sku": "BESTPUNT/135X190/GRI"
		},
		{
			"productId": 8076090376410,
			"variantId": 44138059792602,
			"sku": "BESTPUNT/150X190/GRI"
		},
		{
			"productId": 8076090376410,
			"variantId": 44138059825370,
			"sku": "BESTPUNT/180X200/GRI"
		},
		{
			"productId": 8076090376410,
			"variantId": 44138059858138,
			"sku": "BESTPUNT/200X200/GRI"
		},
		{
			"productId": 8076090441946,
			"variantId": 44138001432794,
			"sku": "BESTPUNT/90X190/PIE"
		},
		{
			"productId": 8076090441946,
			"variantId": 44138001465562,
			"sku": "BESTPUNT/105X190/PIE"
		},
		{
			"productId": 8076090441946,
			"variantId": 44138001498330,
			"sku": "BESTPUNT/135X190/PIE"
		},
		{
			"productId": 8076090441946,
			"variantId": 44138001531098,
			"sku": "BESTPUNT/150X190/PIE"
		},
		{
			"productId": 8076090441946,
			"variantId": 44138001563866,
			"sku": "BESTPUNT/180X200/PIE"
		},
		{
			"productId": 8076090441946,
			"variantId": 44138001596634,
			"sku": "BESTPUNT/200X200/PIE"
		},
		{
			"productId": 8076078743770,
			"variantId": 44138069098714,
			"sku": "JERCORA/90X200/AZU"
		},
		{
			"productId": 8076078743770,
			"variantId": 44138069131482,
			"sku": "JERCORA/105x200/AZU"
		},
		{
			"productId": 8076078743770,
			"variantId": 44138069164250,
			"sku": "JERCORA/135X200/AZU"
		},
		{
			"productId": 8076078743770,
			"variantId": 44138069197018,
			"sku": "JERCORA/150X200/AZU"
		},
		{
			"productId": 8076078743770,
			"variantId": 44138069229786,
			"sku": "JERCORA/180X200/AZU"
		},
		{
			"productId": 8076082970842,
			"variantId": 44138068377818,
			"sku": "PUNTIBA/90X200/ROO"
		},
		{
			"productId": 8076082970842,
			"variantId": 44138068410586,
			"sku": "PUNTIBA/105X200/ROO"
		},
		{
			"productId": 8076082970842,
			"variantId": 44138068443354,
			"sku": "PUNTIBA/135X200/ROO"
		},
		{
			"productId": 8076082970842,
			"variantId": 44138068476122,
			"sku": "PUNTIBA/150X200/ROO"
		},
		{
			"productId": 8076082970842,
			"variantId": 44138068508890,
			"sku": "PUNTIBA/180X200/ROO"
		},
		{
			"productId": 8076083003610,
			"variantId": 44138077257946,
			"sku": "PUNTIBA/90X200/KAK"
		},
		{
			"productId": 8076083003610,
			"variantId": 44138077290714,
			"sku": "PUNTIBA/105X200/KAK"
		},
		{
			"productId": 8076083003610,
			"variantId": 44138077323482,
			"sku": "PUNTIBA/135X200/KAK"
		},
		{
			"productId": 8076083003610,
			"variantId": 44138077356250,
			"sku": "PUNTIBA/150X200/KAK"
		},
		{
			"productId": 8076083003610,
			"variantId": 44138077389018,
			"sku": "PUNTIBA/180X200/KAK"
		},
		{
			"productId": 8076099289306,
			"variantId": 44138064085210,
			"sku": "PULIS/90X200/GRI"
		},
		{
			"productId": 8076099289306,
			"variantId": 44138064117978,
			"sku": "PULIS/105X200/GRI"
		},
		{
			"productId": 8076099289306,
			"variantId": 44138064150746,
			"sku": "PULIS/135X200/GRI"
		},
		{
			"productId": 8076099289306,
			"variantId": 44138064183514,
			"sku": "PULIS/150X200/GRI"
		},
		{
			"productId": 8076099289306,
			"variantId": 44138064216282,
			"sku": "PULIS/180X200/GRI"
		},
		{
			"productId": 8076099420378,
			"variantId": 44138097508570,
			"sku": "PULIS2/90X200/GRI"
		},
		{
			"productId": 8076099420378,
			"variantId": 44138097541338,
			"sku": "PULIS2/105X200/GRI"
		},
		{
			"productId": 8076099420378,
			"variantId": 44138097574106,
			"sku": "PULIS2/135X200/GRI"
		},
		{
			"productId": 8076099420378,
			"variantId": 44138097606874,
			"sku": "PULIS2/150X200/GRI"
		},
		{
			"productId": 8076099420378,
			"variantId": 44138097639642,
			"sku": "PULIS2/180X200/GRI"
		},
		{
			"productId": 8076086116570,
			"variantId": 44138101309658,
			"sku": "ALBA/22X28/NAT"
		},
		{
			"productId": 8076086116570,
			"variantId": 44138101342426,
			"sku": "ALBA/25X32/NAT"
		},
		{
			"productId": 8076086116570,
			"variantId": 44138101375194,
			"sku": "ALBA/30X40/NAT"
		},
		{
			"productId": 8076102467802,
			"variantId": 44138022863066,
			"sku": "TUAR/55X55/GRI"
		},
		{
			"productId": 8076093522138,
			"variantId": 44138061037786,
			"sku": "GRISFU/55X55/CRU"
		},
		{
			"productId": 8076079431898,
			"variantId": 44138074734810,
			"sku": "KINGNAU/180X260/AZU"
		},
		{
			"productId": 8076079431898,
			"variantId": 44138074767578,
			"sku": "KINGNAU/240X270/AZU"
		},
		{
			"productId": 8076079431898,
			"variantId": 44138074800346,
			"sku": "KINGNAU/260X270/AZU"
		},
		{
			"productId": 8076092539098,
			"variantId": 44138031055066,
			"sku": "DEBORAH/180X260/CRU"
		},
		{
			"productId": 8076092539098,
			"variantId": 44138031087834,
			"sku": "DEBORAH/240X270/CRU"
		},
		{
			"productId": 8076092539098,
			"variantId": 44138031120602,
			"sku": "DEBORAH/260X270/CRU"
		},
		{
			"productId": 8076080939226,
			"variantId": 44138067099866,
			"sku": "NONA/180X260/BEI"
		},
		{
			"productId": 8076080939226,
			"variantId": 44138067132634,
			"sku": "NONA/240X270/BEI"
		},
		{
			"productId": 8076080939226,
			"variantId": 44138067165402,
			"sku": "NONA/260X270/BEI"
		},
		{
			"productId": 8076091195610,
			"variantId": 44138096427226,
			"sku": "CHERANCOB/180X260/GRI"
		},
		{
			"productId": 8076091195610,
			"variantId": 44138096459994,
			"sku": "CHERANCOB/240X270/GRI"
		},
		{
			"productId": 8076091195610,
			"variantId": 44138096492762,
			"sku": "CHERANCOB/260X270/GRI"
		},
		{
			"productId": 8076101877978,
			"variantId": 44138047602906,
			"sku": "SUNCOL/180X260/BCO"
		},
		{
			"productId": 8076101877978,
			"variantId": 44138047635674,
			"sku": "SUNCOL/240X270/BCO"
		},
		{
			"productId": 8076101877978,
			"variantId": 44138047668442,
			"sku": "SUNCOL/260X270/BCO"
		},
		{
			"productId": 8076101910746,
			"variantId": 44138042884314,
			"sku": "SUNCOL/180X260/PIE"
		},
		{
			"productId": 8076101910746,
			"variantId": 44138042917082,
			"sku": "SUNCOL/240X270/PIE"
		},
		{
			"productId": 8076101910746,
			"variantId": 44138042949850,
			"sku": "SUNCOL/260X270/PIE"
		},
		{
			"productId": 8076102336730,
			"variantId": 44137994256602,
			"sku": "TUAR/180X280/BCO"
		},
		{
			"productId": 8076102336730,
			"variantId": 44137994289370,
			"sku": "TUAR/240X280/BCO"
		},
		{
			"productId": 8076102336730,
			"variantId": 44137994322138,
			"sku": "TUAR/260X280/BCO"
		},
		{
			"productId": 8076102369498,
			"variantId": 44138041704666,
			"sku": "TUAR/180X280/GRI"
		},
		{
			"productId": 8076102369498,
			"variantId": 44138041737434,
			"sku": "TUAR/240X280/GRI"
		},
		{
			"productId": 8076102369498,
			"variantId": 44138041770202,
			"sku": "TUAR/260X280/GRI"
		},
		{
			"productId": 8076102402266,
			"variantId": 44137996484826,
			"sku": "TUAR/180X280/PIE"
		},
		{
			"productId": 8076102402266,
			"variantId": 44137996517594,
			"sku": "TUAR/240X280/PIE"
		},
		{
			"productId": 8076102402266,
			"variantId": 44137996550362,
			"sku": "TUAR/260X280/PIE"
		},
		{
			"productId": 8076094013658,
			"variantId": 44138029973722,
			"sku": "LINET/180X260/BEI"
		},
		{
			"productId": 8076094013658,
			"variantId": 44138030006490,
			"sku": "LINET/240X270/BEI"
		},
		{
			"productId": 8076094013658,
			"variantId": 44138030039258,
			"sku": "LINET/290X270/BEI"
		},
		{
			"productId": 8076094046426,
			"variantId": 44138038755546,
			"sku": "LINET/180X260/GRI"
		},
		{
			"productId": 8076094046426,
			"variantId": 44138038788314,
			"sku": "LINET/240X270/GRI"
		},
		{
			"productId": 8076086575322,
			"variantId": 44138029482202,
			"sku": "ARKANSAS/180X280/GRC"
		},
		{
			"productId": 8076086575322,
			"variantId": 44138029514970,
			"sku": "ARKANSAS/240X280/GRC"
		},
		{
			"productId": 8076086575322,
			"variantId": 44138029547738,
			"sku": "ARKANSAS/260X280/GRC"
		},
		{
			"productId": 8076086575322,
			"variantId": 44138029580506,
			"sku": "ARKANSAS/290X280/GRC"
		},
		{
			"productId": 8076086608090,
			"variantId": 44138041409754,
			"sku": "ARKANSAS/180X280/MRR"
		},
		{
			"productId": 8076086608090,
			"variantId": 44138041442522,
			"sku": "ARKANSAS/240X280/MRR"
		},
		{
			"productId": 8076086608090,
			"variantId": 44138041475290,
			"sku": "ARKANSAS/260X280/MRR"
		},
		{
			"productId": 8076106039514,
			"variantId": 44138072998106,
			"sku": "DIBETA/180X260/GRC"
		},
		{
			"productId": 8076106039514,
			"variantId": 44138073030874,
			"sku": "DIBETA/240X270/GRC"
		},
		{
			"productId": 8076106039514,
			"variantId": 44138073063642,
			"sku": "DIBETA/260X270/GRC"
		},
		{
			"productId": 8076106072282,
			"variantId": 44138063528154,
			"sku": "DIBETA/180X260/PIE"
		},
		{
			"productId": 8076106072282,
			"variantId": 44138063560922,
			"sku": "DIBETA/240X270/PIE"
		},
		{
			"productId": 8076106072282,
			"variantId": 44138063593690,
			"sku": "DIBETA/260X270/PIE"
		},
		{
			"productId": 8076079235290,
			"variantId": 44138072604890,
			"sku": "KING/180X260/PIO"
		},
		{
			"productId": 8076079235290,
			"variantId": 44138072637658,
			"sku": "KING/240X270/PIO"
		},
		{
			"productId": 8076079235290,
			"variantId": 44138072670426,
			"sku": "KING/260X270/PIO"
		},
		{
			"productId": 8076079268058,
			"variantId": 44138063986906,
			"sku": "KING/180X260/VER"
		},
		{
			"productId": 8076079268058,
			"variantId": 44138064019674,
			"sku": "KING/240X270/VER"
		},
		{
			"productId": 8076079268058,
			"variantId": 44138064052442,
			"sku": "KING/260X270/VER"
		},
		{
			"productId": 8076078088410,
			"variantId": 44138070573274,
			"sku": "GAPATCOL/180X260/ROS"
		},
		{
			"productId": 8076078088410,
			"variantId": 44138070606042,
			"sku": "GAPATCOL/240X270/ROS"
		},
		{
			"productId": 8076078088410,
			"variantId": 44138070638810,
			"sku": "GAPATCOL/260X270/ROS"
		},
		{
			"productId": 8076083265754,
			"variantId": 44138064380122,
			"sku": "RUSTCOL/180X260/CAM"
		},
		{
			"productId": 8076083265754,
			"variantId": 44138064412890,
			"sku": "RUSTCOL/240X270/CAM"
		},
		{
			"productId": 8076083265754,
			"variantId": 44138064445658,
			"sku": "RUSTCOL/260X270/CAM"
		},
		{
			"productId": 8076083298522,
			"variantId": 44138071130330,
			"sku": "RUSTCOL/180X260/ROP"
		},
		{
			"productId": 8076083298522,
			"variantId": 44138071163098,
			"sku": "RUSTCOL/240X270/ROP"
		},
		{
			"productId": 8076083298522,
			"variantId": 44138071195866,
			"sku": "RUSTCOL/260X270/ROP"
		},
		{
			"productId": 8076085657818,
			"variantId": 44138073096410,
			"sku": "VAPATCOL/180X260/AZU"
		},
		{
			"productId": 8076085657818,
			"variantId": 44138073129178,
			"sku": "VAPATCOL/240X270/AZU"
		},
		{
			"productId": 8076085657818,
			"variantId": 44138073161946,
			"sku": "VAPATCOL/260X270/AZU"
		},
		{
			"productId": 8076082905306,
			"variantId": 44138063888602,
			"sku": "PUNCOL/180X260/GRI"
		},
		{
			"productId": 8076082905306,
			"variantId": 44138063921370,
			"sku": "PUNCOL/240X270/GRI"
		},
		{
			"productId": 8076082905306,
			"variantId": 44138063954138,
			"sku": "PUNCOL/260X270/GRI"
		},
		{
			"productId": 8076081660122,
			"variantId": 44138072113370,
			"sku": "PORTUX/180X260/GRI"
		},
		{
			"productId": 8076081660122,
			"variantId": 44138072146138,
			"sku": "PORTUX/240X270/GRI"
		},
		{
			"productId": 8076081660122,
			"variantId": 44138072178906,
			"sku": "PORTUX/260X270/GRI"
		},
		{
			"productId": 8076098928858,
			"variantId": 44138044883162,
			"sku": "PANAL/90X200/BCO"
		},
		{
			"productId": 8076098928858,
			"variantId": 44138044915930,
			"sku": "PANAL/150X200/BCO"
		},
		{
			"productId": 8076098928858,
			"variantId": 44138044948698,
			"sku": "PANAL/180X200/BCO"
		},
		{
			"productId": 8076098928858,
			"variantId": 44138044981466,
			"sku": "PANAL/160X200/BCO"
		},
		{
			"productId": 8076095160538,
			"variantId": 44137999106266,
			"sku": "LUXOR/90X200/BCO"
		},
		{
			"productId": 8076095160538,
			"variantId": 44137999139034,
			"sku": "LUXOR/135X200/BCO"
		},
		{
			"productId": 8076095160538,
			"variantId": 44137999171802,
			"sku": "LUXOR/150X200/BCO"
		},
		{
			"productId": 8076095160538,
			"variantId": 44137999204570,
			"sku": "LUXOR/180X200/BCO"
		},
		{
			"productId": 8076095160538,
			"variantId": 44137999237338,
			"sku": "LUXOR/160X200/BCO"
		},
		{
			"productId": 8076086051034,
			"variantId": 44138065985754,
			"sku": "AGOH/180X280/BEI"
		},
		{
			"productId": 8076086051034,
			"variantId": 44138066018522,
			"sku": "AGOH/240X280/BEI"
		},
		{
			"productId": 8076086083802,
			"variantId": 44138095411418,
			"sku": "AGOH/180X280/GRI"
		},
		{
			"productId": 8076086083802,
			"variantId": 44138095444186,
			"sku": "AGOH/240X280/GRI"
		},
		{
			"productId": 8076093456602,
			"variantId": 44138061103322,
			"sku": "GRISFU/180X280/CRU"
		},
		{
			"productId": 8076093456602,
			"variantId": 44138061136090,
			"sku": "GRISFU/240X280/CRU"
		},
		{
			"productId": 8076093489370,
			"variantId": 44138060611802,
			"sku": "GRISFU/180X280/GRC"
		},
		{
			"productId": 8076093489370,
			"variantId": 44138060644570,
			"sku": "GRISFU/240X280/GRC"
		},
		{
			"productId": 8076102041818,
			"variantId": 44138028302554,
			"sku": "TEXBROD/45X95/BCO"
		},
		{
			"productId": 8076102041818,
			"variantId": 44138028335322,
			"sku": "TEXBROD/45X145/BCO"
		},
		{
			"productId": 8076102041818,
			"variantId": 44138028368090,
			"sku": "TEXBROD/SETDE2:50X75/BCO"
		},
		{
			"productId": 8076098535642,
			"variantId": 44138007134426,
			"sku": "OXFI/45X110/BCO"
		},
		{
			"productId": 8076098535642,
			"variantId": 44138007167194,
			"sku": "OXFI/45X160/BCO"
		},
		{
			"productId": 8076098535642,
			"variantId": 44138007199962,
			"sku": "OXFI/SETDE2:50X85/BCO"
		},
		{
			"productId": 8076096209114,
			"variantId": 44138020896986,
			"sku": "MINIDOT/45X95/BCO"
		},
		{
			"productId": 8076096209114,
			"variantId": 44138020929754,
			"sku": "MINIDOT/45X145/BCO"
		},
		{
			"productId": 8076096209114,
			"variantId": 44138020962522,
			"sku": "MINIDOT/SETDE2:50X75/BCO"
		},
		{
			"productId": 8150094020826,
			"variantId": 44315922071770,
			"sku": "FERDA/45X110/VER"
		},
		{
			"productId": 8150094020826,
			"variantId": 44315922104538,
			"sku": "FERDA/45X160/VER"
		},
		{
			"productId": 8150094020826,
			"variantId": 44315922137306,
			"sku": "FERDA/SETDE2:50X85/VER"
		},
		{
			"productId": 8076077957338,
			"variantId": 44138071949530,
			"sku": "GAPAT/45X110/ROS"
		},
		{
			"productId": 8076077957338,
			"variantId": 44138071982298,
			"sku": "GAPAT/45X160/ROS"
		},
		{
			"productId": 8076077957338,
			"variantId": 44138072015066,
			"sku": "GAPAT/SETDE2:50X85/ROS"
		},
		{
			"productId": 8076077596890,
			"variantId": 44138073719002,
			"sku": "GAFRA/45X110/GRI"
		},
		{
			"productId": 8076077596890,
			"variantId": 44138073751770,
			"sku": "GAFRA/45X160/GRI"
		},
		{
			"productId": 8076077596890,
			"variantId": 44138073784538,
			"sku": "GAFRA/SETDE2:50X85/GRI"
		},
		{
			"productId": 8076092866778,
			"variantId": 44138032169178,
			"sku": "ELEMENT/45X95/GRI"
		},
		{
			"productId": 8076092866778,
			"variantId": 44138032201946,
			"sku": "ELEMENT/45X145/GRI"
		},
		{
			"productId": 8076092866778,
			"variantId": 44138032234714,
			"sku": "ELEMENT/SETDE2:50X75/GRI"
		},
		{
			"productId": 8150094053594,
			"variantId": 44315922628826,
			"sku": "LARI/45X110/AZU"
		},
		{
			"productId": 8150094053594,
			"variantId": 44315922661594,
			"sku": "LARI/45X160/AZU"
		},
		{
			"productId": 8150094053594,
			"variantId": 44315922694362,
			"sku": "LARI/SETDE2:50X85/AZU"
		},
		{
			"productId": 8076084936922,
			"variantId": 44138075193562,
			"sku": "VALETI/45X95/AZU"
		},
		{
			"productId": 8076084936922,
			"variantId": 44138075226330,
			"sku": "VALETI/45X145/AZU"
		},
		{
			"productId": 8076084936922,
			"variantId": 44138075259098,
			"sku": "VALETI/SETDE2:50X75/AZU"
		},
		{
			"productId": 8076089491674,
			"variantId": 44138062643418,
			"sku": "BESTO/45X110/AMA"
		},
		{
			"productId": 8076089491674,
			"variantId": 44138062676186,
			"sku": "BESTO/45X160/AMA"
		},
		{
			"productId": 8076089491674,
			"variantId": 44138062708954,
			"sku": "BESTO/50X85/AMA"
		},
		{
			"productId": 8076089557210,
			"variantId": 44138061922522,
			"sku": "BESTO/45X110/AQU"
		},
		{
			"productId": 8076089557210,
			"variantId": 44138061955290,
			"sku": "BESTO/45X160/AQU"
		},
		{
			"productId": 8076089557210,
			"variantId": 44138061988058,
			"sku": "BESTO/50X85/AQU"
		},
		{
			"productId": 8076089589978,
			"variantId": 44138061824218,
			"sku": "BESTO/45X110/AZD"
		},
		{
			"productId": 8076089589978,
			"variantId": 44138061856986,
			"sku": "BESTO/45X160/AZD"
		},
		{
			"productId": 8076089589978,
			"variantId": 44138061889754,
			"sku": "BESTO/50X85/AZD"
		},
		{
			"productId": 8076089622746,
			"variantId": 44138062020826,
			"sku": "BESTO/45X110/AZU"
		},
		{
			"productId": 8076089622746,
			"variantId": 44138062053594,
			"sku": "BESTO/45X160/AZU"
		},
		{
			"productId": 8076089622746,
			"variantId": 44138062086362,
			"sku": "BESTO/50X85/AZU"
		},
		{
			"productId": 8076089655514,
			"variantId": 44138061725914,
			"sku": "BESTO/45X110/CEN"
		},
		{
			"productId": 8076089655514,
			"variantId": 44138061758682,
			"sku": "BESTO/45X160/CEN"
		},
		{
			"productId": 8076089655514,
			"variantId": 44138061791450,
			"sku": "BESTO/50X85/CEN"
		},
		{
			"productId": 8076089688282,
			"variantId": 44138061299930,
			"sku": "BESTO/45X110/GRC"
		},
		{
			"productId": 8076089688282,
			"variantId": 44138061332698,
			"sku": "BESTO/45X160/GRC"
		},
		{
			"productId": 8076089688282,
			"variantId": 44138061365466,
			"sku": "BESTO/50X85/GRC"
		},
		{
			"productId": 8076089688282,
			"variantId": 44138061398234,
			"sku": "BESTO/45X125/GRC"
		},
		{
			"productId": 8076089721050,
			"variantId": 44138063036634,
			"sku": "BESTO/45X110/GRZ"
		},
		{
			"productId": 8076089721050,
			"variantId": 44138063069402,
			"sku": "BESTO/45X160/GRZ"
		},
		{
			"productId": 8076089721050,
			"variantId": 44138063102170,
			"sku": "BESTO/50X85/GRZ"
		},
		{
			"productId": 8076089753818,
			"variantId": 44138062512346,
			"sku": "BESTO/45X110/PIE"
		},
		{
			"productId": 8076089753818,
			"variantId": 44138062545114,
			"sku": "BESTO/45X160/PIE"
		},
		{
			"productId": 8076089753818,
			"variantId": 44138062577882,
			"sku": "BESTO/50X85/PIE"
		},
		{
			"productId": 8076089753818,
			"variantId": 44138062610650,
			"sku": "BESTO/45X125/PIE"
		},
		{
			"productId": 8076089786586,
			"variantId": 44138062938330,
			"sku": "BESTO/45X110/ROS"
		},
		{
			"productId": 8076089786586,
			"variantId": 44138062971098,
			"sku": "BESTO/45X160/ROS"
		},
		{
			"productId": 8076089786586,
			"variantId": 44138063003866,
			"sku": "BESTO/50X85/ROS"
		},
		{
			"productId": 8076089819354,
			"variantId": 44138061168858,
			"sku": "BESTO/45X110/VOS"
		},
		{
			"productId": 8076089819354,
			"variantId": 44138061201626,
			"sku": "BESTO/45X160/VOS"
		},
		{
			"productId": 8076089819354,
			"variantId": 44138061234394,
			"sku": "BESTO/50X85/VOS"
		},
		{
			"productId": 8076089852122,
			"variantId": 44138061594842,
			"sku": "BESTO1/45X110/BCO"
		},
		{
			"productId": 8076089852122,
			"variantId": 44138061627610,
			"sku": "BESTO1/45X160/BCO"
		},
		{
			"productId": 8076089852122,
			"variantId": 44138061660378,
			"sku": "BESTO/50X85/BCO"
		},
		{
			"productId": 8076089852122,
			"variantId": 44138061693146,
			"sku": "BESTO/45X125/BCO"
		},
		{
			"productId": 8076092408026,
			"variantId": 44138028433626,
			"sku": "CROCHE/45X95/BCO"
		},
		{
			"productId": 8076092408026,
			"variantId": 44138028466394,
			"sku": "CROCHE/45X145/BCO"
		},
		{
			"productId": 8076092408026,
			"variantId": 44138028499162,
			"sku": "CROCHE/SETDE2:50X75/BCO"
		},
		{
			"productId": 8076087361754,
			"variantId": 44138062741722,
			"sku": "BEST2/45X110/BCO"
		},
		{
			"productId": 8076087361754,
			"variantId": 44138062774490,
			"sku": "BEST2/45X160/BCO"
		},
		{
			"productId": 8076087361754,
			"variantId": 44138062807258,
			"sku": "BEST/50X85/BCO"
		},
		{
			"productId": 8076087460058,
			"variantId": 44138062414042,
			"sku": "BEST2/45X110/GRZ"
		},
		{
			"productId": 8076087460058,
			"variantId": 44138062446810,
			"sku": "BEST2/45X160/GRZ"
		},
		{
			"productId": 8076087460058,
			"variantId": 44138062479578,
			"sku": "BEST/50X85/GRZ"
		},
		{
			"productId": 8076087492826,
			"variantId": 44138062840026,
			"sku": "BEST2/45X110/PIE"
		},
		{
			"productId": 8076087492826,
			"variantId": 44138062872794,
			"sku": "BEST2/45X160/PIE"
		},
		{
			"productId": 8076087492826,
			"variantId": 44138062905562,
			"sku": "BEST/50X85/PIE"
		},
		{
			"productId": 8076100305114,
			"variantId": 44138045604058,
			"sku": "SLABCO/45X95/BCO"
		},
		{
			"productId": 8076100305114,
			"variantId": 44138045636826,
			"sku": "SLABCO/45X145/BCO"
		},
		{
			"productId": 8076100305114,
			"variantId": 44138045669594,
			"sku": "SLABCO/SETDE2:50X75/BCO"
		},
		{
			"productId": 8076086804698,
			"variantId": 44137994125530,
			"sku": "ASIA/N50_CMS/BCO"
		},
		{
			"productId": 8076086804698,
			"variantId": 44137994158298,
			"sku": "ASIA/N70_CMS/BCO"
		},
		{
			"productId": 8076086804698,
			"variantId": 44137994191066,
			"sku": "ASIA/N80_CMS/BCO"
		},
		{
			"productId": 8076086804698,
			"variantId": 44137994223834,
			"sku": "ASIA/N90_CMS/BCO"
		},
		{
			"productId": 8076086280410,
			"variantId": 44138044457178,
			"sku": "AMI/45X95/GRI"
		},
		{
			"productId": 8076086280410,
			"variantId": 44138044489946,
			"sku": "AMI/45X145/GRI"
		},
		{
			"productId": 8076086280410,
			"variantId": 44138044522714,
			"sku": "AMI/SETDE2:50X75/GRI"
		},
		{
			"productId": 8076104925402,
			"variantId": 44138096623834,
			"sku": "BELTON2/45X110/PIE"
		},
		{
			"productId": 8076104925402,
			"variantId": 44138096656602,
			"sku": "BELTON2/45X160/PIE"
		},
		{
			"productId": 8076104925402,
			"variantId": 44138096689370,
			"sku": "BELTON2/SETDE2:50X85/PIE"
		},
		{
			"productId": 8076085461210,
			"variantId": 44138076143834,
			"sku": "VAPAT/45X110/AZU"
		},
		{
			"productId": 8076085461210,
			"variantId": 44138076176602,
			"sku": "VAPAT/45X160/AZU"
		},
		{
			"productId": 8076085461210,
			"variantId": 44138076209370,
			"sku": "VAPAT/SETDE2:50X85/AZU"
		},
		{
			"productId": 8076099879130,
			"variantId": 44138042228954,
			"sku": "RITZI/45X110/BCO"
		},
		{
			"productId": 8076099879130,
			"variantId": 44138042261722,
			"sku": "RITZI/45X160/BCO"
		},
		{
			"productId": 8076099879130,
			"variantId": 44138042294490,
			"sku": "RITZI/SETDE2:50X85/BCO"
		},
		{
			"productId": 8076099911898,
			"variantId": 44138012803290,
			"sku": "RITZI/45X110/GRI"
		},
		{
			"productId": 8076099911898,
			"variantId": 44138012836058,
			"sku": "RITZI/45X160/GRI"
		},
		{
			"productId": 8076099911898,
			"variantId": 44138012868826,
			"sku": "RITZI/SETDE2:50X85/GRI"
		},
		{
			"productId": 8076087001306,
			"variantId": 44138042982618,
			"sku": "BAND/45X95/PIE"
		},
		{
			"productId": 8076087001306,
			"variantId": 44138043015386,
			"sku": "BAND/45X145/PIE"
		},
		{
			"productId": 8076087001306,
			"variantId": 44138043048154,
			"sku": "BAND/SETDE2:50X75/PIE"
		},
		{
			"productId": 8076090474714,
			"variantId": 44138045800666,
			"sku": "BESTPUNT/45X95/BCO"
		},
		{
			"productId": 8076090474714,
			"variantId": 44138045833434,
			"sku": "BESTPUNT/45X145/BCO"
		},
		{
			"productId": 8076090474714,
			"variantId": 44138045866202,
			"sku": "BESTPUNT/SETDE2:50X75/BCO"
		},
		{
			"productId": 8076090474714,
			"variantId": 44138045898970,
			"sku": "BESTPUNT/45X105/BCO"
		},
		{
			"productId": 8076090507482,
			"variantId": 44138102194394,
			"sku": "BESTPUNT/45X95/PIE"
		},
		{
			"productId": 8076090507482,
			"variantId": 44138102227162,
			"sku": "BESTPUNT/SETDE2:50X75/PIE"
		},
		{
			"productId": 8076090507482,
			"variantId": 44138102259930,
			"sku": "BESTPUNT/45X105/PIE"
		},
		{
			"productId": 8076084543706,
			"variantId": 44138069000410,
			"sku": "VAI/45X95/BCO"
		},
		{
			"productId": 8076084543706,
			"variantId": 44138069033178,
			"sku": "VAI/45X145/BCO"
		},
		{
			"productId": 8076084543706,
			"variantId": 44138069065946,
			"sku": "VAI/SETDE2:50X75/BCO"
		},
		{
			"productId": 8076084838618,
			"variantId": 44138076995802,
			"sku": "VALENTINA/45X95/GRI"
		},
		{
			"productId": 8076084838618,
			"variantId": 44138077028570,
			"sku": "VALENTINA/45X145/GRI"
		},
		{
			"productId": 8076084838618,
			"variantId": 44138077061338,
			"sku": "VALENTINA/SETDE2:50X75/GRI"
		},
		{
			"productId": 8076107317466,
			"variantId": 44138069623002,
			"sku": "GAFLI/45X95/AMA"
		},
		{
			"productId": 8076107317466,
			"variantId": 44138069655770,
			"sku": "GAFLI/SETDE2:50X75/AMA"
		},
		{
			"productId": 8076082381018,
			"variantId": 44138071589082,
			"sku": "PRAZ/45X110/GRA"
		},
		{
			"productId": 8076082381018,
			"variantId": 44138071621850,
			"sku": "PRAZ/45X160/GRA"
		},
		{
			"productId": 8076082381018,
			"variantId": 44138071654618,
			"sku": "PRAZ/SETDE2:50X85/GRA"
		},
		{
			"productId": 8076085264602,
			"variantId": 44138067591386,
			"sku": "VANITY/45X95/AZU"
		},
		{
			"productId": 8076085264602,
			"variantId": 44138067624154,
			"sku": "VANITY/45X145/AZU"
		},
		{
			"productId": 8076085264602,
			"variantId": 44138067656922,
			"sku": "VANITY/SETDE2:50X75/AZU"
		},
		{
			"productId": 8076082118874,
			"variantId": 44138075357402,
			"sku": "PRANI/45X95/VER"
		},
		{
			"productId": 8076082118874,
			"variantId": 44138075390170,
			"sku": "PRANI/45X145/VER"
		},
		{
			"productId": 8076082118874,
			"variantId": 44138075422938,
			"sku": "PRANI/SETDE2:50X75/VER"
		},
		{
			"productId": 8076077727962,
			"variantId": 44138068148442,
			"sku": "GALI/45X95/AMA"
		},
		{
			"productId": 8076077727962,
			"variantId": 44138068181210,
			"sku": "GALI/45X145/AMA"
		},
		{
			"productId": 8076077727962,
			"variantId": 44138068213978,
			"sku": "GALI/SETDE2:50X75/AMA"
		},
		{
			"productId": 8076081725658,
			"variantId": 44138072473818,
			"sku": "PRA/45X110/VER"
		},
		{
			"productId": 8076081725658,
			"variantId": 44138072506586,
			"sku": "PRA/45X160/VER"
		},
		{
			"productId": 8076081725658,
			"variantId": 44138072539354,
			"sku": "PRA/SETDE2:50X85/VER"
		},
		{
			"productId": 8076082249946,
			"variantId": 44138074046682,
			"sku": "PRANITY/45X95/GRI"
		},
		{
			"productId": 8076082249946,
			"variantId": 44138074079450,
			"sku": "PRANITY/45X145/GRI"
		},
		{
			"productId": 8076082249946,
			"variantId": 44138074112218,
			"sku": "PRANITY/SETDE2:50X75/GRI"
		},
		{
			"productId": 8076094406874,
			"variantId": 44138030563546,
			"sku": "LINLOV/45X95/AGM"
		},
		{
			"productId": 8076094406874,
			"variantId": 44138030596314,
			"sku": "LINLOV/45X145/AGM"
		},
		{
			"productId": 8076094406874,
			"variantId": 44138030629082,
			"sku": "LINLOV/SETDE2:50X75/AGM"
		},
		{
			"productId": 8076094439642,
			"variantId": 44138032791770,
			"sku": "LINLOV/45X95/BCO"
		},
		{
			"productId": 8076094439642,
			"variantId": 44138032824538,
			"sku": "LINLOV/45X145/BCO"
		},
		{
			"productId": 8076094439642,
			"variantId": 44138032857306,
			"sku": "LINLOV/SETDE2:50X75/BCO"
		},
		{
			"productId": 8076094472410,
			"variantId": 44138057564378,
			"sku": "LINLOV/45X95/BEI"
		},
		{
			"productId": 8076094472410,
			"variantId": 44138057597146,
			"sku": "LINLOV/45X145/BEI"
		},
		{
			"productId": 8076094472410,
			"variantId": 44138057629914,
			"sku": "LINLOV/SETDE2:50X75/BEI"
		},
		{
			"productId": 8076094505178,
			"variantId": 44137998057690,
			"sku": "LINLOV/45X95/ROS"
		},
		{
			"productId": 8076094505178,
			"variantId": 44137998090458,
			"sku": "LINLOV/45X145/ROS"
		},
		{
			"productId": 8076094505178,
			"variantId": 44137998123226,
			"sku": "LINLOV/SETDE2:50X75/ROS"
		},
		{
			"productId": 8076098961626,
			"variantId": 44138034626778,
			"sku": "PANAL/45X110/BCO"
		},
		{
			"productId": 8076098961626,
			"variantId": 44138034659546,
			"sku": "PANAL/45X160/BCO"
		},
		{
			"productId": 8076098961626,
			"variantId": 44138034692314,
			"sku": "PANAL/SETDE2:50X85/BCO"
		},
		{
			"productId": 8076078842074,
			"variantId": 44138071818458,
			"sku": "JERCORA/45X95/AZU"
		},
		{
			"productId": 8076078842074,
			"variantId": 44138071851226,
			"sku": "JERCORA/45X145/AZU"
		},
		{
			"productId": 8076078842074,
			"variantId": 44138071883994,
			"sku": "JERCORA/SETDE2:50X75/AZU"
		},
		{
			"productId": 8076083036378,
			"variantId": 44138068705498,
			"sku": "PUNTIBA/45X95/ROO"
		},
		{
			"productId": 8076083036378,
			"variantId": 44138068738266,
			"sku": "PUNTIBA/45X145/ROO"
		},
		{
			"productId": 8076083036378,
			"variantId": 44138068771034,
			"sku": "PUNTIBA/SETDE2:50X75/ROO"
		},
		{
			"productId": 8076083101914,
			"variantId": 44138073948378,
			"sku": "PUNTIBA/45X95/KAK"
		},
		{
			"productId": 8076083101914,
			"variantId": 44138073981146,
			"sku": "PUNTIBA/45X145/KAK"
		},
		{
			"productId": 8076083101914,
			"variantId": 44138074013914,
			"sku": "PUNTIBA/SETDE2:50X75/KAK"
		},
		{
			"productId": 8076099354842,
			"variantId": 44138064249050,
			"sku": "PULIS/45X95/GRI"
		},
		{
			"productId": 8076099354842,
			"variantId": 44138064281818,
			"sku": "PULIS/45X145/GRI"
		},
		{
			"productId": 8076099354842,
			"variantId": 44138064314586,
			"sku": "PULIS/SETDE2:50X75/GRI"
		},
		{
			"productId": 8076099485914,
			"variantId": 44138098000090,
			"sku": "PULIS2/45X95/GRI"
		},
		{
			"productId": 8076099485914,
			"variantId": 44138098032858,
			"sku": "PULIS2/45X145/GRI"
		},
		{
			"productId": 8076099485914,
			"variantId": 44138098065626,
			"sku": "PULIS2/SETDE2:50X75/GRI"
		},
		{
			"productId": 8076081922266,
			"variantId": 44138068017370,
			"sku": "PRALIF/45X110/VER"
		},
		{
			"productId": 8076081922266,
			"variantId": 44138068050138,
			"sku": "PRALIF/45X160/VER"
		},
		{
			"productId": 8076081922266,
			"variantId": 44138068082906,
			"sku": "PRALIF/SETDE2:50X85/VER"
		},
		{
			"productId": 8076085067994,
			"variantId": 44138069459162,
			"sku": "VALU/45X95/AZU"
		},
		{
			"productId": 8076085067994,
			"variantId": 44138069491930,
			"sku": "VALU/45X145/AZU"
		},
		{
			"productId": 8076085067994,
			"variantId": 44138069524698,
			"sku": "VALU/SETDE2:50X75/AZU"
		},
		{
			"productId": 8076079464666,
			"variantId": 44138067689690,
			"sku": "KINGNAU/55X55/AZU"
		},
		{
			"productId": 8076092604634,
			"variantId": 44137995174106,
			"sku": "DEBORAH/55X55/CRU"
		},
		{
			"productId": 8076080971994,
			"variantId": 44138071064794,
			"sku": "NONA/55X55/BEI"
		},
		{
			"productId": 8076096241882,
			"variantId": 44138038100186,
			"sku": "MINIDOT/55X55/BCO"
		},
		{
			"productId": 8076102074586,
			"variantId": 44138031710426,
			"sku": "TEXBROD/55X55/BCO"
		},
		{
			"productId": 8150094086362,
			"variantId": 44315921940698,
			"sku": "FERDA/55X55/VER"
		},
		{
			"productId": 8076077629658,
			"variantId": 44138069262554,
			"sku": "GAFRA/55X55/GRI"
		},
		{
			"productId": 8150094119130,
			"variantId": 44315924496602,
			"sku": "LARI/55X55/AZU"
		},
		{
			"productId": 8076101943514,
			"variantId": 44138028204250,
			"sku": "SUNCOL/55X55/BCO"
		},
		{
			"productId": 8076101976282,
			"variantId": 44138039541978,
			"sku": "SUNCOL/55X55/PIE"
		},
		{
			"productId": 8076084969690,
			"variantId": 44138071326938,
			"sku": "VALETI/55X55/AZU"
		},
		{
			"productId": 8076102435034,
			"variantId": 44138015817946,
			"sku": "TUAR/55X55/BCO"
		},
		{
			"productId": 8076102500570,
			"variantId": 44138031612122,
			"sku": "TUAR/55X55/PIE"
		},
		{
			"productId": 8076089917658,
			"variantId": 44138043572442,
			"sku": "BESTO/55X55/BCO"
		},
		{
			"productId": 8076089917658,
			"variantId": 44138043605210,
			"sku": "BESTO/51X71/BCO"
		},
		{
			"productId": 8076089950426,
			"variantId": 44138042851546,
			"sku": "BESTO/51X71/PIE"
		},
		{
			"productId": 8076089983194,
			"variantId": 44138046030042,
			"sku": "BESTO/55X55/AMA"
		},
		{
			"productId": 8076090015962,
			"variantId": 44138030072026,
			"sku": "BESTO/55X55/AQU"
		},
		{
			"productId": 8076090048730,
			"variantId": 44138012475610,
			"sku": "BESTO/55X55/AZD"
		},
		{
			"productId": 8076090081498,
			"variantId": 44138006937818,
			"sku": "BESTO/55X55/CEN"
		},
		{
			"productId": 8076090114266,
			"variantId": 44138042360026,
			"sku": "BESTO/55X55/ROS"
		},
		{
			"productId": 8076090147034,
			"variantId": 44138000384218,
			"sku": "BESTO/55X55/VOS"
		},
		{
			"productId": 8076090245338,
			"variantId": 44138037280986,
			"sku": "BESTOBIC/55X55/AZU"
		},
		{
			"productId": 8076090278106,
			"variantId": 44138056646874,
			"sku": "BESTOBIC/55X55/GRC"
		},
		{
			"productId": 8076090310874,
			"variantId": 44138044260570,
			"sku": "BESTOBIC/55X55/PIE"
		},
		{
			"productId": 8076078121178,
			"variantId": 44138073686234,
			"sku": "GAPATCOL/55X55/ROS"
		},
		{
			"productId": 8076098666714,
			"variantId": 44138029383898,
			"sku": "OXFI2/55X55/BCO"
		},
		{
			"productId": 8076085690586,
			"variantId": 44138068115674,
			"sku": "VAPATCOL/55X55/AZU"
		},
		{
			"productId": 8076087886042,
			"variantId": 44137999073498,
			"sku": "BEST2/51X71/BCO"
		},
		{
			"productId": 8076087951578,
			"variantId": 44138011820250,
			"sku": "BEST2/55X55/PIE"
		},
		{
			"productId": 8076087951578,
			"variantId": 44138011853018,
			"sku": "BEST2/51X71/PIE"
		},
		{
			"productId": 8076088017114,
			"variantId": 44138036560090,
			"sku": "BEST2/55X55/BLCO"
		},
		{
			"productId": 8076088213722,
			"variantId": 44138024763610,
			"sku": "BESTBIC2/55X55/GRC"
		},
		{
			"productId": 8076088279258,
			"variantId": 44138019717338,
			"sku": "BESTBIC2/55X55/PIE"
		},
		{
			"productId": 8076086313178,
			"variantId": 44138038558938,
			"sku": "AMI/55X55/GRI"
		},
		{
			"productId": 8076087034074,
			"variantId": 44138037575898,
			"sku": "BAND/55X55/PIE"
		},
		{
			"productId": 8076087165146,
			"variantId": 44137993339098,
			"sku": "BARBADOS/45X45/GRI"
		},
		{
			"productId": 8076087165146,
			"variantId": 44137993371866,
			"sku": "BARBADOS/30X50/GRI"
		},
		{
			"productId": 8076087197914,
			"variantId": 44138040754394,
			"sku": "BARBADOS/45X45/PIE"
		},
		{
			"productId": 8076087197914,
			"variantId": 44138040787162,
			"sku": "BARBADOS/30X50/PIE"
		},
		{
			"productId": 8076104827098,
			"variantId": 44138096754906,
			"sku": "BELTON/55X55/PIE"
		},
		{
			"productId": 8076094079194,
			"variantId": 44138004250842,
			"sku": "LINET/55X55/BEI"
		},
		{
			"productId": 8076094111962,
			"variantId": 44137996976346,
			"sku": "LINET/55X55/GRI"
		},
		{
			"productId": 8076099944666,
			"variantId": 44138020831450,
			"sku": "RITZI/55X55/BCO"
		},
		{
			"productId": 8076100010202,
			"variantId": 44138058776794,
			"sku": "RITZI/55X55/GRI"
		},
		{
			"productId": 8076086640858,
			"variantId": 44137995141338,
			"sku": "ARKANSAS/45X45/GRC"
		},
		{
			"productId": 8076086673626,
			"variantId": 44137995108570,
			"sku": "ARKANSAS/45X45/MRR"
		},
		{
			"productId": 8076086706394,
			"variantId": 44138060579034,
			"sku": "ARKANSAS/55X55/GRC"
		},
		{
			"productId": 8076086739162,
			"variantId": 44137997959386,
			"sku": "ARKANSAS/55X55/MRR"
		},
		{
			"productId": 8076092899546,
			"variantId": 44138045374682,
			"sku": "ELEMENT/55X55/GRI"
		},
		{
			"productId": 8150094610650,
			"variantId": 44315921613018,
			"sku": "FERDIR/30X50/BCO"
		},
		{
			"productId": 8150094545114,
			"variantId": 44315921678554,
			"sku": "DIAMICU/45X45/BEI"
		},
		{
			"productId": 8150094577882,
			"variantId": 44315921645786,
			"sku": "FERDIN/45X45/VER"
		},
		{
			"productId": 8076100337882,
			"variantId": 44138040688858,
			"sku": "SLABCO/55X55/BCO"
		},
		{
			"productId": 8076084871386,
			"variantId": 44138069590234,
			"sku": "VALENTINA/55X55/GRI"
		},
		{
			"productId": 8076090704090,
			"variantId": 44138063233242,
			"sku": "BOLIVIA2/30X50/BEI"
		},
		{
			"productId": 8076090736858,
			"variantId": 44138098163930,
			"sku": "BOLIVIA2/30X50/GRI"
		},
		{
			"productId": 8076107350234,
			"variantId": 44138072047834,
			"sku": "GAFLI/55X55/AMA"
		},
		{
			"productId": 8076082413786,
			"variantId": 44138077225178,
			"sku": "PRAZ/55X55/GRA"
		},
		{
			"productId": 8076085297370,
			"variantId": 44138070835418,
			"sku": "VANITY/55X55/AZU"
		},
		{
			"productId": 8076082184410,
			"variantId": 44138072703194,
			"sku": "PRANI/55X55/VER"
		},
		{
			"productId": 8076077793498,
			"variantId": 44138069557466,
			"sku": "GALI/55X55/AMA"
		},
		{
			"productId": 8076085493978,
			"variantId": 44138072080602,
			"sku": "VAPAT/55X55/AZU"
		},
		{
			"productId": 8076081758426,
			"variantId": 44138071556314,
			"sku": "PRA/55X55/VER"
		},
		{
			"productId": 8076082282714,
			"variantId": 44138070868186,
			"sku": "PRANITY/55X55/GRI"
		},
		{
			"productId": 8076081955034,
			"variantId": 44138075324634,
			"sku": "PRALIF/55X55/VER"
		},
		{
			"productId": 8076094537946,
			"variantId": 44138006741210,
			"sku": "LINLOV/55X55/AGM"
		},
		{
			"productId": 8076094570714,
			"variantId": 44138039247066,
			"sku": "LINLOV/55X55/BCO"
		},
		{
			"productId": 8076094603482,
			"variantId": 44138032890074,
			"sku": "LINLOV/55X55/BEI"
		},
		{
			"productId": 8076094636250,
			"variantId": 44138035773658,
			"sku": "LINLOV/55X55/ROS"
		},
		{
			"productId": 8076094963930,
			"variantId": 44137998024922,
			"sku": "LINO/55X55/BCO"
		},
		{
			"productId": 8076083331290,
			"variantId": 44138063823066,
			"sku": "RUSTCOL/55X55/CAM"
		},
		{
			"productId": 8076083364058,
			"variantId": 44138072572122,
			"sku": "RUSTCOL/55X55/ROP"
		},
		{
			"productId": 8076079333594,
			"variantId": 44138063462618,
			"sku": "KING/55X55/VER"
		},
		{
			"productId": 8076098994394,
			"variantId": 44138029351130,
			"sku": "PANAL/55X55/BCO"
		},
		{
			"productId": 8076077990106,
			"variantId": 44138076963034,
			"sku": "GAPAT/55X55/ROS"
		},
		{
			"productId": 8076106105050,
			"variantId": 44138071916762,
			"sku": "DIBETA/55X55/GRC"
		},
		{
			"productId": 8076106137818,
			"variantId": 44138063855834,
			"sku": "DIBETA/55X55/PIE"
		},
		{
			"productId": 8076078874842,
			"variantId": 44138075291866,
			"sku": "JERCORA/55X55/AZU"
		},
		{
			"productId": 8076099387610,
			"variantId": 44138063495386,
			"sku": "PULIS/55X55/GRI"
		},
		{
			"productId": 8076099551450,
			"variantId": 44138098098394,
			"sku": "PULIS2/55X55/GRI"
		},
		{
			"productId": 8076082938074,
			"variantId": 44138064347354,
			"sku": "PUNCOL/55X55/GRI"
		},
		{
			"productId": 8076085100762,
			"variantId": 44138071097562,
			"sku": "VALU/55X55/AZU"
		},
		{
			"productId": 8076084576474,
			"variantId": 44138078077146,
			"sku": "VAI/55X55/BCO"
		},
		{
			"productId": 8076081692890,
			"variantId": 44138075455706,
			"sku": "PORTUX/55X55/GRI"
		},
		{
			"productId": 8076093554906,
			"variantId": 44138061070554,
			"sku": "GRISFU/55X55/GRC"
		},
		{
			"productId": 8076092801242,
			"variantId": 44138016014554,
			"sku": "ELASTICA/90X190/BCO"
		},
		{
			"productId": 8076092801242,
			"variantId": 44138016047322,
			"sku": "ELASTICA/135X190/BCO"
		},
		{
			"productId": 8076092801242,
			"variantId": 44138016080090,
			"sku": "ELASTICA/150X190/BCO"
		},
		{
			"productId": 8076092801242,
			"variantId": 44138016112858,
			"sku": "ELASTICA/180X200/BCO"
		},
		{
			"productId": 8076084642010,
			"variantId": 44138074833114,
			"sku": "VALCU/45X110/ROJ"
		},
		{
			"productId": 8076084642010,
			"variantId": 44138074865882,
			"sku": "VALCU/45X160/ROJ"
		},
		{
			"productId": 8076084642010,
			"variantId": 44138074898650,
			"sku": "VALCU/SETDE2:50X85/ROJ"
		},
		{
			"productId": 8076079300826,
			"variantId": 44138071294170,
			"sku": "KING/55X55/PIO"
		},
		{
			"productId": 8076091228378,
			"variantId": 44138096591066,
			"sku": "CHERANCOB/55X55/GRI"
		},
		{
			"productId": 8076084674778,
			"variantId": 44138071523546,
			"sku": "VALCU/55X55/ROJ"
		},
		{
			"productId": 8076096274650,
			"variantId": 44138046324954,
			"sku": "MINIDOT/F150X260/BCO"
		},
		{
			"productId": 8076096274650,
			"variantId": 44138046357722,
			"sku": "MINIDOT/F220X260/BCO"
		},
		{
			"productId": 8076096274650,
			"variantId": 44138046390490,
			"sku": "MINIDOT/F240X260/BCO"
		},
		{
			"productId": 8076096274650,
			"variantId": 44138046423258,
			"sku": "MINIDOT/F260X260/BCO"
		},
		{
			"productId": 8076098568410,
			"variantId": 44138018799834,
			"sku": "OXFI/F150X260/BCO"
		},
		{
			"productId": 8076098568410,
			"variantId": 44138018832602,
			"sku": "OXFI/F200X260/BCO"
		},
		{
			"productId": 8076098568410,
			"variantId": 44138018865370,
			"sku": "OXFI/F220X260/BCO"
		},
		{
			"productId": 8076098568410,
			"variantId": 44138018898138,
			"sku": "OXFI/F240X260/BCO"
		},
		{
			"productId": 8076098568410,
			"variantId": 44138018930906,
			"sku": "OXFI/F260X260/BCO"
		},
		{
			"productId": 8076100370650,
			"variantId": 44138035642586,
			"sku": "SLABCO/F150X260/BCO"
		},
		{
			"productId": 8076100370650,
			"variantId": 44138035675354,
			"sku": "SLABCO/F220X260/BCO"
		},
		{
			"productId": 8076100370650,
			"variantId": 44138035708122,
			"sku": "SLABCO/F240X260/BCO"
		},
		{
			"productId": 8076100370650,
			"variantId": 44138035740890,
			"sku": "SLABCO/F260X260/BCO"
		},
		{
			"productId": 8150094151898,
			"variantId": 44315923841242,
			"sku": "FERDA/150X260/VER"
		},
		{
			"productId": 8150094151898,
			"variantId": 44315923874010,
			"sku": "FERDA/200X260/VER"
		},
		{
			"productId": 8150094151898,
			"variantId": 44315923906778,
			"sku": "FERDA/220X260/VER"
		},
		{
			"productId": 8150094151898,
			"variantId": 44315923939546,
			"sku": "FERDA/240X260/VER"
		},
		{
			"productId": 8150094151898,
			"variantId": 44315923972314,
			"sku": "FERDA/260X260/VER"
		},
		{
			"productId": 8076077662426,
			"variantId": 44138068246746,
			"sku": "GAFRA/150X220/GRI"
		},
		{
			"productId": 8076077662426,
			"variantId": 44138068279514,
			"sku": "GAFRA/220X220/GRI"
		},
		{
			"productId": 8076077662426,
			"variantId": 44138068312282,
			"sku": "GAFRA/240X220/GRI"
		},
		{
			"productId": 8076077662426,
			"variantId": 44138068345050,
			"sku": "GAFRA/260X240/GRI"
		},
		{
			"productId": 8150094184666,
			"variantId": 44315924857050,
			"sku": "LARI/150X260/AZU"
		},
		{
			"productId": 8150094184666,
			"variantId": 44315924889818,
			"sku": "LARI/200X260/AZU"
		},
		{
			"productId": 8150094184666,
			"variantId": 44315924922586,
			"sku": "LARI/220X260/AZU"
		},
		{
			"productId": 8150094184666,
			"variantId": 44315924955354,
			"sku": "LARI/240X260/AZU"
		},
		{
			"productId": 8150094184666,
			"variantId": 44315924988122,
			"sku": "LARI/260X260/AZU"
		},
		{
			"productId": 8076085002458,
			"variantId": 44138067722458,
			"sku": "VALETI/150X220/AZU"
		},
		{
			"productId": 8076085002458,
			"variantId": 44138067755226,
			"sku": "VALETI/220X220/AZU"
		},
		{
			"productId": 8076085002458,
			"variantId": 44138067787994,
			"sku": "VALETI/240X220/AZU"
		},
		{
			"productId": 8076085002458,
			"variantId": 44138067820762,
			"sku": "VALETI/260X240/AZU"
		},
		{
			"productId": 8076075565274,
			"variantId": 44138030694618,
			"sku": "BESTO/150X260/AMA"
		},
		{
			"productId": 8076075565274,
			"variantId": 44138030727386,
			"sku": "BESTO/220X260/AMA"
		},
		{
			"productId": 8076075565274,
			"variantId": 44138030760154,
			"sku": "BESTO/240X260/AMA"
		},
		{
			"productId": 8076075565274,
			"variantId": 44138030792922,
			"sku": "BESTO/260X260/AMA"
		},
		{
			"productId": 8076075598042,
			"variantId": 44138056417498,
			"sku": "BESTO/150X260/AQU"
		},
		{
			"productId": 8076075598042,
			"variantId": 44138056450266,
			"sku": "BESTO/220X260/AQU"
		},
		{
			"productId": 8076075598042,
			"variantId": 44138056483034,
			"sku": "BESTO/240X260/AQU"
		},
		{
			"productId": 8076075598042,
			"variantId": 44138056515802,
			"sku": "BESTO/260X260/AQU"
		},
		{
			"productId": 8076075663578,
			"variantId": 44138054811866,
			"sku": "BESTO/150X260/AZD"
		},
		{
			"productId": 8076075663578,
			"variantId": 44138054844634,
			"sku": "BESTO/220X260/AZD"
		},
		{
			"productId": 8076075663578,
			"variantId": 44138054877402,
			"sku": "BESTO/240X260/AZD"
		},
		{
			"productId": 8076075663578,
			"variantId": 44138054910170,
			"sku": "BESTO/260X260/AZD"
		},
		{
			"productId": 8076075729114,
			"variantId": 44138049863898,
			"sku": "BESTO/150X260/BCO"
		},
		{
			"productId": 8076075729114,
			"variantId": 44138049896666,
			"sku": "BESTO/200X260/BCO"
		},
		{
			"productId": 8076075729114,
			"variantId": 44138049929434,
			"sku": "BESTO/220X260/BCO"
		},
		{
			"productId": 8076075729114,
			"variantId": 44138049962202,
			"sku": "BESTO/240X260/BCO"
		},
		{
			"productId": 8076075729114,
			"variantId": 44138049994970,
			"sku": "BESTO/260X260/BCO"
		},
		{
			"productId": 8076075761882,
			"variantId": 44138027483354,
			"sku": "BESTO/150X260/CEN"
		},
		{
			"productId": 8076075761882,
			"variantId": 44138027516122,
			"sku": "BESTO/220X260/CEN"
		},
		{
			"productId": 8076075761882,
			"variantId": 44138027548890,
			"sku": "BESTO/240X260/CEN"
		},
		{
			"productId": 8076075761882,
			"variantId": 44138027581658,
			"sku": "BESTO/260X260/CEN"
		},
		{
			"productId": 8076075827418,
			"variantId": 44138066936026,
			"sku": "BESTO/150X260/LIC"
		},
		{
			"productId": 8076075827418,
			"variantId": 44138066968794,
			"sku": "BESTO/220X260/LIC"
		},
		{
			"productId": 8076075827418,
			"variantId": 44138067001562,
			"sku": "BESTO/240X260/LIC"
		},
		{
			"productId": 8076075827418,
			"variantId": 44138067034330,
			"sku": "BESTO/260X260/LIC"
		},
		{
			"productId": 8076075860186,
			"variantId": 44137996681434,
			"sku": "BESTO/150X260/ROS"
		},
		{
			"productId": 8076075860186,
			"variantId": 44137996714202,
			"sku": "BESTO/220X260/ROS"
		},
		{
			"productId": 8076075860186,
			"variantId": 44137996746970,
			"sku": "BESTO/240X260/ROS"
		},
		{
			"productId": 8076075860186,
			"variantId": 44137996779738,
			"sku": "BESTO/260X260/ROS"
		},
		{
			"productId": 8076075925722,
			"variantId": 44138044686554,
			"sku": "BESTO/150X260/VOS"
		},
		{
			"productId": 8076075925722,
			"variantId": 44138044719322,
			"sku": "BESTO/220X260/VOS"
		},
		{
			"productId": 8076075925722,
			"variantId": 44138044752090,
			"sku": "BESTO/240X260/VOS"
		},
		{
			"productId": 8076075925722,
			"variantId": 44138044784858,
			"sku": "BESTO/260X260/VOS"
		},
		{
			"productId": 8076075991258,
			"variantId": 44137993732314,
			"sku": "BESTOBIC/150X260/AZC"
		},
		{
			"productId": 8076075991258,
			"variantId": 44137993765082,
			"sku": "BESTOBIC/220X260/AZC"
		},
		{
			"productId": 8076075991258,
			"variantId": 44137993797850,
			"sku": "BESTOBIC/240X260/AZC"
		},
		{
			"productId": 8076075991258,
			"variantId": 44137993830618,
			"sku": "BESTOBIC/260X260/AZC"
		},
		{
			"productId": 8076076056794,
			"variantId": 44137998352602,
			"sku": "BESTOBIC/150X260/GRC"
		},
		{
			"productId": 8076076056794,
			"variantId": 44137998385370,
			"sku": "BESTOBIC/220X260/GRC"
		},
		{
			"productId": 8076076056794,
			"variantId": 44137998418138,
			"sku": "BESTOBIC/240X260/GRC"
		},
		{
			"productId": 8076076056794,
			"variantId": 44137998450906,
			"sku": "BESTOBIC/260X260/GRC"
		},
		{
			"productId": 8076076089562,
			"variantId": 44138039345370,
			"sku": "BESTOBIC/150X260/PIE"
		},
		{
			"productId": 8076076089562,
			"variantId": 44138039378138,
			"sku": "BESTOBIC/200X260/PIE"
		},
		{
			"productId": 8076076089562,
			"variantId": 44138039410906,
			"sku": "BESTOBIC/220X260/PIE"
		},
		{
			"productId": 8076076089562,
			"variantId": 44138039443674,
			"sku": "BESTOBIC/240X260/PIE"
		},
		{
			"productId": 8076076089562,
			"variantId": 44138039476442,
			"sku": "BESTOBIC/260X260/PIE"
		},
		{
			"productId": 8076092375258,
			"variantId": 44138009952474,
			"sku": "CROCHE/150X220/BCO"
		},
		{
			"productId": 8076092375258,
			"variantId": 44138009985242,
			"sku": "CROCHE/220X220/BCO"
		},
		{
			"productId": 8076092375258,
			"variantId": 44138010018010,
			"sku": "CROCHE/240X220/BCO"
		},
		{
			"productId": 8076092375258,
			"variantId": 44138010050778,
			"sku": "CROCHE/260X240/BCO"
		},
		{
			"productId": 8076087623898,
			"variantId": 44138026533082,
			"sku": "BEST2/150X260/BCO"
		},
		{
			"productId": 8076087623898,
			"variantId": 44138026565850,
			"sku": "BEST2/200X260/BCO"
		},
		{
			"productId": 8076087623898,
			"variantId": 44138026598618,
			"sku": "BEST2/220X260/BCO"
		},
		{
			"productId": 8076087623898,
			"variantId": 44138026631386,
			"sku": "BEST2/240X260/BCO"
		},
		{
			"productId": 8076087623898,
			"variantId": 44138026664154,
			"sku": "BEST2/260X260/BCO"
		},
		{
			"productId": 8076088049882,
			"variantId": 44138038624474,
			"sku": "BESTBIC2/150X260/GRC"
		},
		{
			"productId": 8076088049882,
			"variantId": 44138038657242,
			"sku": "BESTBIC2/220X260/GRC"
		},
		{
			"productId": 8076088049882,
			"variantId": 44138038690010,
			"sku": "BESTBIC2/240X260/GRC"
		},
		{
			"productId": 8076088049882,
			"variantId": 44138038722778,
			"sku": "BESTBIC2/260X260/GRC"
		},
		{
			"productId": 8076088115418,
			"variantId": 44138056089818,
			"sku": "BESTBIC2/150X260/PIE"
		},
		{
			"productId": 8076088115418,
			"variantId": 44138056122586,
			"sku": "BESTBIC2/200X260/PIE"
		},
		{
			"productId": 8076088115418,
			"variantId": 44138056155354,
			"sku": "BESTBIC2/220X260/PIE"
		},
		{
			"productId": 8076088115418,
			"variantId": 44138056188122,
			"sku": "BESTBIC2/240X260/PIE"
		},
		{
			"productId": 8076088115418,
			"variantId": 44138056220890,
			"sku": "BESTBIC2/260X260/PIE"
		},
		{
			"productId": 8076086345946,
			"variantId": 44138040951002,
			"sku": "AMI/F150X260/GRI"
		},
		{
			"productId": 8076086345946,
			"variantId": 44138040983770,
			"sku": "AMI/F220X260/GRI"
		},
		{
			"productId": 8076086345946,
			"variantId": 44138041016538,
			"sku": "AMI/F240X260/GRI"
		},
		{
			"productId": 8076086345946,
			"variantId": 44138041049306,
			"sku": "AMI/F260X260/GRI"
		},
		{
			"productId": 8076104859866,
			"variantId": 44138096820442,
			"sku": "BELTON2/150X260/PIE"
		},
		{
			"productId": 8076104859866,
			"variantId": 44138096853210,
			"sku": "BELTON2/200X260/PIE"
		},
		{
			"productId": 8076104859866,
			"variantId": 44138096885978,
			"sku": "BELTON2/220X260/PIE"
		},
		{
			"productId": 8076104859866,
			"variantId": 44138096918746,
			"sku": "BELTON2/240X260/PIE"
		},
		{
			"productId": 8076104859866,
			"variantId": 44138096951514,
			"sku": "BELTON2/260X260/PIE"
		},
		{
			"productId": 8076087066842,
			"variantId": 44138037641434,
			"sku": "BAND/F150X260/PIE"
		},
		{
			"productId": 8076087066842,
			"variantId": 44138037674202,
			"sku": "BAND/F220X260/PIE"
		},
		{
			"productId": 8076087066842,
			"variantId": 44138037706970,
			"sku": "BAND/F240X260/PIE"
		},
		{
			"productId": 8076087066842,
			"variantId": 44138037739738,
			"sku": "BAND/F260X260/PIE"
		},
		{
			"productId": 8076099748058,
			"variantId": 44138025255130,
			"sku": "RITZI/150X260/BCO"
		},
		{
			"productId": 8076099748058,
			"variantId": 44138025287898,
			"sku": "RITZI/200X260/BCO"
		},
		{
			"productId": 8076099748058,
			"variantId": 44138025320666,
			"sku": "RITZI/220X260/BCO"
		},
		{
			"productId": 8076099748058,
			"variantId": 44138025353434,
			"sku": "RITZI/240X260/BCO"
		},
		{
			"productId": 8076099748058,
			"variantId": 44138025386202,
			"sku": "RITZI/260X260/BCO"
		},
		{
			"productId": 8076099748058,
			"variantId": 44138025418970,
			"sku": "RITZI/290X260/BCO"
		},
		{
			"productId": 8076099780826,
			"variantId": 44137995829466,
			"sku": "RITZI/150X260/GRI"
		},
		{
			"productId": 8076099780826,
			"variantId": 44137995862234,
			"sku": "RITZI/200X260/GRI"
		},
		{
			"productId": 8076099780826,
			"variantId": 44137995895002,
			"sku": "RITZI/220X260/GRI"
		},
		{
			"productId": 8076099780826,
			"variantId": 44137995927770,
			"sku": "RITZI/240X260/GRI"
		},
		{
			"productId": 8076099780826,
			"variantId": 44137995960538,
			"sku": "RITZI/260X260/GRI"
		},
		{
			"productId": 8076099780826,
			"variantId": 44137995993306,
			"sku": "RITZI/290X260/GRI"
		},
		{
			"productId": 8076092834010,
			"variantId": 44138022043866,
			"sku": "ELEMENT/150X260/GRI"
		},
		{
			"productId": 8076092834010,
			"variantId": 44138022076634,
			"sku": "ELEMENT/220X260/GRI"
		},
		{
			"productId": 8076092834010,
			"variantId": 44138022109402,
			"sku": "ELEMENT/240X260/GRI"
		},
		{
			"productId": 8076092834010,
			"variantId": 44138022142170,
			"sku": "ELEMENT/260X260/GRI"
		},
		{
			"productId": 8076084707546,
			"variantId": 44138070900954,
			"sku": "VALCU/150X260/ROJ"
		},
		{
			"productId": 8076084707546,
			"variantId": 44138070933722,
			"sku": "VALCU/200X260/ROJ"
		},
		{
			"productId": 8076084707546,
			"variantId": 44138070966490,
			"sku": "VALCU/220X260/ROJ"
		},
		{
			"productId": 8076084707546,
			"variantId": 44138070999258,
			"sku": "VALCU/240X260/ROJ"
		},
		{
			"productId": 8076084707546,
			"variantId": 44138071032026,
			"sku": "VALCU/260X260/ROJ"
		},
		{
			"productId": 8076084904154,
			"variantId": 44138077585626,
			"sku": "VALENTINA/150X220/GRI"
		},
		{
			"productId": 8076084904154,
			"variantId": 44138077618394,
			"sku": "VALENTINA/220X220/GRI"
		},
		{
			"productId": 8076084904154,
			"variantId": 44138077651162,
			"sku": "VALENTINA/240X220/GRI"
		},
		{
			"productId": 8076084904154,
			"variantId": 44138077683930,
			"sku": "VALENTINA/260X240/GRI"
		},
		{
			"productId": 8076107284698,
			"variantId": 44138069688538,
			"sku": "GAFLI/150X220/AMA"
		},
		{
			"productId": 8076107284698,
			"variantId": 44138069721306,
			"sku": "GAFLI/220X220/AMA"
		},
		{
			"productId": 8076107284698,
			"variantId": 44138069754074,
			"sku": "GAFLI/240X220/AMA"
		},
		{
			"productId": 8076107284698,
			"variantId": 44138069786842,
			"sku": "GAFLI/260X240/AMA"
		},
		{
			"productId": 8076082446554,
			"variantId": 44138076242138,
			"sku": "PRAZ/150X260/GRA"
		},
		{
			"productId": 8076082446554,
			"variantId": 44138076274906,
			"sku": "PRAZ/220X260/GRA"
		},
		{
			"productId": 8076082446554,
			"variantId": 44138076307674,
			"sku": "PRAZ/240X260/GRA"
		},
		{
			"productId": 8076082446554,
			"variantId": 44138076340442,
			"sku": "PRAZ/260X260/GRA"
		},
		{
			"productId": 8076085395674,
			"variantId": 44138070442202,
			"sku": "VANITY/150X260/AZU"
		},
		{
			"productId": 8076085395674,
			"variantId": 44138070474970,
			"sku": "VANITY/220X260/AZU"
		},
		{
			"productId": 8076085395674,
			"variantId": 44138070507738,
			"sku": "VANITY/240X260/AZU"
		},
		{
			"productId": 8076085395674,
			"variantId": 44138070540506,
			"sku": "VANITY/260X260/AZU"
		},
		{
			"productId": 8076082217178,
			"variantId": 44138075783386,
			"sku": "PRANI/150X220/VER"
		},
		{
			"productId": 8076082217178,
			"variantId": 44138075816154,
			"sku": "PRANI/200X220/VER"
		},
		{
			"productId": 8076082217178,
			"variantId": 44138075848922,
			"sku": "PRANI/220X220/VER"
		},
		{
			"productId": 8076082217178,
			"variantId": 44138075881690,
			"sku": "PRANI/240X220/VER"
		},
		{
			"productId": 8076082217178,
			"variantId": 44138075914458,
			"sku": "PRANI/260X240/VER"
		},
		{
			"productId": 8076077826266,
			"variantId": 44138070278362,
			"sku": "GALI/150X220/AMA"
		},
		{
			"productId": 8076077826266,
			"variantId": 44138070311130,
			"sku": "GALI/200X220/AMA"
		},
		{
			"productId": 8076077826266,
			"variantId": 44138070343898,
			"sku": "GALI/220X220/AMA"
		},
		{
			"productId": 8076077826266,
			"variantId": 44138070376666,
			"sku": "GALI/240X220/AMA"
		},
		{
			"productId": 8076077826266,
			"variantId": 44138070409434,
			"sku": "GALI/260X240/AMA"
		},
		{
			"productId": 8076081791194,
			"variantId": 44138077946074,
			"sku": "PRA/150X260/VER"
		},
		{
			"productId": 8076081791194,
			"variantId": 44138077978842,
			"sku": "PRA/220X260/VER"
		},
		{
			"productId": 8076081791194,
			"variantId": 44138078011610,
			"sku": "PRA/240X260/VER"
		},
		{
			"productId": 8076081791194,
			"variantId": 44138078044378,
			"sku": "PRA/260X260/VER"
		},
		{
			"productId": 8076082315482,
			"variantId": 44138074931418,
			"sku": "PRANITY/150X220/GRI"
		},
		{
			"productId": 8076082315482,
			"variantId": 44138074964186,
			"sku": "PRANITY/220X220/GRI"
		},
		{
			"productId": 8076082315482,
			"variantId": 44138074996954,
			"sku": "PRANITY/240X220/GRI"
		},
		{
			"productId": 8076082315482,
			"variantId": 44138075029722,
			"sku": "PRANITY/260X240/GRI"
		},
		{
			"productId": 8076094275802,
			"variantId": 44138019356890,
			"sku": "LINLOV/150X220/AGM"
		},
		{
			"productId": 8076094275802,
			"variantId": 44138019389658,
			"sku": "LINLOV/220X220/AGM"
		},
		{
			"productId": 8076094275802,
			"variantId": 44138019422426,
			"sku": "LINLOV/240X220/AGM"
		},
		{
			"productId": 8076094275802,
			"variantId": 44138019455194,
			"sku": "LINLOV/260X240/AGM"
		},
		{
			"productId": 8076094308570,
			"variantId": 44137999827162,
			"sku": "LINLOV/150X220/BEI"
		},
		{
			"productId": 8076094308570,
			"variantId": 44137999859930,
			"sku": "LINLOV/220X220/BEI"
		},
		{
			"productId": 8076094308570,
			"variantId": 44137999892698,
			"sku": "LINLOV/240X220/BEI"
		},
		{
			"productId": 8076094308570,
			"variantId": 44137999925466,
			"sku": "LINLOV/260X240/BEI"
		},
		{
			"productId": 8076094669018,
			"variantId": 44137999958234,
			"sku": "LINLOV/F150X220/BCO"
		},
		{
			"productId": 8076094669018,
			"variantId": 44137999991002,
			"sku": "LINLOV/F220X220/BCO"
		},
		{
			"productId": 8076094669018,
			"variantId": 44138000023770,
			"sku": "LINLOV/F240X220/BCO"
		},
		{
			"productId": 8076094669018,
			"variantId": 44138000056538,
			"sku": "LINLOV/F260X240/BCO"
		},
		{
			"productId": 8076094701786,
			"variantId": 44137993437402,
			"sku": "LINLOV/F150X220/ROS"
		},
		{
			"productId": 8076094701786,
			"variantId": 44137993470170,
			"sku": "LINLOV/F220X220/ROS"
		},
		{
			"productId": 8076094701786,
			"variantId": 44137993502938,
			"sku": "LINLOV/F240X220/ROS"
		},
		{
			"productId": 8076094701786,
			"variantId": 44137993535706,
			"sku": "LINLOV/F260X240/ROS"
		},
		{
			"productId": 8076099027162,
			"variantId": 44138034888922,
			"sku": "PANAL2/F150X260/BCO"
		},
		{
			"productId": 8076099027162,
			"variantId": 44138034921690,
			"sku": "PANAL2/F220X260/BCO"
		},
		{
			"productId": 8076099027162,
			"variantId": 44138034954458,
			"sku": "PANAL2/F240X260/BCO"
		},
		{
			"productId": 8076099027162,
			"variantId": 44138034987226,
			"sku": "PANAL2/F260X260/BCO"
		},
		{
			"productId": 8076078022874,
			"variantId": 44138075488474,
			"sku": "GAPAT/150X260/ROS"
		},
		{
			"productId": 8076078022874,
			"variantId": 44138075521242,
			"sku": "GAPAT/200X260/ROS"
		},
		{
			"productId": 8076078022874,
			"variantId": 44138075554010,
			"sku": "GAPAT/220X260/ROS"
		},
		{
			"productId": 8076078022874,
			"variantId": 44138075586778,
			"sku": "GAPAT/240X260/ROS"
		},
		{
			"productId": 8076078022874,
			"variantId": 44138075619546,
			"sku": "GAPAT/260X260/ROS"
		},
		{
			"productId": 8076085526746,
			"variantId": 44138072735962,
			"sku": "VAPAT/150X260/AZU"
		},
		{
			"productId": 8076085526746,
			"variantId": 44138072768730,
			"sku": "VAPAT/200X260/AZU"
		},
		{
			"productId": 8076085526746,
			"variantId": 44138072801498,
			"sku": "VAPAT/220X260/AZU"
		},
		{
			"productId": 8076085526746,
			"variantId": 44138072834266,
			"sku": "VAPAT/240X260/AZU"
		},
		{
			"productId": 8076085526746,
			"variantId": 44138072867034,
			"sku": "VAPAT/260X260/AZU"
		},
		{
			"productId": 8076078907610,
			"variantId": 44138071359706,
			"sku": "JERCORA/150X220/AZU"
		},
		{
			"productId": 8076078907610,
			"variantId": 44138071392474,
			"sku": "JERCORA/200X220/AZU"
		},
		{
			"productId": 8076078907610,
			"variantId": 44138071425242,
			"sku": "JERCORA/220X220/AZU"
		},
		{
			"productId": 8076078907610,
			"variantId": 44138071458010,
			"sku": "JERCORA/240X220/AZU"
		},
		{
			"productId": 8076078907610,
			"variantId": 44138071490778,
			"sku": "JERCORA/260X240/AZU"
		},
		{
			"productId": 8076099322074,
			"variantId": 44138063626458,
			"sku": "PULIS/150X220/GRI"
		},
		{
			"productId": 8076099322074,
			"variantId": 44138063659226,
			"sku": "PULIS/200X220/GRI"
		},
		{
			"productId": 8076099322074,
			"variantId": 44138063691994,
			"sku": "PULIS/220X220/GRI"
		},
		{
			"productId": 8076099322074,
			"variantId": 44138063724762,
			"sku": "PULIS/240X220/GRI"
		},
		{
			"productId": 8076099322074,
			"variantId": 44138063757530,
			"sku": "PULIS/260X240/GRI"
		},
		{
			"productId": 8076099453146,
			"variantId": 44138097672410,
			"sku": "PULIS2/150X220/GRI"
		},
		{
			"productId": 8076099453146,
			"variantId": 44138097705178,
			"sku": "PULIS2/200X220/GRI"
		},
		{
			"productId": 8076099453146,
			"variantId": 44138097737946,
			"sku": "PULIS2/220X220/GRI"
		},
		{
			"productId": 8076099453146,
			"variantId": 44138097770714,
			"sku": "PULIS2/240X220/GRI"
		},
		{
			"productId": 8076099453146,
			"variantId": 44138097803482,
			"sku": "PULIS2/260X240/GRI"
		},
		{
			"productId": 8076085133530,
			"variantId": 44138076373210,
			"sku": "VALU/150X220/AZU"
		},
		{
			"productId": 8076085133530,
			"variantId": 44138076405978,
			"sku": "VALU/220X220/AZU"
		},
		{
			"productId": 8076085133530,
			"variantId": 44138076438746,
			"sku": "VALU/240X220/AZU"
		},
		{
			"productId": 8076085133530,
			"variantId": 44138076471514,
			"sku": "VALU/260X240/AZU"
		},
		{
			"productId": 8076084609242,
			"variantId": 44138067329242,
			"sku": "VAI/150X220/BCO"
		},
		{
			"productId": 8076084609242,
			"variantId": 44138067362010,
			"sku": "VAI/200X220/BCO"
		},
		{
			"productId": 8076084609242,
			"variantId": 44138067394778,
			"sku": "VAI/220X220/BCO"
		},
		{
			"productId": 8076084609242,
			"variantId": 44138067427546,
			"sku": "VAI/240X220/BCO"
		},
		{
			"productId": 8076084609242,
			"variantId": 44138067460314,
			"sku": "VAI/260X240/BCO"
		},
		{
			"productId": 8076082020570,
			"variantId": 44138068836570,
			"sku": "PRALIF/150X220/VER"
		},
		{
			"productId": 8076082020570,
			"variantId": 44138068869338,
			"sku": "PRALIF/200X220/VER"
		},
		{
			"productId": 8076082020570,
			"variantId": 44138068902106,
			"sku": "PRALIF/220X220/VER"
		},
		{
			"productId": 8076082020570,
			"variantId": 44138068934874,
			"sku": "PRALIF/240X220/VER"
		},
		{
			"productId": 8076082020570,
			"variantId": 44138068967642,
			"sku": "PRALIF/260X240/VER"
		},
		{
			"productId": 8150094676186,
			"variantId": 44315921776858,
			"sku": "VAC/120X180/AGM"
		},
		{
			"productId": 8150094708954,
			"variantId": 44315921809626,
			"sku": "VAC/120X180/AMA"
		},
		{
			"productId": 8150094643418,
			"variantId": 44315921711322,
			"sku": "SOFPLA/120X180/AZU"
		},
		{
			"productId": 8076083658970,
			"variantId": 44138091282650,
			"sku": "SOFPLAX/160X220/CRU"
		},
		{
			"productId": 8076083658970,
			"variantId": 44138091315418,
			"sku": "SOFPLAX/240X220/CRU"
		},
		{
			"productId": 8076104073434,
			"variantId": 44138093478106,
			"sku": "APO/160X220/ROS"
		},
		{
			"productId": 8076104073434,
			"variantId": 44138093510874,
			"sku": "APO/240X220/ROS"
		},
		{
			"productId": 8076106957018,
			"variantId": 44138094231770,
			"sku": "FLIC/160X220/GRI"
		},
		{
			"productId": 8076106957018,
			"variantId": 44138094264538,
			"sku": "FLIC/240X220/GRI"
		},
		{
			"productId": 8076104040666,
			"variantId": 44138094526682,
			"sku": "APO/160X220/NAT"
		},
		{
			"productId": 8076104040666,
			"variantId": 44138094559450,
			"sku": "APO/240X220/NAT"
		},
		{
			"productId": 8076107088090,
			"variantId": 44138090496218,
			"sku": "FLORFLI/160X220/MAR"
		},
		{
			"productId": 8076107088090,
			"variantId": 44138090528986,
			"sku": "FLORFLI/240X220/MAR"
		},
		{
			"productId": 8076086378714,
			"variantId": 44138029646042,
			"sku": "ANFUN/50CMS/BCO"
		},
		{
			"productId": 8076086378714,
			"variantId": 44138029678810,
			"sku": "ANFUN/N70CMS/BCO"
		},
		{
			"productId": 8076086378714,
			"variantId": 44138029711578,
			"sku": "ANFUN/N80CMS/BCO"
		},
		{
			"productId": 8076086378714,
			"variantId": 44138029744346,
			"sku": "ANFUN/N90CMS/BCO"
		},
		{
			"productId": 8076086870234,
			"variantId": 44138039836890,
			"sku": "BAMBU/50CMS/BCO"
		},
		{
			"productId": 8076086870234,
			"variantId": 44138039869658,
			"sku": "BAMBU/N70CMS/BCO"
		},
		{
			"productId": 8076086870234,
			"variantId": 44138039902426,
			"sku": "BAMBU/N90CMS/BCO"
		},
		{
			"productId": 8076086870234,
			"variantId": 44138039935194,
			"sku": "BAMBU/105CMS/BCO"
		},
		{
			"productId": 8076090835162,
			"variantId": 44138038198490,
			"sku": "CAIRO/N90X190/BCO"
		},
		{
			"productId": 8076090835162,
			"variantId": 44138038231258,
			"sku": "CAIRO/N135X190/BCO"
		},
		{
			"productId": 8076090835162,
			"variantId": 44138038264026,
			"sku": "CAIRO/N150X190/BCO"
		},
		{
			"productId": 8076090835162,
			"variantId": 44138038296794,
			"sku": "CAIRO/N180X200/BCO"
		},
		{
			"productId": 8076098437338,
			"variantId": 44138018406618,
			"sku": "OMAPU/N90X190/BCO"
		},
		{
			"productId": 8076098437338,
			"variantId": 44138018439386,
			"sku": "OMAPU/N105X190/BCO"
		},
		{
			"productId": 8076098437338,
			"variantId": 44138018472154,
			"sku": "OMAPU/N135X190/BCO"
		},
		{
			"productId": 8076098437338,
			"variantId": 44138018504922,
			"sku": "OMAPU/N150X190/BCO"
		},
		{
			"productId": 8076098437338,
			"variantId": 44138018537690,
			"sku": "OMAPU/N180X200/BCO"
		},
		{
			"productId": 8076098437338,
			"variantId": 44138018570458,
			"sku": "OMAPU/N80X190/BCO"
		},
		{
			"productId": 8076098437338,
			"variantId": 44138018603226,
			"sku": "OMAPU/N160X200/BCO"
		},
		{
			"productId": 8076086903002,
			"variantId": 44138027188442,
			"sku": "BAMBU/N90X190/BCO"
		},
		{
			"productId": 8076086903002,
			"variantId": 44138027221210,
			"sku": "BAMBU/N135X190/BCO"
		},
		{
			"productId": 8076086903002,
			"variantId": 44138027253978,
			"sku": "BAMBU/N150X190/BCO"
		},
		{
			"productId": 8076086903002,
			"variantId": 44138027286746,
			"sku": "BAMBU/N180X200/BCO"
		},
		{
			"productId": 8076086903002,
			"variantId": 44138027319514,
			"sku": "BAMBU/200X200/BCO"
		},
		{
			"productId": 8076086903002,
			"variantId": 44138027352282,
			"sku": "BAMBU/160X200/BCO"
		},
		{
			"productId": 8076086411482,
			"variantId": 44137995239642,
			"sku": "ANPROT/N90/UNI"
		},
		{
			"productId": 8076086411482,
			"variantId": 44137995272410,
			"sku": "ANPROT/N135/UNI"
		},
		{
			"productId": 8076086411482,
			"variantId": 44137995305178,
			"sku": "ANPROT/N150/UNI"
		},
		{
			"productId": 8076086411482,
			"variantId": 44137995337946,
			"sku": "ANPROT/N180/UNI"
		},
		{
			"productId": 8076086477018,
			"variantId": 44138025025754,
			"sku": "ANRENO/N150X220/UNI"
		},
		{
			"productId": 8076086477018,
			"variantId": 44138025058522,
			"sku": "ANRENO/N220X220/UNI"
		},
		{
			"productId": 8076086477018,
			"variantId": 44138025091290,
			"sku": "ANRENO/N240X220/UNI"
		},
		{
			"productId": 8076086477018,
			"variantId": 44138025124058,
			"sku": "ANRENO/N260X240/UNI"
		},
		{
			"productId": 8076086935770,
			"variantId": 44138053861594,
			"sku": "BAMBU/N150X220/UNI"
		},
		{
			"productId": 8076086935770,
			"variantId": 44138053894362,
			"sku": "BAMBU/N220X220/UNI"
		},
		{
			"productId": 8076086935770,
			"variantId": 44138053927130,
			"sku": "BAMBU/N240X220/UNI"
		},
		{
			"productId": 8076086935770,
			"variantId": 44138053959898,
			"sku": "BAMBU/N260X240/UNI"
		},
		{
			"productId": 8076086935770,
			"variantId": 44138053992666,
			"sku": "BAMBU/290X240/BCO"
		},
		{
			"productId": 8076087263450,
			"variantId": 44137995534554,
			"sku": "BASE125/N150X220/BCO"
		},
		{
			"productId": 8076087263450,
			"variantId": 44137995567322,
			"sku": "BASE125/N220X200/BCO"
		},
		{
			"productId": 8076087263450,
			"variantId": 44137995600090,
			"sku": "BASE125/N240X220/BCO"
		},
		{
			"productId": 8076087263450,
			"variantId": 44137995632858,
			"sku": "BASE125/N260X240/BCO"
		},
		{
			"productId": 8076087296218,
			"variantId": 44138021748954,
			"sku": "BASE400/N150X220/BCO"
		},
		{
			"productId": 8076087296218,
			"variantId": 44138021781722,
			"sku": "BASE400/N220X200/BCO"
		},
		{
			"productId": 8076087296218,
			"variantId": 44138021814490,
			"sku": "BASE400/N240X220/BCO"
		},
		{
			"productId": 8076087296218,
			"variantId": 44138021847258,
			"sku": "BASE400/N260X240/BCO"
		},
		{
			"productId": 8076096340186,
			"variantId": 44138054353114,
			"sku": "MINIDOT/S160X280/BCO"
		},
		{
			"productId": 8076096340186,
			"variantId": 44138054385882,
			"sku": "MINIDOT/S210X280/BCO"
		},
		{
			"productId": 8076096340186,
			"variantId": 44138054418650,
			"sku": "MINIDOT/S240X280/BCO"
		},
		{
			"productId": 8076096340186,
			"variantId": 44138054451418,
			"sku": "MINIDOT/S270X290/BCO"
		},
		{
			"productId": 8076102009050,
			"variantId": 44138047701210,
			"sku": "TEXBROD/160X270/BCO"
		},
		{
			"productId": 8076102009050,
			"variantId": 44138047733978,
			"sku": "TEXBROD/210X270/BCO"
		},
		{
			"productId": 8076102009050,
			"variantId": 44138047766746,
			"sku": "TEXBROD/240X270/BCO"
		},
		{
			"productId": 8076102009050,
			"variantId": 44138047799514,
			"sku": "TEXBROD/270X270/BCO"
		},
		{
			"productId": 8076098601178,
			"variantId": 44138044326106,
			"sku": "OXFI/S160X270/BCO"
		},
		{
			"productId": 8076098601178,
			"variantId": 44138044358874,
			"sku": "OXFI/S210X270/BCO"
		},
		{
			"productId": 8076098601178,
			"variantId": 44138044391642,
			"sku": "OXFI/S240X270/BCO"
		},
		{
			"productId": 8076098601178,
			"variantId": 44138044424410,
			"sku": "OXFI/S270X270/BCO"
		},
		{
			"productId": 8150094217434,
			"variantId": 44315925709018,
			"sku": "FERDA/160X270/VER"
		},
		{
			"productId": 8150094217434,
			"variantId": 44315925741786,
			"sku": "FERDA/210X270/VER"
		},
		{
			"productId": 8150094217434,
			"variantId": 44315925774554,
			"sku": "FERDA/240X270/VER"
		},
		{
			"productId": 8150094217434,
			"variantId": 44315925807322,
			"sku": "FERDA/270X270/VER"
		},
		{
			"productId": 8076077695194,
			"variantId": 44138077716698,
			"sku": "GAFRA/160X270/GRI"
		},
		{
			"productId": 8076077695194,
			"variantId": 44138077749466,
			"sku": "GAFRA/210X270/GRI"
		},
		{
			"productId": 8076077695194,
			"variantId": 44138077782234,
			"sku": "GAFRA/240X270/GRI"
		},
		{
			"productId": 8076077695194,
			"variantId": 44138077815002,
			"sku": "GAFRA/270X270/GRI"
		},
		{
			"productId": 8150094250202,
			"variantId": 44315922170074,
			"sku": "LARI/160X270/AZU"
		},
		{
			"productId": 8150094250202,
			"variantId": 44315922202842,
			"sku": "LARI/210X270/AZU"
		},
		{
			"productId": 8150094250202,
			"variantId": 44315922235610,
			"sku": "LARI/240X270/AZU"
		},
		{
			"productId": 8150094250202,
			"variantId": 44315922268378,
			"sku": "LARI/270X270/AZU"
		},
		{
			"productId": 8076088869082,
			"variantId": 44137996812506,
			"sku": "BESTO/160X275/AMA"
		},
		{
			"productId": 8076088869082,
			"variantId": 44137996845274,
			"sku": "BESTO/210X275/AMA"
		},
		{
			"productId": 8076088869082,
			"variantId": 44137996878042,
			"sku": "BESTO/240X275/AMA"
		},
		{
			"productId": 8076088869082,
			"variantId": 44137996910810,
			"sku": "BESTO/270X275/AMA"
		},
		{
			"productId": 8076088901850,
			"variantId": 44138051698906,
			"sku": "BESTO/160X275/AQU"
		},
		{
			"productId": 8076088901850,
			"variantId": 44138051731674,
			"sku": "BESTO/210X275/AQU"
		},
		{
			"productId": 8076088901850,
			"variantId": 44138051764442,
			"sku": "BESTO/240X275/AQU"
		},
		{
			"productId": 8076088901850,
			"variantId": 44138051797210,
			"sku": "BESTO/270X275/AQU"
		},
		{
			"productId": 8076088934618,
			"variantId": 44138025812186,
			"sku": "BESTO/160X275/AZD"
		},
		{
			"productId": 8076088934618,
			"variantId": 44138025844954,
			"sku": "BESTO/210X275/AZD"
		},
		{
			"productId": 8076088934618,
			"variantId": 44138025877722,
			"sku": "BESTO/240X275/AZD"
		},
		{
			"productId": 8076088934618,
			"variantId": 44138025910490,
			"sku": "BESTO/270X275/AZD"
		},
		{
			"productId": 8076088967386,
			"variantId": 44137997304026,
			"sku": "BESTO/160X275/AZU"
		},
		{
			"productId": 8076088967386,
			"variantId": 44137997336794,
			"sku": "BESTO/210X275/AZU"
		},
		{
			"productId": 8076088967386,
			"variantId": 44137997369562,
			"sku": "BESTO/240X275/AZU"
		},
		{
			"productId": 8076088967386,
			"variantId": 44137997402330,
			"sku": "BESTO/270X275/AZU"
		},
		{
			"productId": 8076089000154,
			"variantId": 44138058219738,
			"sku": "BESTO/160X275/BCO"
		},
		{
			"productId": 8076089000154,
			"variantId": 44138058252506,
			"sku": "BESTO/180X275/BCO"
		},
		{
			"productId": 8076089000154,
			"variantId": 44138058285274,
			"sku": "BESTO/210X275/BCO"
		},
		{
			"productId": 8076089000154,
			"variantId": 44138058318042,
			"sku": "BESTO/240X275/BCO"
		},
		{
			"productId": 8076089000154,
			"variantId": 44138058350810,
			"sku": "BESTO/270X275/BCO"
		},
		{
			"productId": 8076089032922,
			"variantId": 44138032005338,
			"sku": "BESTO/160X275/CEN"
		},
		{
			"productId": 8076089032922,
			"variantId": 44138032038106,
			"sku": "BESTO/210X275/CEN"
		},
		{
			"productId": 8076089032922,
			"variantId": 44138032070874,
			"sku": "BESTO/240X275/CEN"
		},
		{
			"productId": 8076089032922,
			"variantId": 44138032103642,
			"sku": "BESTO/270X275/CEN"
		},
		{
			"productId": 8076089098458,
			"variantId": 44138040164570,
			"sku": "BESTO/160X275/GRZ"
		},
		{
			"productId": 8076089098458,
			"variantId": 44138040197338,
			"sku": "BESTO/210X275/GRZ"
		},
		{
			"productId": 8076089098458,
			"variantId": 44138040230106,
			"sku": "BESTO/240X275/GRZ"
		},
		{
			"productId": 8076089098458,
			"variantId": 44138040262874,
			"sku": "BESTO/270X275/GRZ"
		},
		{
			"productId": 8076089131226,
			"variantId": 44137994780890,
			"sku": "BESTO/160X275/PIE"
		},
		{
			"productId": 8076089131226,
			"variantId": 44137994813658,
			"sku": "BESTO/180X275/PIE"
		},
		{
			"productId": 8076089131226,
			"variantId": 44137994846426,
			"sku": "BESTO/210X275/PIE"
		},
		{
			"productId": 8076089131226,
			"variantId": 44137994879194,
			"sku": "BESTO/240X275/PIE"
		},
		{
			"productId": 8076089131226,
			"variantId": 44137994911962,
			"sku": "BESTO/270X275/PIE"
		},
		{
			"productId": 8076089163994,
			"variantId": 44137997467866,
			"sku": "BESTO/160X275/ROS"
		},
		{
			"productId": 8076089163994,
			"variantId": 44137997500634,
			"sku": "BESTO/210X275/ROS"
		},
		{
			"productId": 8076089163994,
			"variantId": 44137997533402,
			"sku": "BESTO/240X275/ROS"
		},
		{
			"productId": 8076089163994,
			"variantId": 44137997566170,
			"sku": "BESTO/270X275/ROS"
		},
		{
			"productId": 8076089196762,
			"variantId": 44138044129498,
			"sku": "BESTO/160X275/VOS"
		},
		{
			"productId": 8076089196762,
			"variantId": 44138044162266,
			"sku": "BESTO/210X275/VOS"
		},
		{
			"productId": 8076089196762,
			"variantId": 44138044195034,
			"sku": "BESTO/240X275/VOS"
		},
		{
			"productId": 8076089196762,
			"variantId": 44138044227802,
			"sku": "BESTO/270X275/VOS"
		},
		{
			"productId": 8076092309722,
			"variantId": 44138031382746,
			"sku": "CROCHE/160X270/BCO"
		},
		{
			"productId": 8076092309722,
			"variantId": 44138031415514,
			"sku": "CROCHE/210X270/BCO"
		},
		{
			"productId": 8076092309722,
			"variantId": 44138031448282,
			"sku": "CROCHE/240X270/BCO"
		},
		{
			"productId": 8076092309722,
			"variantId": 44138031481050,
			"sku": "CROCHE/270X270/BCO"
		},
		{
			"productId": 8076087689434,
			"variantId": 44138047078618,
			"sku": "BEST2/160X275/BCO"
		},
		{
			"productId": 8076087689434,
			"variantId": 44138047111386,
			"sku": "BEST2/180X275/BCO"
		},
		{
			"productId": 8076087689434,
			"variantId": 44138047144154,
			"sku": "BEST2/210X275/BCO"
		},
		{
			"productId": 8076087689434,
			"variantId": 44138047176922,
			"sku": "BEST2/240X275/BCO"
		},
		{
			"productId": 8076087689434,
			"variantId": 44138047209690,
			"sku": "BEST2/270X275/BCO"
		},
		{
			"productId": 8076087722202,
			"variantId": 44138030825690,
			"sku": "BEST2/160X275/GRZ"
		},
		{
			"productId": 8076087722202,
			"variantId": 44138030858458,
			"sku": "BEST2/210X275/GRZ"
		},
		{
			"productId": 8076087722202,
			"variantId": 44138030891226,
			"sku": "BEST2/240X275/GRZ"
		},
		{
			"productId": 8076087722202,
			"variantId": 44138030923994,
			"sku": "BEST2/270X275/GRZ"
		},
		{
			"productId": 8076087754970,
			"variantId": 44137994518746,
			"sku": "BEST2/160X275/PIE"
		},
		{
			"productId": 8076087754970,
			"variantId": 44137994551514,
			"sku": "BEST2/180X275/PIE"
		},
		{
			"productId": 8076087754970,
			"variantId": 44137994584282,
			"sku": "BEST2/210X275/PIE"
		},
		{
			"productId": 8076087754970,
			"variantId": 44137994617050,
			"sku": "BEST2/240X275/PIE"
		},
		{
			"productId": 8076087754970,
			"variantId": 44137994649818,
			"sku": "BEST2/270X275/PIE"
		},
		{
			"productId": 8076087132378,
			"variantId": 44138022273242,
			"sku": "BANDSAB/S160X270/PIE"
		},
		{
			"productId": 8076087132378,
			"variantId": 44138022306010,
			"sku": "BANDSAB/S210X270/PIE"
		},
		{
			"productId": 8076087132378,
			"variantId": 44138022338778,
			"sku": "BANDSAB/S240X270/PIE"
		},
		{
			"productId": 8076087132378,
			"variantId": 44138022371546,
			"sku": "BANDSAB/S270X270/PIE"
		},
		{
			"productId": 8076104892634,
			"variantId": 44138097082586,
			"sku": "BELTON2/160X270/PIE"
		},
		{
			"productId": 8076104892634,
			"variantId": 44138097115354,
			"sku": "BELTON2/210X270/PIE"
		},
		{
			"productId": 8076104892634,
			"variantId": 44138097148122,
			"sku": "BELTON2/240X270/PIE"
		},
		{
			"productId": 8076104892634,
			"variantId": 44138097180890,
			"sku": "BELTON2/270X270/PIE"
		},
		{
			"productId": 8076085625050,
			"variantId": 44138067198170,
			"sku": "VAPAT/160X270/AZU"
		},
		{
			"productId": 8076085625050,
			"variantId": 44138067230938,
			"sku": "VAPAT/210X270/AZU"
		},
		{
			"productId": 8076085625050,
			"variantId": 44138067263706,
			"sku": "VAPAT/240X270/AZU"
		},
		{
			"productId": 8076085625050,
			"variantId": 44138067296474,
			"sku": "VAPAT/270X270/AZU"
		},
		{
			"productId": 8076099813594,
			"variantId": 44138020995290,
			"sku": "RITZI/160X270/BCO"
		},
		{
			"productId": 8076099813594,
			"variantId": 44138021028058,
			"sku": "RITZI/180X270/BCO"
		},
		{
			"productId": 8076099813594,
			"variantId": 44138021060826,
			"sku": "RITZI/210X270/BCO"
		},
		{
			"productId": 8076099813594,
			"variantId": 44138021093594,
			"sku": "RITZI/240X270/BCO"
		},
		{
			"productId": 8076099813594,
			"variantId": 44138021126362,
			"sku": "RITZI/270X270/BCO"
		},
		{
			"productId": 8076099813594,
			"variantId": 44138021159130,
			"sku": "RITZI/290X270/BCO"
		},
		{
			"productId": 8076099846362,
			"variantId": 44138060808410,
			"sku": "RITZI/160X270/GRI"
		},
		{
			"productId": 8076099846362,
			"variantId": 44138060841178,
			"sku": "RITZI/180X270/GRI"
		},
		{
			"productId": 8076099846362,
			"variantId": 44138060873946,
			"sku": "RITZI/210X270/GRI"
		},
		{
			"productId": 8076099846362,
			"variantId": 44138060906714,
			"sku": "RITZI/240X270/GRI"
		},
		{
			"productId": 8076099846362,
			"variantId": 44138060939482,
			"sku": "RITZI/270X270/GRI"
		},
		{
			"productId": 8076099846362,
			"variantId": 44138060972250,
			"sku": "RITZI/290X270/GRI"
		},
		{
			"productId": 8076084740314,
			"variantId": 44138073424090,
			"sku": "VALCU/160X270/ROJ"
		},
		{
			"productId": 8076084740314,
			"variantId": 44138073456858,
			"sku": "VALCU/210X270/ROJ"
		},
		{
			"productId": 8076084740314,
			"variantId": 44138073489626,
			"sku": "VALCU/240X270/ROJ"
		},
		{
			"productId": 8076084740314,
			"variantId": 44138073522394,
			"sku": "VALCU/270X270/ROJ"
		},
		{
			"productId": 8076082348250,
			"variantId": 44138072211674,
			"sku": "PRANITY/160X270/GRI"
		},
		{
			"productId": 8076082348250,
			"variantId": 44138072244442,
			"sku": "PRANITY/210X270/GRI"
		},
		{
			"productId": 8076082348250,
			"variantId": 44138072277210,
			"sku": "PRANITY/240X270/GRI"
		},
		{
			"productId": 8076082348250,
			"variantId": 44138072309978,
			"sku": "PRANITY/270X270/GRI"
		},
		{
			"productId": 8076082479322,
			"variantId": 44138074144986,
			"sku": "PRAZ/160X270/GRA"
		},
		{
			"productId": 8076082479322,
			"variantId": 44138074177754,
			"sku": "PRAZ/210X270/GRA"
		},
		{
			"productId": 8076082479322,
			"variantId": 44138074210522,
			"sku": "PRAZ/240X270/GRA"
		},
		{
			"productId": 8076082479322,
			"variantId": 44138074243290,
			"sku": "PRAZ/270X270/GRA"
		},
		{
			"productId": 8076081823962,
			"variantId": 44138072342746,
			"sku": "PRA/160X270/VER"
		},
		{
			"productId": 8076081823962,
			"variantId": 44138072375514,
			"sku": "PRA/210X270/VER"
		},
		{
			"productId": 8076081823962,
			"variantId": 44138072408282,
			"sku": "PRA/240X270/VER"
		},
		{
			"productId": 8076081823962,
			"variantId": 44138072441050,
			"sku": "PRA/270X270/VER"
		},
		{
			"productId": 8076082053338,
			"variantId": 44138069819610,
			"sku": "PRALIF/160X270/VER"
		},
		{
			"productId": 8076082053338,
			"variantId": 44138069852378,
			"sku": "PRALIF/210X270/VER"
		},
		{
			"productId": 8076082053338,
			"variantId": 44138069885146,
			"sku": "PRALIF/240X270/VER"
		},
		{
			"productId": 8076082053338,
			"variantId": 44138069917914,
			"sku": "PRALIF/270X270/VER"
		},
		{
			"productId": 8076094341338,
			"variantId": 44138043113690,
			"sku": "LINLOV/160X270/AGM"
		},
		{
			"productId": 8076094341338,
			"variantId": 44138043146458,
			"sku": "LINLOV/210X270/AGM"
		},
		{
			"productId": 8076094341338,
			"variantId": 44138043179226,
			"sku": "LINLOV/240X270/AGM"
		},
		{
			"productId": 8076094341338,
			"variantId": 44138043211994,
			"sku": "LINLOV/270X270/AGM"
		},
		{
			"productId": 8076094374106,
			"variantId": 44138036920538,
			"sku": "LINLOV/160X270/ROS"
		},
		{
			"productId": 8076094374106,
			"variantId": 44138036953306,
			"sku": "LINLOV/210X270/ROS"
		},
		{
			"productId": 8076094374106,
			"variantId": 44138036986074,
			"sku": "LINLOV/240X270/ROS"
		},
		{
			"productId": 8076094374106,
			"variantId": 44138037018842,
			"sku": "LINLOV/270X270/ROS"
		},
		{
			"productId": 8076094767322,
			"variantId": 44138035511514,
			"sku": "LINLOV/S160X270/BCO"
		},
		{
			"productId": 8076094767322,
			"variantId": 44138035544282,
			"sku": "LINLOV/S210X270/BCO"
		},
		{
			"productId": 8076094767322,
			"variantId": 44138035577050,
			"sku": "LINLOV/S240X270/BCO"
		},
		{
			"productId": 8076094767322,
			"variantId": 44138035609818,
			"sku": "LINLOV/S270X270/BCO"
		},
		{
			"productId": 8076094800090,
			"variantId": 44138019913946,
			"sku": "LINLOV/S160X270/BEI"
		},
		{
			"productId": 8076094800090,
			"variantId": 44138019946714,
			"sku": "LINLOV/S210X270/BEI"
		},
		{
			"productId": 8076094800090,
			"variantId": 44138019979482,
			"sku": "LINLOV/S240X270/BEI"
		},
		{
			"productId": 8076094800090,
			"variantId": 44138020012250,
			"sku": "LINLOV/S270X270/BEI"
		},
		{
			"productId": 8076094832858,
			"variantId": 44138097279194,
			"sku": "LINLOV/S160X270/GRI"
		},
		{
			"productId": 8076094832858,
			"variantId": 44138097311962,
			"sku": "LINLOV/S210X270/GRI"
		},
		{
			"productId": 8076094832858,
			"variantId": 44138097344730,
			"sku": "LINLOV/S240X270/GRI"
		},
		{
			"productId": 8076094832858,
			"variantId": 44138097377498,
			"sku": "LINLOV/S270X270/GRI"
		},
		{
			"productId": 8076094898394,
			"variantId": 44138053173466,
			"sku": "LINO/150X220/BCO"
		},
		{
			"productId": 8076094898394,
			"variantId": 44138053206234,
			"sku": "LINO/220X220/BCO"
		},
		{
			"productId": 8076094898394,
			"variantId": 44138053239002,
			"sku": "LINO/240X220/BCO"
		},
		{
			"productId": 8076094898394,
			"variantId": 44138053271770,
			"sku": "LINO/260X240/BCO"
		},
		{
			"productId": 8076094931162,
			"variantId": 44138036429018,
			"sku": "LINO/160X270/BCO"
		},
		{
			"productId": 8076094931162,
			"variantId": 44138036461786,
			"sku": "LINO/210X270/BCO"
		},
		{
			"productId": 8076094931162,
			"variantId": 44138036494554,
			"sku": "LINO/240X270/BCO"
		},
		{
			"productId": 8076094931162,
			"variantId": 44138036527322,
			"sku": "LINO/270X270/BCO"
		},
		{
			"productId": 8076079399130,
			"variantId": 44138076635354,
			"sku": "KING/70X180/PIO"
		},
		{
			"productId": 8076083396826,
			"variantId": 44138073391322,
			"sku": "RUSTCOL/70X220/CAM"
		}

	];

	//CATEGORIAS
	mostrar_productos('cama', 'items1');
	mostrar_productos('bajera', 'items3');
	mostrar_productos('funda', 'items4');
	mostrar_productos('encimera', 'items5');
	mostrar_productos('cuadrante_2', 'items7');
	mostrar_productos('cuadrante_1', 'items8');
	mostrar_productos('almohada-45x110', 'items10');
	mostrar_productos('almohada-45x160', 'items11');

	mostrar_productos('almohada-2-50x85', 'items12');


	//COLOR POR DEFECTO
	//PARTE DE ARRIBA:  ENCIMERA , FUNDA
	//CUADRANTE:  CUANDRANTE_0 , CUANDRANTE_1, CUANDRANTE_2

	const color = 'bco';
	const arriba = 'funda';

	const listado_almohadas = [
		{
			parent: 1,
			cat: 'almohada-45x110',
			defecto: true,
			mensaje: 'Incluye 1 ud. Tamaño ideal para tu ancho de cama'
		},
		{
			parent: 2,
			cat: 'almohada-45x160',
			defecto: true,
			mensaje: 'Incluye 1 ud. Tamaño ideal para tu ancho de cama'
		},
		{
			parent: 2,
			cat: 'almohada-2-50x85',
			defecto: false,
			mensaje: 'Incluye 1 Set de 2 - 50x85cm.'
		},
		{
			parent: 3,
			cat: 'almohada-2-50x85',
			defecto: true,
			mensaje: 'Incluye 1 Set de 2 - 50x85cm.'
		},
		{
			parent: 4,
			cat: 'almohada-2-50x85',
			defecto: true,
			mensaje: 'Incluye 1 Set de 2 - 50x85cm.'
		}

	];








	//GET URL PARAMS
	function get_params(param) {

		var page_uri = window.location.search.substring(1);
		var data_var = page_uri.split('&');

		for (var i = 0; i < data_var.length; i++) {
			var parameterName = data_var[i].split('=');
			if (parameterName[0] == param) {
				return parameterName[1];
			}
		}
	}





	//PRIMERA CARGA
	jQuery(function () {


		if (typeof (get_params('a')) != 'undefined') {

			var arr = [];

			arr.push('#variacion-' + get_params('a'));
			arr.push('.subsquare.almohad.' + get_params('b'));
			arr.push('#variacion-' + get_params('c'));
			arr.push('.subsquare.arriba.' + get_params('d'));
			arr.push('#variacion-' + get_params('e'));
			arr.push('#variacion-' + get_params('f'));
			arr.push('.subsquare.cuadrante.' + get_params('g'));
			arr.push('#variacion-' + get_params('h'));

			if (get_params('i') != '') {
				arr.push('#variacion-' + get_params('i'));
			}

			jQuery.each(arr, function (index, value) {
				jQuery(value).trigger('click');
				buildVariant();
				calcular();
			});

			nexsteps(7);
			jQuery('#modalask .popcancel').trigger('click');

			jQuery('html').animate({
				scrollTop: 0
			}, 1000);

		} else {

			jQuery('.square-item.PID-3').trigger('click');
			jQuery('.arriba.' + arriba).trigger('click');
			jQuery('.subsquare.cuadrante_1').trigger('click');


			jQuery('.variacion.selected').each(function () {
				cliquear(jQuery(this).attr('identificador'));
				buildVariant();
				calcular();
			});

		}



	});






	function dibujar() {

		//IMAGENES
		jQuery('.capa').html('');

		jQuery('.variacion.color-item.selected').each(function () {
			var capa = jQuery(this).attr('capa');
			var base = 'https://cdn.shopify.com/s/files/1/0672/2804/1434/files/';
			var img = jQuery(this).attr('img-data');
			if (img.length != 0) {

				jQuery('.capa.' + capa).html('<img src="' + base + img + '">');

			}
		});


		if (screen.width <= 768) {
			// changeImgWidth();
		} else {

			var padre = jQuery('#img_personalizado').innerWidth();
			var nimage = parseInt((padre * 80) / 100);
			var pright = parseInt((padre - nimage) / 2);

			jQuery('#img_personalizado img').css('margin-left', pright + 'px');
			jQuery('#sharepop').css('margin-left', pright + 'px');
		}
	}



	function mostrar_productos(categoria, zona) {

		// Iterate through shopifyProducts and update listado_productos
		// Merge de arrays : necessitem el product ID de Shopi per fer l'add to cart
		for (const shopifyItem of shopifyProducts) {
			const indices = listado_productos.reduce((acc, item, index) => {
				if (item.sku && item.sku.toLowerCase() === shopifyItem.sku.toLowerCase()) {
					acc.push(index);
				}
				return acc;
			}, []);

			// Update all matching items in listado_productos
			for (const index of indices) {
				listado_productos[index] = { ...listado_productos[index], ...shopifyItem };
			}
		}

		for (var info of listado_productos) {



			var variantId = 'variantId="' + info['variantId'] + '"';
			if (info['cat'] == categoria) {

				var defecto = '';
				if (info['defecto'] === true) {
					var defecto = 'selected';
				}

				var pid = 'PID="PID-' + info['parentid'] + '"';
				var clase = info['clase'] + ' ' + defecto + ' ' + categoria + ' PID-' + info['parentid'] + '"';
				var variacion = 'id="variacion-' + info['id'] + '"';
				var identificador = 'identificador="' + info['id'] + '"';
				var cat = 'cat="' + categoria + '"';
				var sku = 'sku="' + info['sku'] + '"';
				var variantId = 'variantId="' + info['variantId'] + '"';
				var img = 'img-data="' + info['imagen'] + '"';
				var capa = 'capa="' + info['capa'] + '"';
				var parent = info['parentid'];

				var data = '<div id="producto-' + info['id'] + '"' + identificador + ' class="producto" >';

				if (info['modo'] == 'color') {
					data += '<div ' + variacion + identificador + pid + cat + sku + variantId + img + capa + '" class="variacion color-item ' + clase + '"></div>';
				}
				if (info['modo'] == 'square') {
					data += '<div ' + variacion + identificador + cat + sku + variantId + img + capa + ' class="square-item ' + clase + '">' + info['nombre'] + '</div>';
				}

				data += '</div>';

				jQuery('#' + zona).append(data);

			}
		}
	}





	function cliquear(obj) {
		if (typeof obj === undefined) { return; }
		jQuery('#variacion-' + obj).trigger('click');
	}





	jQuery(document).on("click", ".square-item", function (event) {

		event.preventDefault();
		jQuery('.square-item').removeClass('selected');
		jQuery(this).addClass('selected');

		jQuery('.square-item').each(function () {
			if (jQuery(this).hasClass('selected')) {
				jQuery('.PID-' + jQuery(this).attr('identificador')).addClass('active');
				jQuery('.PID-' + jQuery(this).attr('identificador')).removeClass('remove');
			} else {
				jQuery('.PID-' + jQuery(this).attr('identificador')).addClass('remove');
				jQuery('.PID-' + jQuery(this).attr('identificador')).removeClass('active');
			}
		});


		//COLORES
		jQuery('.color-item').removeClass('selected');
		jQuery('.variacion.color-item.' + color + '.active').addClass('selected');


		//ALMOHADAS
		jQuery('.almohad').addClass('invalid');
		jQuery('.almohad, .subsquare.almohad').removeClass('selected');
		jQuery('.itemline.almohadas').css('display', 'none');


		var parent = jQuery('#items1 .selected').attr('identificador');
		for (var info of listado_almohadas) {

			if (parent == info['parent']) {
				jQuery('.almohad.' + info['cat']).removeClass('invalid');

				if (info['defecto'] === true) {
					jQuery('.almohad.' + info['cat']).addClass('selected');
					jQuery('.itemline.almohadas.' + info['cat']).css('display', 'flex');
					// generate_msg(info['mensaje']);
					jQuery('.almohad.' + info['cat']).trigger('click')

				} else {
					jQuery('.' + info['cat'] + '.PID-' + info['parent']).css('display', 'hidden');
					jQuery('.' + info['cat'] + '.PID-' + info['parent']).removeClass('active selected');
				}
			}
		}


		if (jQuery('#items1 .selected').attr('identificador') == 1) {
			jQuery('.subsquare.cuadrante.cuadrante_1').trigger('click');
			jQuery('#items7').css('display', 'flex');
			jQuery('.variacion.color-item.cuadrante_1').removeClass('selected');
			jQuery('.subsquare.cuadrante.cuadrante_2').css('display', 'none');

		} else {
			jQuery('.subsquare.cuadrante.cuadrante_1').trigger('click');
			jQuery('.subsquare.cuadrante.cuadrante_2').css('display', 'block');
		}

		jQuery('.arriba.' + arriba).trigger('click');

	});







	jQuery(document).on("click", ".almohad", function (event) {
		event.preventDefault();

		if (jQuery(this).hasClass('invalid')) {
			// generate_msg('<span class="unactive-grey">Medida no disponible para este ancho de cama</span>');
			return;

		} else {

			var parent = jQuery('#items1 .selected').attr('identificador');
			var msg = '';
			for (var info of listado_almohadas) {

				if (parent == info['parent']) {
					if (info['cat'] == jQuery(this).attr('cat')) {
						msg = info['mensaje'];
					}
				}
			}
			// generate_msg(msg);
		}

		jQuery('.almohad, .itemline.almohadas .variacion, .subsquare.almohad').removeClass('selected');
		jQuery('.itemline.almohadas').css('display', 'none');
		jQuery(this).addClass('selected');

		var parent = jQuery('#items1 .selected').attr('identificador');

		jQuery('.almohad.' + jQuery(this).attr('cat')).addClass('selected');
		jQuery('.itemline.almohadas.' + jQuery(this).attr('cat')).css('display', 'flex');

		var scolor = '.variacion.color-item.' + color + '.' + jQuery(this).attr('cat') + '.PID-' + parent;
		jQuery(scolor).addClass('selected');
		jQuery(scolor).addClass('selected').trigger('click');


		buildVariant();
		calcular();

	});






	jQuery(document).on("click", ".arriba", function (event) {
		event.preventDefault();

		jQuery('#items4, #items5').css('display', 'none');
		jQuery('#items4 .variacion, #items5 .variacion').removeClass('selected');

		jQuery('.subsquare.arriba').removeClass('selected');
		jQuery('.itemline.' + jQuery(this).attr('cat')).css('display', 'flex');
		jQuery('.subsquare.' + jQuery(this).attr('cat')).addClass('selected');

		if (jQuery(this).attr('cat') == 'encimera') {
			jQuery('#items4 .color-item.' + color + '.active').addClass('selected');
		} else {
			jQuery('#items5 .color-item.' + color + '.active').addClass('selected');
		}

		dibujar();
		buildVariant();
		calcular();
	});






	jQuery(document).on("click", ".cuadrante", function (event) {
		event.preventDefault();

		jQuery('#items7, #items8').css('display', 'none');
		jQuery('.subsquare.cuadrante').removeClass('selected');
		jQuery('.itemline.' + jQuery(this).attr('cat')).css('display', 'flex');
		jQuery('.subsquare.' + jQuery(this).attr('cat')).addClass('selected');

		var parent = jQuery('#items1 .selected').attr('identificador');


		jQuery('.variacion.color-item.cuadrante_1').removeClass('selected');
		jQuery('.variacion.color-item.cuadrante_2').removeClass('selected');

		if (jQuery(this).attr('cat') == 'cuadrante_0') {
			jQuery('.variacion.color-item.cuadrante_1, .variacion.color-item.cuadrante_2').removeClass('selected');
			jQuery('#desglose .current.cuadrante').html('Nada');
		}

		if (jQuery(this).attr('cat') == 'cuadrante_1') {
			jQuery('#items7').css('display', 'flex');
			jQuery('.variacion.color-item.cuadrante_2.' + color + '.active').addClass('selected').trigger('click');

		}


		if (jQuery(this).attr('cat') == 'cuadrante_2') {
			jQuery('#items7, #items8').css('display', 'flex');
			jQuery('.variacion.color-item.cuadrante_1.' + color + '.active').addClass('selected').trigger('click');
			jQuery('.variacion.color-item.cuadrante_2.' + color + '.active').addClass('selected').trigger('click');
		}



		dibujar();
		buildVariant();
		calcular();

	});







	jQuery(document).on("click", ".variacion", function (event) {
		event.preventDefault();

		var cat = jQuery(this).attr('cat');
		jQuery('.variacion.color-item.' + cat).removeClass('selected');
		jQuery(this).addClass('selected');


		buildVariant();
		calcular();
		dibujar();
	});








	function calcular() {

		var total = 0;
		var totalpremium = 0;

		jQuery('.variacion.selected').each(function () {
			let actual = jQuery(this).attr('identificador');

			var miItem = listado_productos.filter(function (itemBaseDatos) {
				return itemBaseDatos['id'] == actual;
			});

			total = total + miItem[0]['precio'];
			totalpremium = totalpremium + miItem[0]['premium'];

		});

		jQuery('#totalproduct-normal').html(total.toFixed(0).replace('.', ',') + '€');
		jQuery('#totalproduct-premium ').html(totalpremium.toFixed(2).replace('.', ',') + '€<br/><span class="premium">PREMIUM</spam>');

	}








	jQuery(document).on("click", ".cuadrante", function (event) {
		event.preventDefault();

		jQuery('#items7, #items8').css('display', 'none');
		jQuery('.subsquare.cuadrante').removeClass('selected');
		jQuery('.itemline.' + jQuery(this).attr('cat')).css('display', 'flex');
		jQuery('.subsquare.' + jQuery(this).attr('cat')).addClass('selected');

		var parent = jQuery('#items1 .selected').attr('identificador');


		jQuery('.variacion.color-item.cuadrante_1').removeClass('selected');
		jQuery('.variacion.color-item.cuadrante_2').removeClass('selected');

		if (jQuery(this).attr('cat') == 'cuadrante_0') {
			jQuery('.variacion.color-item.cuadrante_1, .variacion.color-item.cuadrante_2').removeClass('selected');
			jQuery('#desglose .current.cuadrante').html('Nada');
		}

		if (jQuery(this).attr('cat') == 'cuadrante_1') {
			jQuery('#items7').css('display', 'flex');
			jQuery('.variacion.color-item.cuadrante_2.' + color + '.active').addClass('selected').trigger('click');

		}


		if (jQuery(this).attr('cat') == 'cuadrante_2') {
			jQuery('#items7, #items8').css('display', 'flex');
			jQuery('.variacion.color-item.cuadrante_1.' + color + '.active').addClass('selected').trigger('click');
			jQuery('.variacion.color-item.cuadrante_2.' + color + '.active').addClass('selected').trigger('click');
		}



		dibujar();
		buildVariant();
		calcular();
		// variantId()

	});

	function buildVariant() {
		var variantArray = [];

		jQuery('.variacion.selected').each(function () {

			let actual = jQuery(this).attr('identificador');
			let variant = jQuery(this).attr('variantId');

			// Filtrar el array por 'variantId'
			var miItemByVariant = listado_productos.filter(function (itemBaseDatos) {
				return itemBaseDatos['variantId'] == variant;
			});

			// Comprobar si hay elementos después de los filtros y añadirlos al array
			if (miItemByVariant.length > 0 && typeof variant !== 'undefined') {
				variantArray.push(miItemByVariant[0]);
			}

			// Limpiar el contenido actual de #variantId
			jQuery('#variantId').empty();

			// Añadir inputs al elemento con id 'variantId' para cada elemento en variantArray
			variantArray.forEach(function (item) {
				var inputElement = '<input class="hidden" type="text" value="' + item.variantId + '">';
				jQuery('#variantId').append(inputElement);
			});
		});

	}


	jQuery(document).on("click", ".variacion", function (event) {
		event.preventDefault();


		var colores = new Array();
		colores["ama"] = 'Amarillo';
		colores["bco"] = 'Blanco';
		colores["cen"] = 'Ceniza';
		colores["azd"] = 'Azul oscuro';
		colores["azu"] = 'Azul';
		colores["lic"] = 'Lila';
		colores["aqu"] = 'Agua marina';
		colores["ros"] = 'Rosa';
		colores["gre"] = 'Verde oscuro';
		colores["grz"] = 'Gris ceniza oscuro';
		colores["cen"] = 'Gris ceniza';
		colores["grc"] = 'Gris claro';
		colores["pie"] = 'Gris piedra';
		colores["piedoble"] = 'Gris piedra';
		colores["azudoble"] = 'Azul';
		colores["grcdoble"] = 'Gris ceniza';


		jQuery('#desglose .current.cama').html(jQuery('.square-item.selected').html());
		jQuery('#desglose .current.almohada').html(jQuery('.subsquare.almohad.selected').html());

		var nsabana = jQuery('.variacion.color-item.bajera.selected').attr('identificador');
		let nsabana_color = '';
		jQuery('.variacion.color-item.bajera.selected').each(function () {
			var miItem = listado_productos.filter(function (itemBaseDatos) {
				return itemBaseDatos['id'] == nsabana;
			});

			nsabana_color = miItem[0]['clase'];
		});
		jQuery('#desglose .current.sabana').html(colores[nsabana_color]);



		var nencimera = jQuery('.topper .variacion.color-item.selected').attr('identificador');
		let nencimera_color = '';
		jQuery('.topper .variacion.color-item.selected').each(function () {
			var miItem = listado_productos.filter(function (itemBaseDatos) {
				return itemBaseDatos['id'] == nencimera;
			});

			nencimera_color = miItem[0]['clase'];
		});

		var currcat = jQuery('.subsquare.arriba.selected').attr('cat');
		if (currcat == 'encimera') {
			var ncurrcat = '( F. Nórdica )';
		}

		if (currcat == 'funda') {
			var ncurrcat = '( Sábana )';
		}

		jQuery('#desglose .current.encimera').html(ncurrcat + ' ' + colores[nencimera_color]);



		var nfunda = jQuery('.itemline.almohadas .color-item.selected').attr('identificador');
		let nfunda_color = '';
		jQuery('.variacion.color-item.selected').each(function () {
			var miItem = listado_productos.filter(function (itemBaseDatos) {
				return itemBaseDatos['id'] == nfunda;
			});

			nfunda_color = miItem[0]['clase'];
		});

		jQuery('#desglose .current.funda').html(colores[nfunda_color]);




		var cuadrante_a = jQuery('#items7 .color-item.selected').attr('identificador');
		let cuadrante_a_color = '';
		jQuery('#items7 .color-item.selected').each(function () {
			var miItem = listado_productos.filter(function (itemBaseDatos) {
				return itemBaseDatos['id'] == cuadrante_a;
			});

			cuadrante_a_color = miItem[0]['clase'];
		});


		var cuadrante_b = jQuery('#items8 .color-item.selected').attr('identificador');
		let cuadrante_b_color = '';
		jQuery('#items8 .color-item.selected').each(function () {
			var miItem = listado_productos.filter(function (itemBaseDatos) {
				return itemBaseDatos['id'] == cuadrante_b;
			});

			cuadrante_b_color = miItem[0]['clase'];
		});



		if (cuadrante_a_color && !cuadrante_b_color) {
			var desglose_cuadrantes = '( 1 ) ' + colores[cuadrante_a_color];
		}

		if (!cuadrante_a_color && cuadrante_b_color) {
			var desglose_cuadrantes = '( 1 ) ' + colores[cuadrante_b_color];
		}

		if (cuadrante_a_color && cuadrante_b_color) {
			var desglose_cuadrantes = '( 2 ) ' + colores[cuadrante_a_color] + ' ' + colores[cuadrante_b_color];
		}

		jQuery('#desglose .current.cuadrante').html(desglose_cuadrantes);


		let psku = '';
		let pqty = '';
		var vcart = '';
		var url_redirect = 'https://www.textura-interiors.com/checkout/cart';
		var quickcart = 'https://www.textura-interiors.com//quickaddtocart';


		buildVariant();

		vcart += '<form id="scart" action=""​>';
		vcart += '<input id="skus" type="hidden" name="skus" value="" />';
		vcart += '<input id="skus" type="hidden" name="skus" value="" />';
		vcart += '<input id="qtys" type="hidden" name="qtys" value="" />';
		vcart += '<input type="hidden" name="url_redirect" id="url_redirect" value="https://www.textura-interiors.com/checkout/cart"/>';
		vcart += '<button type="submit" class="btn btn-primary botones">Ir al carrito</button>';
		vcart += '</form>';

		jQuery('#carrito').html(vcart);

		psku = psku.substring(0, psku.length - 1);
		pqty = pqty.substring(0, pqty.length - 1);

		jQuery('#scart #skus').val(psku);
		jQuery('#scart #qtys').val(pqty);
		jQuery('#scart').attr('action', quickcart + '?skus=' + psku + '&qtys=' + pqty + '&redirect_url=' + url_redirect);

	});





	jQuery(document).on("click", "#nbolsa", function (event) {
		event.preventDefault();

		jQuery('#scart').trigger('submit');

	});


});